import { useState, useRef, useEffect } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";

const SB_URL = "https://dsjlslknazpjispvyjki.supabase.co";
const SB_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzamxzbGtuYXpwamlzcHZ5amtpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcxODM2NzEsImV4cCI6MjA5Mjc1OTY3MX0.cKW5AzGo6mY6UOzEJd4bWR9vXM073do0UHH2PaGwAG8";
const SB_H = {"apikey":SB_KEY,"Authorization":`Bearer ${SB_KEY}`,"Content-Type":"application/json"};
const SB = (path,opts={}) => {
  const {headers:extraHeaders={}, ...restOpts} = opts;
  return fetch(`${SB_URL}/rest/v1/${path}`,{...restOpts,headers:{...SB_H,...extraHeaders}});
};

const WA = "5492324679412";
const IG = "https://www.instagram.com/tmcagro";
const YT = "https://www.youtube.com/@tmcagro";
const FOTO = "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1400&q=80";

const DEFAULT_BANNERS = [
  { img:"", link:"" },
  { img:"", link:"" },
  { img:"", link:"" },
];

const ytId = url => {
  if(!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?\s]+)/);
  return m ? m[1] : null;
};

const APP_VERSION = "v5.18";

// v4: sesión persistente — si el usuario no vuelve a entrar en más de 10 días
// le vuelve a pedir la clave; si entra dentro de esos 10 días, el vencimiento
// se corre 10 días más (ventana móvil, no fija desde el primer login).
const SESSION_KEY = "tmc_sess";
const SESSION_DAYS = 10;
const saveSession = u => { try{ localStorage.setItem(SESSION_KEY, JSON.stringify({u, loginAt:Date.now()})); }catch{} };
const loadSession = () => {
  try{
    const raw = JSON.parse(localStorage.getItem(SESSION_KEY)||"null");
    if(!raw || !raw.u) return null;
    if(Date.now() - (raw.loginAt||0) > SESSION_DAYS*24*60*60*1000){ localStorage.removeItem(SESSION_KEY); return null; }
    return raw.u;
  }catch{ return null; }
};
const clearSession = () => { try{ localStorage.removeItem(SESSION_KEY); }catch{} };
// Antes ponía cada palabra en Mayúscula (Título De Categoría); ahora solo la
// primera letra del nombre, el resto en minúscula (pedido de Marcos 19/08).
const normCat = s => {
  if(!s) return "";
  const t = s.trim().toLowerCase();
  return t.charAt(0).toUpperCase()+t.slice(1);
};
const hashPwd = async pwd => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(pwd));
  return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,"0")).join("");
};
const normSearch = s => s ? s.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase() : "";
const slugify = s => (s||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g,"-");
// v4.37: "condiciones" es una tabla de texto libre (id TEXT, sin default \u2014
// ver diagnostico_condiciones_id.sql) heredada de Rural, no genera su propio
// id como s\u00ed hacen las tablas nuevas del cat\u00e1logo. Hay que mandarlo nosotros
// al insertar. crypto.randomUUID() est\u00e1 disponible en todo navegador moderno
// en HTTPS; el fallback de abajo es solo por si alguna vez corre en un
// contexto sin eso (ej. http:// en desarrollo local).
const genId = () => (typeof crypto!=="undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,10)}`;

// Validaciones del registro de clientes \u2014 antes no chequeaban nada, se pod\u00eda
// crear una cuenta con "asd" como email o cualquier cosa como CUIT.
const validarEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email||"").trim());
const validarDNI = dni => { const d = String(dni||"").replace(/\D/g,""); return d.length>=7 && d.length<=8; };
// Algoritmo oficial de d\u00edgito verificador del CUIT (AFIP): valida que los 11
// d\u00edgitos sean matem\u00e1ticamente consistentes entre s\u00ed, no solo la cantidad.
const validarCUIT = cuit => {
  const d = String(cuit||"").replace(/\D/g,"");
  if(d.length!==11) return false;
  const mult = [5,4,3,2,7,6,5,4,3,2];
  const n = d.split("").map(Number);
  const suma = n.slice(0,10).reduce((s,x,i)=>s+x*mult[i],0);
  let resto = 11 - (suma % 11);
  if(resto===11) resto = 0;
  if(resto===10) return false;
  return resto === n[10];
};
// v4: URLs por pantalla, para poder compartir un link directo y que ande el
// atr\u00e1s/adelante del navegador.
const SCREEN_PATH = { admin:"/admin", tablero:"/tablero", clientes:"/clientes", login:"/ingresar", register:"/registro", terminos:"/condiciones-de-uso" };

const DEFAULT_LISTA_MAP = {
  publico:  { f:"pp", lbl:"Precio Público" },
  lista1:   { f:"p1", lbl:"Lista 1 - Distribuidor" },
  especial: { f:"pe", lbl:"Lista 2 - Especial" },
  lista2:   { f:"p2", lbl:"Lista 3 - Comercio" },
};

const INIT_USERS = [
  {id:1,u:"admin", p:"d6aa7749ff88903b983b9535a4a0bde0966c240dbdd7f1d5d3e6c0c36809d209", rol:"admin", lista:"lista1", nom:"Administrador"},

];

const SAMPLE = [];
const ALS={code:"cod",sku:"cod",ref:"cod",codigo:"cod",nombre:"nom",name:"nom",producto:"nom",descripcion:"desc",description:"desc",categoria:"cat",category:"cat",linea:"cat",marca:"marca",brand:"marca",iva:"iva",moneda:"mon",currency:"mon",precio_publico:"pp",precio_lista1:"p1",precio_especial:"pe",precio_lista2:"p2",image:"img",imagen:"img",img2:"img2",img3:"img3",img4:"img4",imagen2:"img2",imagen3:"img3",imagen4:"img4",video:"video",videos:"video",youtube:"video"};
const nk=k=>{ const c=k.toLowerCase().trim().replace(/\s+/g,"_"); return ALS[c]||c; };
const groupBy=(arr,k)=>arr.reduce((a,x)=>{const g=x[k]||"General";if(!a[g])a[g]=[];a[g].push(x);return a;},{});

const NO_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23f0f0ee'/%3E%3Ctext x='100' y='114' font-family='Arial, sans-serif' font-size='38' font-weight='800' letter-spacing='2' fill='%23116735' text-anchor='middle'%3ETMC%3C/text%3E%3C/svg%3E";
// Isotipo TMC.agro vectorial (extraído del sitio de referencia tmcagro.com).
// A diferencia del logo viejo (PNG en caja verde), este ya viene en blanco +
// verde menta y funciona directo sobre cualquier fondo oscuro, sin caja.
const TmcLogo = ({h=32}) => (
  <svg height={h} viewBox="0 0 454 107" fill="none" style={{display:"block"}} aria-label="TMC.agro">
    <path fillRule="evenodd" clipRule="evenodd" d="M138.445 23.9541C142.803 21.9738 148.475 21 155.587 21C173.594 21 183.092 27.3805 184.018 41.7487C184.037 42.047 183.799 42.3023 183.5 42.3023H167.176C166.917 42.3023 166.698 42.1115 166.648 41.8569C165.841 37.7465 162.506 35.6913 155.587 35.6913C145.557 35.6913 143.864 40.0319 143.864 44.9735C143.864 49.9819 145.622 54.3892 155.587 54.3892C162.509 54.3892 165.844 52.2698 166.649 48.0911C166.698 47.836 166.917 47.6446 167.177 47.6446H183.5C183.799 47.6446 184.037 47.8999 184.018 48.1981C183.095 62.6341 173.66 69.0805 155.587 69.0805C148.475 69.0805 142.803 68.0983 138.445 66.1042V23.9541ZM68.6244 36.3598H80.4896C80.7785 36.3598 81.0127 36.1256 81.0127 35.8367V22.1917C81.0127 21.9028 80.7785 21.6686 80.4896 21.6686H89.1506C89.3448 21.6686 89.523 21.7761 89.6135 21.9479L103.072 47.5012C103.268 47.8736 103.801 47.8736 103.997 47.5012L117.456 21.9479C117.546 21.7761 117.724 21.6686 117.919 21.6686H137.922C138.211 21.6686 138.445 21.9028 138.445 22.1917V23.9541C130.511 27.5591 126.929 34.4997 126.929 44.9735C126.929 55.4903 130.511 62.474 138.445 66.1042V67.8904C138.445 68.1793 138.211 68.4135 137.922 68.4135H122.034C121.745 68.4135 121.511 68.1793 121.511 67.8904V48.1828C121.511 47.6439 120.794 47.4571 120.531 47.9274L109.221 68.1458C109.128 68.3111 108.953 68.4135 108.764 68.4135H98.3053C98.1158 68.4135 97.9412 68.3111 97.8487 68.1458L86.5381 47.9274C86.275 47.4571 85.5585 47.6439 85.5585 48.1828V67.8904C85.5585 68.1793 85.3243 68.4135 85.0354 68.4135H69.1475C68.8586 68.4135 68.6244 68.1793 68.6244 67.8904V36.3598ZM68.6244 36.3598H61.9965C61.7076 36.3598 61.4734 36.5941 61.4734 36.883V67.8904C61.4734 68.1793 61.2392 68.4135 60.9503 68.4135H45.0624C44.7735 68.4135 44.5393 68.1793 44.5393 67.8904V36.883C44.5393 36.5941 44.3051 36.3598 44.0162 36.3598H25.5231C25.2342 36.3598 25 36.1256 25 35.8367V22.1917C25 21.9028 25.2342 21.6686 25.5231 21.6686H69.1475C68.8586 21.6686 68.6244 21.9028 68.6244 22.1917V36.3598ZM261.946 48.2835C261.81 32.344 252.306 26.4972 235.606 26.4972C228.246 26.4972 219.656 27.9579 211.67 30.5549C211.364 30.6546 211.213 30.9984 211.344 31.2928L216.212 42.1693C216.318 42.4059 216.577 42.5348 216.83 42.4793C224.095 40.8865 229.938 40.4182 235.063 40.4182C240.194 40.4182 245.084 40.6046 245.607 44.8529C245.653 45.2303 245.274 45.4974 244.914 45.3739C241.346 44.1497 237.202 43.4808 231.872 43.4808C219.992 43.4808 207.772 46.3345 207.772 57.1929C207.772 66.2415 215.918 69.6521 225.219 69.6521C231.951 69.6521 238.683 68.7029 244.767 64.5119C245.137 64.257 245.653 64.5159 245.653 64.9651V68.4108C245.653 68.7119 245.897 68.956 246.198 68.956H261.401C261.702 68.956 261.946 68.7119 261.946 68.4108V48.2835ZM245.653 54.9591C245.653 55.1746 245.527 55.3701 245.329 55.455C241.267 57.1953 235.462 58.5154 230.107 58.5154C225.966 58.5154 224.065 58.1673 224.065 55.8704C224.065 53.2254 227.324 52.5294 234.859 52.5294C239.303 52.5294 242.709 52.8426 245.249 53.4692C245.489 53.5282 245.653 53.7446 245.653 53.9911V54.9591ZM305.145 27.7385C305.145 27.4374 305.389 27.1933 305.69 27.1933H320.893C321.194 27.1933 321.438 27.4374 321.438 27.7385V63.5965C321.438 80.3016 309.761 86.3572 295.776 86.3572C284.551 86.3572 274.848 84.2743 270.721 83.1928C270.483 83.1303 270.319 82.9146 270.319 82.6681V70.1735C270.319 69.8309 270.628 69.5727 270.964 69.639C271.324 69.7102 271.706 69.7863 272.106 69.8662C277.071 70.8571 284.983 72.4363 292.789 72.4363C300.319 72.4363 304.554 70.685 305.09 61.4907C305.12 60.9735 304.459 60.7176 304.097 61.088C300.516 64.7511 295.077 66.8679 287.63 66.8679C275.071 66.8679 266.042 60.7427 266.042 46.6826C266.042 32.6224 275.071 26.4972 287.63 26.4972C295.093 26.4972 300.538 28.623 304.12 32.3002C304.479 32.6689 305.145 32.4255 305.145 31.9109V27.7385ZM293.74 52.947C302.361 52.947 305.145 51.4157 305.145 46.6826C305.145 41.9495 302.361 40.4182 293.74 40.4182C285.118 40.4182 282.335 41.9495 282.335 46.6826C282.335 51.4157 285.118 52.947 293.74 52.947ZM369.346 27.7856C366.706 27.1258 363.478 26.4972 358.962 26.4972C352.941 26.4972 347.809 28.2646 344.222 32.6765C343.88 33.0969 343.144 32.8665 343.144 32.3246V27.7385C343.144 27.4374 342.9 27.1933 342.599 27.1933H327.396C327.095 27.1933 326.851 27.4374 326.851 27.7385V68.4108C326.851 68.7119 327.095 68.956 327.396 68.956H342.599C342.9 68.956 343.144 68.7119 343.144 68.4108V46.6109C343.144 46.4777 343.194 46.3478 343.283 46.2491C347.953 41.1006 354.199 40.4182 359.912 40.4182C362.719 40.4182 365.585 40.7868 369.074 41.6395C369.42 41.7241 369.756 41.4637 369.756 41.1076V28.3124C369.756 28.0635 369.588 27.8459 369.346 27.7856ZM373.171 48.0747C373.171 63.5269 383.558 69.6521 400.869 69.6521C418.181 69.6521 428.567 63.5269 428.567 48.0747C428.567 32.6224 418.181 26.4972 400.869 26.4972C383.558 26.4972 373.171 32.6224 373.171 48.0747ZM412.274 48.0747C412.274 54.1999 408.133 55.7312 400.869 55.7312C393.605 55.7312 389.464 54.1999 389.464 48.0747C389.464 41.9495 393.605 40.4182 400.869 40.4182C408.133 40.4182 412.274 41.9495 412.274 48.0747ZM189.216 55.0584C188.927 55.0584 188.693 55.2926 188.693 55.5815V69.3083C188.693 69.5972 188.927 69.8314 189.216 69.8314H200.577C200.866 69.8314 201.1 69.5972 201.1 69.3083V55.5815C201.1 55.2926 200.866 55.0584 200.577 55.0584H189.216Z" fill="white"/>
    <rect x="68.6172" y="21.6797" width="12.4074" height="14.773" rx="0.523109" fill="#6FCF97"/>
    <path d="M126.918 44.3852C126.758 31.4178 134.056 25.5086 138.458 24.0039V66.1343C128.532 62.3042 126.518 51.0877 126.918 44.3852Z" fill="#6FCF97"/>
  </svg>
);

const S = `
@font-face{font-family:'MonumentExt';font-weight:800;src:url('/fonts/MonumentExt-800.otf') format('opentype');font-display:swap;}
@font-face{font-family:'MonumentExt';font-weight:300;src:url('/fonts/MonumentExt-300.otf') format('opentype');font-display:swap;}
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');
:root{--bf:'MonumentExt','Montserrat',sans-serif;--mf:'Montserrat',sans-serif;--grn:#116735;--grn-deep:#0d4f27;--grn-acc:#143c23;--mint:#6fcf97;--wht:#f9fffc;--gry:#c0c0c0;--bgd:#1a1a1a;--bdr:rgba(255,255,255,0.08);}
*{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent;}
html,body{font-family:var(--mf);background:#fff;color:var(--wht);overflow-x:hidden;}
button{touch-action:manipulation;}
.cv{min-height:100vh;min-height:100dvh;display:flex;flex-direction:column;position:relative;overflow:hidden;}
.cvbg{position:absolute;inset:0;background-image:url('${FOTO}');background-size:cover;background-position:center;}
.cvov{position:absolute;inset:0;background:rgba(13,20,15,0.78);}
.cvgh{position:absolute;top:0;left:0;right:0;font-family:var(--bf);font-size:clamp(70px,16vw,190px);font-weight:800;font-style:italic;color:rgba(255,255,255,.06);line-height:.9;letter-spacing:-4px;pointer-events:none;white-space:nowrap;overflow:hidden;padding:8px;}
.cvc{position:relative;z-index:2;flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:28px 16px;}
.cvtag{font-family:var(--bf);font-size:12px;font-weight:300;letter-spacing:3px;text-transform:uppercase;color:var(--mint);margin-bottom:14px;}
.cvbar{display:flex;align-items:center;gap:12px;font-family:var(--bf);font-size:13px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.55);margin-top:24px;}
.cvbar .sp{color:#6FCF97;}
.lc{background:#232323;border:1px solid var(--bdr);border-radius:16px;padding:34px 32px;width:100%;max-width:380px;box-shadow:0 20px 60px rgba(0,0,0,.45);}
.lt{font-family:var(--bf);font-size:24px;font-weight:800;letter-spacing:.5px;color:var(--wht);text-align:center;text-transform:uppercase;margin-bottom:6px;}
.lsub{font-size:12.5px;color:var(--gry);text-align:center;margin-bottom:20px;line-height:1.5;}
.lf{margin-bottom:14px;}
.lf label{display:block;font-size:10.5px;font-weight:700;color:var(--mint);text-transform:uppercase;letter-spacing:.8px;margin-bottom:6px;}
.lf input{width:100%;background:var(--bgd);color:var(--wht);border:1.5px solid var(--bdr);border-radius:10px;padding:13px 14px;font-family:var(--mf);font-size:13.5px;outline:none;transition:border-color .15s;}
.lf input:focus{border-color:var(--mint);}
.lbtn{width:100%;background:var(--grn);color:#fff;border:none;border-radius:50px;padding:15px;font-family:var(--mf);font-size:14px;font-weight:700;cursor:pointer;margin-top:6px;}
.lbtn:hover{background:var(--grn-deep);}
.lerr{background:#3a1414;border:1px solid #7f1d1d;color:#fca5a5;border-radius:6px;padding:7px 10px;font-size:11.5px;margin-bottom:8px;text-align:center;}
.lpub{text-align:center;margin-top:16px;font-size:12px;color:var(--gry);}
.lpub span{color:var(--mint);font-weight:700;cursor:pointer;text-decoration:underline;}
.lterms{font-size:10.5px;color:#888;text-align:center;margin-top:16px;line-height:1.7;}
.lterms span{color:var(--mint);text-decoration:underline;cursor:pointer;}
.lhint{font-size:10.5px;color:#888;text-align:center;margin-top:12px;line-height:1.8;}
.lhint code{background:rgba(255,255,255,.08);color:var(--wht);padding:1px 5px;border-radius:3px;}
.cvp{position:relative;z-index:2;background:var(--grn-acc);padding:12px 18px;display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;}
.cvpl{font-family:var(--bf);font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.5);margin-right:6px;}
.hdr{background:var(--grn);height:54px;padding:0 16px;padding-top:env(safe-area-inset-top);display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:100;box-shadow:0 2px 12px rgba(0,0,0,.35);}
.hr{display:flex;align-items:center;gap:7px;}
.hb{display:flex;align-items:center;gap:5px;background:rgba(255,255,255,.15);color:#fff;border:none;border-radius:50px;padding:6px 11px;font-family:var(--mf);font-size:11.5px;font-weight:600;cursor:pointer;transition:background .15s;white-space:nowrap;}
.hb:hover{background:rgba(255,255,255,.26);}
.hb svg{width:14px;height:14px;}
.lpill{background:rgba(111,207,151,.2);color:var(--mint);font-size:9.5px;font-weight:700;padding:3px 9px;border-radius:20px;text-transform:uppercase;letter-spacing:.5px;}
.cbadge{background:var(--mint);color:var(--grn-deep);font-size:9.5px;font-weight:800;border-radius:50%;width:16px;height:16px;display:inline-flex;align-items:center;justify-content:center;}
/* Botón flotante del carrito — de respaldo para cuando el header sticky no
   se queda pegado arriba en algunos navegadores mobile (Safari/iOS con
   overflow-x:hidden en body es un caso conocido). Siempre visible mientras
   se scrollea el catálogo, no depende del sticky. Queda tapado solo (y no
   clickeable) cuando hay un modal/drawer abierto, porque esos fondos tienen
   z-index más alto. */
.cartFab{display:none;position:fixed;right:16px;bottom:16px;bottom:calc(16px + env(safe-area-inset-bottom));z-index:150;background:var(--grn);color:#fff;border:none;border-radius:50%;width:54px;height:54px;align-items:center;justify-content:center;box-shadow:0 6px 20px rgba(0,0,0,.5);cursor:pointer;}
.cartFab svg{width:23px;height:23px;}
.cartFab .cbadge{position:absolute;top:-2px;right:-2px;width:19px;height:19px;font-size:10.5px;border:2px solid #fff;}
/* "Volver arriba" — a diferencia del carrito, este SÍ se ve en desktop
   también (antes solo existía un flotante para mobile, para el carrito). */
.topFab{display:flex;position:fixed;left:16px;bottom:16px;bottom:calc(16px + env(safe-area-inset-bottom));z-index:150;background:#232323;color:var(--mint);border:1.5px solid var(--bdr);border-radius:50%;width:44px;height:44px;align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(0,0,0,.4);cursor:pointer;}
.topFab svg{width:19px;height:19px;}
.quickbar{position:fixed;bottom:16px;bottom:calc(16px + env(safe-area-inset-bottom));left:50%;transform:translateX(-50%);z-index:150;display:flex;align-items:center;gap:2px;background:#232323;border:1px solid var(--bdr);border-radius:50px;padding:5px;box-shadow:0 6px 20px rgba(0,0,0,.5);}
.quickbar-btn{display:flex;align-items:center;gap:6px;padding:8px 14px;border-radius:50px;color:var(--wht);text-decoration:none;font-size:12px;font-weight:600;white-space:nowrap;transition:background .15s;}
.quickbar-btn:hover{background:rgba(255,255,255,.08);}
.quickbar-btn svg{width:14px;height:14px;flex-shrink:0;}
.quickbar-btn.wa{color:#25D366;}
.quickbar-div{width:1px;height:18px;background:var(--bdr);}
.mw{max-width:1120px;margin:0 auto;padding:16px 14px 80px;}
.li{background:var(--grn-acc);border-left:3px solid var(--grn);border-radius:0 7px 7px 0;padding:8px 13px;font-size:12px;color:var(--wht);font-weight:600;margin-bottom:14px;display:flex;align-items:center;gap:7px;}
.sb{display:flex;align-items:center;gap:9px;background:#f4f4f2;border:1.5px solid rgba(17,103,53,.18);border-radius:9px;padding:8px 13px;margin-bottom:12px;}
.si{border:none;outline:none;flex:1;font-family:var(--mf);font-size:12.5px;color:#1a1a1a;background:transparent;}
.si::placeholder{color:#8a8a86;}
.cp{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:16px;}
.pk{background:#f4f4f2;border:1.5px solid rgba(17,103,53,.18);color:var(--grn-deep);font-family:var(--mf);font-size:11px;font-weight:600;padding:4px 12px;border-radius:50px;cursor:pointer;transition:all .15s;}
.pk:hover{border-color:var(--grn);color:var(--grn);}
.pk.on{background:var(--grn);border-color:var(--grn);color:#fff;}
.cs{margin-bottom:22px;}
.catmore{display:block;width:100%;background:transparent;border:1.5px dashed rgba(0,0,0,.15);color:var(--grn-deep);font-family:var(--mf);font-size:12px;font-weight:700;padding:10px;border-radius:9px;cursor:pointer;margin-top:6px;transition:all .15s;}
.catmore:hover{border-color:var(--grn);background:rgba(17,103,53,.06);}
.catnav{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:10px;padding-top:10px;border-top:1px solid rgba(0,0,0,.12);}
.catnav button{background:none;border:none;color:#6b7280;font-family:var(--mf);font-size:11.5px;font-weight:600;cursor:pointer;padding:4px 2px;transition:color .15s;}
.catnav button:hover{color:var(--grn-deep);}
@media(max-width:600px){.catnav{flex-direction:column;align-items:flex-start;gap:6px;}}
.lbtn2{width:100%;background:transparent;color:var(--mint);border:1.5px solid var(--mint);border-radius:50px;padding:13px;font-family:var(--mf);font-size:13.5px;font-weight:700;cursor:pointer;margin-top:10px;transition:background .15s;}
.lbtn2:hover{background:rgba(111,207,151,.1);}
.tos{max-width:720px;margin:0 auto;padding:40px 20px 80px;}
.tos h1{font-family:var(--bf);font-size:26px;font-weight:800;color:var(--wht);margin-bottom:6px;}
.tos .tos-upd{font-size:11.5px;color:#888;margin-bottom:28px;}
.tos h2{font-family:var(--bf);font-size:16px;font-weight:800;color:var(--mint);margin:26px 0 8px;}
.tos p{font-size:13px;color:var(--gry);line-height:1.7;margin-bottom:10px;}
.tos ul{margin:0 0 10px 20px;padding:0;}
.tos li{font-size:13px;color:var(--gry);line-height:1.7;margin-bottom:4px;}
.tos a{color:var(--mint);}
.ct{display:flex;align-items:center;gap:9px;margin-bottom:9px;}
.cn{font-family:var(--bf);font-size:17px;font-weight:800;color:var(--grn-deep);letter-spacing:.3px;}
.cl{flex:1;height:1.5px;background:rgba(0,0,0,.12);}
.cc{font-size:10.5px;font-weight:600;color:#6b7280;background:rgba(0,0,0,.06);padding:2px 8px;border-radius:20px;}
.pl{display:flex;flex-direction:column;gap:1px;}
.pr{display:flex;align-items:center;background:#f4f4f2;border:1.5px solid rgba(17,103,53,.15);border-left:3px solid var(--grn);border-radius:0 9px 9px 0;overflow:hidden;cursor:pointer;transition:box-shadow .2s,border-color .2s;}
.pr:hover{box-shadow:0 4px 16px rgba(0,0,0,.12);border-color:var(--grn);}
.pimg{position:relative;width:80px;height:80px;flex-shrink:0;overflow:hidden;background:#eeeeec;}
.pimg img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s;}
.pimg img[src*="NO_IMG"]{object-fit:contain;}
.pr:hover .pimg img{transform:scale(1.07);}
.pph{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:18px;color:var(--grn-deep);}
.pi{flex:1;padding:9px 13px;min-width:0;}
.pt{display:flex;align-items:center;gap:6px;margin-bottom:2px;}
.pc{font-size:9.5px;font-weight:600;color:#6b7280;background:rgba(0,0,0,.06);padding:1px 6px;border-radius:3px;letter-spacing:.3px;}
.pm{font-size:10px;color:#6b7280;font-weight:500;}
.pn{font-size:13px;font-weight:700;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.pd{font-size:11px;color:#6b7280;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:420px;}
.pp{padding:8px 14px;text-align:right;flex-shrink:0;flex-grow:0;width:150px;border-left:1px solid rgba(0,0,0,.1);display:flex;flex-direction:column;align-items:flex-end;gap:1px;}
.prow2{display:flex;align-items:baseline;gap:2px;}
.pcu{font-size:9px;font-weight:600;color:#6b7280;}
.pv{font-family:var(--bf);font-size:18px;font-weight:800;color:#1a1a1a;line-height:1.1;white-space:nowrap;}
.piv{font-size:9.5px;color:#888;white-space:nowrap;}
.ppub{font-size:10px;color:#9ca3af;text-decoration:line-through;white-space:nowrap;}
.pdesc{font-size:10px;font-weight:700;color:var(--grn-deep);background:rgba(17,103,53,.1);border:1px solid rgba(17,103,53,.3);padding:1px 5px;border-radius:3px;white-space:nowrap;}
.ab{background:var(--grn);color:#fff;border:none;border-radius:50px;padding:5px 10px;font-family:var(--mf);font-size:10px;font-weight:700;cursor:pointer;transition:all .15s;margin-top:5px;display:block;width:100%;text-align:center;}
.ab:hover{background:var(--grn-deep);}
.ab.in{background:rgba(17,103,53,.12);color:var(--grn-deep);}
.ov{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:300;display:flex;align-items:center;justify-content:center;padding:14px;}
.mb{background:#f4f4f2;border-radius:15px;max-width:500px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.35);}
.mi{width:100%;height:190px;object-fit:cover;border-radius:15px 15px 0 0;display:block;background:#f0f0ee;}
.mph{width:100%;height:190px;background:#f0f0ee;border-radius:15px 15px 0 0;display:flex;align-items:center;justify-content:center;font-size:56px;color:#116735;}
.mbdy{padding:18px 20px;}
.co{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:200;opacity:0;pointer-events:none;transition:opacity .25s;}
.co.op{opacity:1;pointer-events:all;}
.cp2{position:fixed;top:0;right:0;bottom:0;width:350px;max-width:94vw;background:#232323;z-index:201;transform:translateX(105%);transition:transform .3s;display:flex;flex-direction:column;box-shadow:-4px 0 40px rgba(0,0,0,.4);}
.cp2.op{transform:translateX(0);}
.mnov{position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:210;}
.mnu{position:absolute;top:calc(100% + 8px);right:12px;width:250px;max-width:88vw;background:#232323;border-radius:12px;box-shadow:0 14px 44px rgba(0,0,0,.5);z-index:211;overflow:hidden;border:1px solid var(--bdr);}
.mnu-hdr{background:var(--grn-acc);padding:12px 14px;border-bottom:1px solid var(--bdr);font-size:12.5px;color:var(--wht);font-weight:700;}
.mnu-item{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:11px 14px;font-size:13px;font-weight:600;color:var(--wht);cursor:pointer;border-bottom:1px solid var(--bdr);background:none;width:100%;text-align:left;border-left:none;border-right:none;border-top:none;font-family:var(--mf);}
.mnu-item:last-child{border-bottom:none;}
.mnu-item:hover{background:rgba(255,255,255,.05);}
.mnu-item.danger{color:#f87171;}
.mnu-badge{background:#6FCF97;color:#0d4f27;border-radius:10px;padding:1px 7px;font-size:10.5px;font-weight:800;}
.mnu-badge.warn{background:#e67e22;color:#fff;}
.mnu-lb{display:flex;align-items:center;gap:9px;}
.mnu-lb svg{flex-shrink:0;color:#999;}
.mnu-item.danger .mnu-lb svg{color:#f87171;}
.topact{display:flex;gap:8px;flex-wrap:wrap;padding:9px 14px;background:#191919;border-bottom:1px solid var(--bdr);}
.topact-btn{display:flex;align-items:center;gap:6px;background:transparent;border:1.5px solid var(--bdr);color:var(--mint);font-family:var(--mf);font-size:12px;font-weight:700;padding:6px 12px;border-radius:50px;cursor:pointer;white-space:nowrap;}
.topact-btn:hover{border-color:var(--mint);background:rgba(111,207,151,.1);}
.ch{background:var(--grn);padding:13px 15px;display:flex;justify-content:space-between;align-items:center;flex-shrink:0;}
.chttl{font-family:var(--bf);font-size:16.5px;font-weight:700;color:#fff;letter-spacing:.1px;}
.chcls{background:rgba(255,255,255,.16);color:#fff;border:none;border-radius:6px;width:26px;height:26px;cursor:pointer;display:flex;align-items:center;justify-content:center;}
.chcls:hover{background:rgba(255,255,255,.28);}
.cbdy{flex:0 1 auto;overflow-y:auto;overscroll-behavior-y:contain;padding:11px;-webkit-overflow-scrolling:touch;}
.cemp{text-align:center;padding:38px 14px;color:#999;}
.ci{display:flex;gap:9px;align-items:flex-start;padding:10px 0;border-bottom:1px solid var(--bdr);}
.cimg{width:46px;height:46px;border-radius:6px;object-fit:cover;border:1px solid var(--bdr);flex-shrink:0;background:#f0f0ee;}
.cph2{width:46px;height:46px;border-radius:6px;background:#f0f0ee;display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#116735;}
.cin{flex:1;min-width:0;}
.cnm{font-size:11.5px;font-weight:600;color:var(--wht);line-height:1.3;}
.cco{font-size:10px;color:#999;margin-bottom:3px;}
.cpr{font-family:var(--bf);font-size:15px;font-weight:700;color:var(--mint);margin-bottom:4px;}
.qr{display:flex;align-items:center;gap:5px;}
.qb{width:21px;height:21px;border-radius:4px;border:1.5px solid var(--bdr);background:var(--bgd);cursor:pointer;font-size:13px;font-weight:700;color:var(--gry);display:flex;align-items:center;justify-content:center;}
.qb:hover{border-color:var(--mint);color:var(--mint);}
.qn{font-size:12.5px;font-weight:700;min-width:17px;text-align:center;}
.cdl{background:none;border:none;cursor:pointer;color:#777;margin-left:auto;padding:2px;display:flex;}
.cdl:hover{color:#f87171;}
.cft{padding:12px 15px calc(14px + env(safe-area-inset-bottom));border-top:1px solid var(--bdr);flex-shrink:0;}
.cno{font-size:10.5px;color:#888;text-align:center;margin-bottom:2px;}
.shareRow{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;}
.shareBtn{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;background:var(--bgd);border:1.3px solid var(--bdr);border-radius:8px;padding:8px 3px;font-family:var(--mf);font-size:10px;font-weight:600;color:var(--gry);cursor:pointer;}
.shareBtn:hover{border-color:rgba(255,255,255,.25);background:#232323;}
.shareBtn.wa{border-color:#25D366;color:#25D366;}
.shareBtn.wa:hover{background:rgba(37,211,102,.12);}
.aw{max-width:1020px;margin:0 auto;padding:20px 14px;}
.att{font-family:var(--bf);font-size:28px;font-weight:800;color:var(--grn-deep);margin-bottom:16px;}
.ats{display:flex;background:#232323;border-radius:7px;padding:3px;margin-bottom:18px;overflow-x:auto;-webkit-overflow-scrolling:touch;gap:2px;}
.at{flex:0 0 auto;display:inline-flex;align-items:center;gap:6px;background:transparent;border:none;border-radius:5px;padding:8px 13px;font-family:var(--mf);font-size:11.5px;font-weight:600;cursor:pointer;color:var(--gry);white-space:nowrap;}
.at svg{flex-shrink:0;opacity:.75;}
.at.on{background:var(--bgd);color:var(--mint);box-shadow:0 1px 4px rgba(0,0,0,.4);}
.at.on svg{opacity:1;}
.ac{background:#232323;border-radius:9px;border:1px solid var(--bdr);overflow:hidden;margin-bottom:14px;}
.atb{width:100%;border-collapse:collapse;font-size:12px;}
.atb th{background:var(--grn-acc);color:var(--wht);font-weight:700;text-transform:uppercase;font-size:9.5px;letter-spacing:.7px;padding:8px 11px;text-align:left;}
.atb td{padding:10px 11px;border-bottom:1px solid var(--bdr);vertical-align:middle;color:var(--wht);}
.atb tr:last-child td{border-bottom:none;}
.atb tr:hover td{background:rgba(255,255,255,.04);}
.tl{display:inline-block;font-size:10px;font-weight:700;padding:2px 7px;border-radius:4px;text-transform:uppercase;letter-spacing:.3px;}
.tl.lista1{background:rgba(59,130,246,.18);color:#93c5fd;}
.tl.especial{background:rgba(245,158,11,.18);color:#fbbf24;}
.tl.lista2{background:rgba(168,85,247,.18);color:#d8b4fe;}
.tl.admin{background:rgba(111,207,151,.18);color:var(--mint);}
.adl{background:rgba(220,38,38,.15);color:#f87171;border:none;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:700;cursor:pointer;}
.adl:hover{background:rgba(220,38,38,.25);}
.ubox{border:2px dashed var(--bdr);border-radius:11px;padding:32px;text-align:center;cursor:pointer;background:var(--bgd);transition:all .2s;margin-bottom:12px;}
.ubox:hover{border-color:var(--mint);background:rgba(111,207,151,.05);}
.ubox h3{font-family:var(--bf);font-size:18px;font-weight:800;margin:7px 0 5px;color:var(--wht);}
.ubox p{font-size:11.5px;color:var(--gry);line-height:1.6;}
.ubox code{background:rgba(111,207,151,.15);padding:2px 5px;border-radius:3px;font-size:10.5px;color:var(--mint);}
.sok{background:var(--grn-acc);border-left:3px solid var(--grn);border-radius:0 6px 6px 0;padding:8px 12px;font-size:12px;color:var(--wht);font-weight:600;margin-bottom:12px;}
.ur{display:flex;gap:7px;margin-bottom:12px;flex-wrap:wrap;}
.ui{border:1.5px solid var(--bdr);border-radius:6px;padding:7px 10px;font-family:var(--mf);font-size:12px;outline:none;flex:1;min-width:110px;background:var(--bgd);color:var(--wht);}
.ui:focus{border-color:var(--mint);}
.us{border:1.5px solid var(--bdr);border-radius:6px;padding:7px 10px;font-family:var(--mf);font-size:12px;outline:none;background:var(--bgd);color:var(--wht);}
.ua{background:var(--grn);color:#fff;border:none;border-radius:50px;padding:8px 14px;font-family:var(--mf);font-size:12px;font-weight:700;cursor:pointer;}
.ua:hover{background:var(--grn-deep);}
.tip{font-size:10.5px;color:var(--gry);background:var(--grn-acc);border-radius:8px;padding:12px 14px;line-height:1.7;margin-top:10px;}
.pw{background:#232323;border-radius:9px;border:1px solid var(--bdr);overflow:hidden;margin-bottom:12px;}
.pb{background:var(--grn-deep);padding:10px 14px;display:flex;justify-content:space-between;align-items:center;}
.pt2{font-family:var(--bf);font-size:17px;font-weight:800;color:#fff;}
.ps{font-size:11px;color:rgba(255,255,255,.7);display:flex;gap:10px;}
.psc{max-height:300px;overflow-y:auto;}
.ptb{width:100%;border-collapse:collapse;font-size:12px;}
.cbadge2{font-size:11px;font-weight:700;color:var(--mint);background:rgba(111,207,151,.15);padding:2px 6px;border-radius:4px;}
.ptb th{background:var(--grn-acc);color:var(--wht);font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.7px;padding:7px 10px;text-align:left;position:sticky;top:0;}
.ptb td{padding:8px 10px;border-bottom:1px solid var(--bdr);vertical-align:middle;color:var(--wht);}
.ptb tr:last-child td{border-bottom:none;}
@keyframes spin{to{transform:rotate(360deg);}}
.sp2{display:inline-block;animation:spin 1s linear infinite;}
.pa{display:flex;gap:8px;padding:12px 14px;border-top:1px solid var(--bdr);background:#191919;}
.bc{background:var(--grn);color:#fff;border:none;border-radius:50px;padding:9px 20px;font-family:var(--mf);font-size:13px;font-weight:700;cursor:pointer;flex:1;}
.bc:hover{background:var(--grn-deep);}
.bx{background:transparent;color:var(--gry);border:1.5px solid var(--bdr);border-radius:50px;padding:9px 16px;font-family:var(--mf);font-size:12.5px;font-weight:600;cursor:pointer;}
.bx:hover{border-color:#f87171;color:#f87171;}
.ip{width:36px;height:36px;border-radius:5px;object-fit:cover;border:1px solid var(--bdr);background:#f0f0ee;}
.iph{width:36px;height:36px;border-radius:5px;background:#f0f0ee;display:flex;align-items:center;justify-content:center;font-size:16px;color:#116735;}
@media print{
  .hdr,.sb,.cp,.co,.cp2,.ov,.li,.ab,.no-print,.ft{display:none!important;}
  .mw{padding:0!important;}
  .pr{break-inside:avoid;}
  html,body,.cat-wrap,.mw{background:#fff!important;color:#000!important;}
  .pn,.pv,.cn{color:#000!important;}
  @page{margin:1.2cm;size:A4;}
  .cat-wrap::before{content:"TMC.agro — Listado de Precios";display:block;font-size:20px;font-weight:800;margin-bottom:4px;}
  .cat-wrap::after{content:"Descargado el: " attr(data-stamp) " — " attr(data-lista);display:block;font-size:10px;color:#666;margin-bottom:16px;border-bottom:1px solid #ccc;padding-bottom:8px;}
}
/* ─ CAROUSEL ─ */
.car{position:relative;width:100%;overflow:hidden;background:var(--grn-deep);margin-bottom:0;}
.cat-wrap{display:flex;flex-direction:column;min-height:100vh;min-height:100dvh;}
.emod{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:300;display:flex;align-items:center;justify-content:center;padding:16px;}
.emod-box{background:#232323;border-radius:14px;width:100%;max-width:620px;max-height:92vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,.5);}
.emod-hdr{background:var(--grn-deep);padding:14px 18px;border-radius:14px 14px 0 0;display:flex;justify-content:space-between;align-items:center;position:sticky;top:0;z-index:1;}
.emod-ttl{font-family:var(--bf);font-size:20px;font-weight:800;color:#fff;}
.emod-close{background:rgba(255,255,255,.15);border:none;color:#fff;width:30px;height:30px;border-radius:50%;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;}
.emod-body{padding:18px;}
.emod-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
.emod-full{grid-column:1/-1;}
.emod-label{font-size:11px;font-weight:700;color:var(--mint);text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px;}
.emod-input{width:100%;border:1.5px solid var(--bdr);border-radius:7px;padding:8px 10px;font-family:var(--mf);font-size:13px;outline:none;box-sizing:border-box;transition:border-color .15s;background:var(--bgd);color:var(--wht);}
.emod-input:focus{border-color:var(--mint);}
.emod-textarea{width:100%;border:1.5px solid var(--bdr);border-radius:7px;padding:8px 10px;font-family:var(--mf);font-size:13px;outline:none;resize:vertical;min-height:70px;box-sizing:border-box;background:var(--bgd);color:var(--wht);}
.emod-textarea:focus{border-color:var(--mint);}
.emod-section{font-size:11px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:.8px;margin:14px 0 8px;padding-bottom:6px;border-bottom:1px solid var(--bdr);}
.emod-img-prev{width:100%;height:80px;object-fit:contain;border-radius:6px;border:1px solid var(--bdr);margin-bottom:6px;background:var(--bgd);}
.emod-footer{padding:14px 18px;border-top:1px solid var(--bdr);display:flex;gap:10px;justify-content:flex-end;position:sticky;bottom:0;background:#232323;border-radius:0 0 14px 14px;}
.emod-save{background:var(--grn);color:#fff;border:none;border-radius:50px;padding:10px 24px;font-family:var(--mf);font-size:13px;font-weight:700;cursor:pointer;}
.emod-save:hover{background:var(--grn-deep);}
.emod-cancel{background:rgba(255,255,255,.08);color:var(--gry);border:none;border-radius:50px;padding:10px 16px;font-family:var(--mf);font-size:13px;font-weight:600;cursor:pointer;}
.tr-edit{cursor:pointer;transition:background .1s;}
.tr-edit:hover{background:rgba(255,255,255,.04);}
.car-track{display:flex;transition:transform .5s ease;}
.car-slide{min-width:100%;height:320px;position:relative;flex-shrink:0;}
@media(max-width:600px){.car-slide{height:160px;}}
.car-slide img{width:100%;height:100%;object-fit:cover;display:block;}
.car-slide-ph{width:100%;height:100%;background:linear-gradient(135deg,#0d4f27,#116735);display:flex;align-items:center;justify-content:center;flex-direction:column;gap:12px;}
.car-dots{position:absolute;bottom:10px;left:50%;transform:translateX(-50%);display:flex;gap:7px;z-index:5;}
.car-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.4);cursor:pointer;transition:background .2s;}
.car-dot.on{background:#fff;}
.car-arr{position:absolute;top:50%;transform:translateY(-50%);background:rgba(0,0,0,.4);color:#fff;border:none;width:36px;height:36px;border-radius:50%;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;z-index:5;transition:background .2s;}
.car-arr:hover{background:rgba(0,0,0,.65);}
.car-arr.l{left:10px;}
.car-arr.r{right:10px;}
/* ─ GALLERY ─ */
.gal-main{width:100%;height:280px;background:#f0f0ee;border-radius:10px 10px 0 0;overflow:hidden;display:flex;align-items:center;justify-content:center;}
.gal-main img{width:100%;height:100%;object-fit:contain;}
.gal-main-ph{font-size:64px;color:#555;}
.gal-thumbs{display:flex;gap:7px;padding:8px 0;overflow-x:auto;}
.gal-thumb{width:64px;height:64px;border-radius:7px;overflow:hidden;cursor:pointer;flex-shrink:0;border:2px solid transparent;transition:border-color .15s;background:#f0f0ee;}
.gal-thumb.on{border-color:var(--mint);}
.gal-thumb img{width:100%;height:100%;object-fit:cover;}
.gal-thumb-ph{width:100%;height:100%;background:#f0f0ee;display:flex;align-items:center;justify-content:center;font-size:22px;color:#116735;}
.yt-wrap{position:relative;width:100%;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:8px;margin-top:10px;}
.yt-wrap iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:8px;}
/* ─ FOOTER ─ */
.ft{background:var(--grn-acc);border-top:4px solid var(--grn);padding:28px 20px 20px;margin-top:32px;}
.ft-inner{max-width:1120px;margin:0 auto;display:flex;flex-direction:column;gap:18px;}
.ft-top{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:14px;}
.ft-tag{font-size:11px;color:rgba(255,255,255,.5);letter-spacing:.5px;margin-top:4px;}
.ft-links{display:flex;gap:10px;flex-wrap:wrap;}
.ft-link{display:inline-flex;align-items:center;gap:7px;background:rgba(255,255,255,.1);color:#fff;text-decoration:none;border-radius:50px;padding:9px 16px;font-family:var(--mf);font-size:12.5px;font-weight:600;transition:background .15s;white-space:nowrap;}
.ft-link:hover{background:rgba(255,255,255,.2);}
.ft-link svg{width:16px;height:16px;flex-shrink:0;}
.ft-link.wa{background:#25D366;}
.ft-link.wa:hover{background:#1ebe5d;}
.ft-divider{height:1px;background:rgba(255,255,255,.1);}
.ft-bot{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px;}
.ft-copy{font-size:11px;color:rgba(255,255,255,.4);}
.ft-prices{font-size:11px;color:rgba(255,255,255,.4);}
@media(max-width:600px){.ft-top{flex-direction:column;align-items:flex-start;}.ft-bot{flex-direction:column;gap:4px;}}
@media(max-width:600px){
  input,select,textarea{font-size:16px!important;} /* evita el auto-zoom de iOS al enfocar un campo */
  .qb,.chcls,.cdl,.hb,.shareBtn,.at,.sb button{touch-action:manipulation;}
  .emod-box{padding-bottom:env(safe-area-inset-bottom);}
  .hdr{padding:0 12px;padding-top:env(safe-area-inset-top);height:50px;}
  .hb span:not(.cbadge){display:none;}
  .hb{padding:6px 9px;}
  .quickbar-btn span{display:none;}
  .quickbar-btn{padding:9px;}
  .lpill{font-size:8.5px;padding:2px 7px;}
  .mw{padding:10px 10px 80px;}
  .pr{flex-wrap:wrap;}
  .pimg{width:70px;height:70px;}
  .pi{padding:7px 10px;width:calc(100% - 70px);}
  .pn{font-size:12.5px;white-space:normal;line-height:1.3;}
  .pd{display:none;}
  .pp{min-width:unset;width:100%;border-left:none;border-top:1px solid rgba(0,0,0,.1);padding:6px 10px;flex-direction:row;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:4px;}
  .prow2{flex-direction:row;}
  .ppub{font-size:9.5px;}
  .pdesc{font-size:9.5px;}
  .pv{font-size:16px;}
  .piv{font-size:9px;}
  .ab{width:auto;margin-top:0;padding:6px 12px;flex-shrink:0;font-size:10px;}
  .cn{font-size:15px;}
  .li{font-size:11px;flex-wrap:wrap;}
  .sb{padding:7px 11px;}
  .cartFab{display:flex;}
  .cp2{width:100%;max-width:100%;top:auto;bottom:0;height:auto;max-height:88vh;border-radius:16px 16px 0 0;transform:translateY(105%);}
  .cp2.op{transform:translateY(0);}
  .lc{padding:22px 20px;}
  .cvtag{font-size:11px;}
  .cvc{padding:20px 14px;}
  .aw{padding:14px 10px;}
  .atb th:nth-child(4),.atb td:nth-child(4){display:none;}
  .pr{border-radius:8px;}
  .ct{margin-bottom:6px;}
  .cp{gap:5px;}
  .pk{font-size:10.5px;padding:4px 10px;}
  .sb{flex-wrap:wrap;gap:6px;}
  .sb input{min-width:0;flex:1;}
  .emod-box{border-radius:12px 12px 0 0;position:fixed;bottom:0;left:0;right:0;max-height:92vh;width:100%;max-width:100%;}
  .emod{align-items:flex-end;padding:0;}
  .emod-grid{grid-template-columns:1fr;}
  .cft .shareBtn{font-size:9.5px;padding:7px 3px;}
  .gal-main{height:200px;}
  .gal-thumbs{gap:5px;}
  .gal-thumb{width:52px;height:52px;}
}
`;

export default function TMCCatalogo() {
  const [screen,setSc]   = useState("cat");
  const [regForm,setRegForm] = useState({p:"",nom:"",email:"",tel:"",cuit:"",docTipo:"cuit",loc:"",prov:"",cp:""});
  const [regMsg,setRegMsg]   = useState("");
  const [users,setUsers] = useState(INIT_USERS);
  const [sess,setSess]   = useState(loadSession);
  const [prods,setProds] = useState([]);
  const [loading,setLoading] = useState(true);

  // Sesión restaurada desde localStorage al abrir la app (persistente por 10
  // días de inactividad). Corre el vencimiento y trae los pedidos del usuario,
  // igual que hace doLogin — pero sin volver a pedir clave ni loguear el evento.
  useEffect(()=>{
    if(!sess) return;
    saveSession(sess);
    SB(`pedidos_catalogo?usuario=eq.${encodeURIComponent(sess.u)}&order=created_at.desc&limit=20`)
      .then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setMyOrders(d); }).catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    // Load products from Supabase
    SB("configuracion?clave=eq.cat_order&select=valor").then(r=>r.json()).then(d=>{
      if(Array.isArray(d)&&d[0]?.valor) setCatOrder(d[0].valor);
    }).catch(()=>{});
    SB("configuracion?clave=eq.prod_order&select=valor").then(r=>r.json()).then(d=>{
      if(Array.isArray(d)&&d[0]?.valor) setProdOrder(d[0].valor);
    }).catch(()=>{});
    SB("productos?select=*&order=cat,nom").then(r=>r.json()).then(data=>{
      if(Array.isArray(data)&&data.length>0){
        setProds(data.map(p=>({...p,desc:p.descripcion,cat:normCat(p.cat)})));
      } else {
        setProds(SAMPLE);
      }
    }).catch(()=>setProds(SAMPLE)).finally(()=>setLoading(false));
    SB("condiciones?select=*&order=orden.asc,nombre.asc").then(r=>r.json()).then(d=>{
      if(Array.isArray(d)) setCondiciones(d);
    }).catch(()=>{});
    SB("promos_catalogo?select=*&order=id.asc").then(r=>r.json()).then(d=>{
      if(Array.isArray(d)) setPromos(d);
    }).catch(()=>{});
    // v4: listas de precio normalizadas (reemplaza las columnas fijas pp/p1/pe/p2)
    SB("listas_precio?select=*&order=orden.asc").then(r=>r.json()).then(d=>{
      if(Array.isArray(d)&&d.length) setListasPrecio(d);
    }).catch(()=>{});
    // Nota: la carga de usuarios y precios se movió más abajo (ver el efecto
    // que depende de "sess") — antes se bajaban ENTERAS (todas las listas de
    // precio, todos los usuarios) a cualquier visitante sin login. v4.36.
  },[]);

  // v4.36: usuarios y precios, con alcance según quién mira. Staff (admin/
  // vendedor) sigue viendo todo (lo necesita para el Excel multi-lista, la
  // ficha de producto y la gestión de usuarios). Cliente o visitante anónimo
  // solo pide: el precio YA RESUELTO de su propia lista (precios_lista(),
  // misma cascada que antes pero calculada en el servidor) y, si está
  // logueado, su propio perfil (mi_perfil()) — nunca la tabla entera. Ver
  // migracion_v11_endurecer_datos_publicos.sql.
  useEffect(()=>{
    const isStaff = sess?.rol==="admin"||sess?.rol==="vendedor";
    if(isStaff){
      SB("rpc/get_all_users",{method:"POST",body:JSON.stringify({
        p_usuario:"admin",
        p_clave:"d6aa7749ff88903b983b9535a4a0bde0966c240dbdd7f1d5d3e6c0c36809d209"
      })}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)&&data.length>0){
          setUsers(current=>{
            const sbUsers = data.map(u=>({...u,u:u.usuario,p:"[hashed]",nom:u.nombre}));
            const sbKeys = new Set(sbUsers.map(u=>u.u));
            // Antes esto se quedaba solo con los admins "locales" (el admin
            // hardcodeado de arranque) y descartaba cualquier admin que
            // viniera de Supabase — por eso los admins creados desde el panel
            // (Maxi, Agustina) desaparecían de la lista al refrescar, aunque
            // seguían bien guardados en la base. Ahora se listan los admins
            // que sí vinieron de la base, y solo se mantiene el admin local
            // como respaldo si por algún motivo no está en esa respuesta.
            const localOnlyAdmins = current.filter(u=>u.rol==="admin" && !sbKeys.has(u.u));
            return [...localOnlyAdmins, ...sbUsers];
          });
        }
      }).catch(()=>{});
      SB("precios_producto?select=*").then(r=>r.json()).then(d=>{
        if(Array.isArray(d)){
          const map = {};
          d.forEach(row=>{ if(!map[row.producto_cod]) map[row.producto_cod]={}; map[row.producto_cod][row.lista_key]=row.precio; });
          setPreciosMap(map);
        }
      }).catch(()=>{});
    } else {
      const listaVisitante = sess?.lista || "publico";
      SB("rpc/precios_lista",{method:"POST",body:JSON.stringify({p_lista_key:listaVisitante})}).then(r=>r.json()).then(d=>{
        if(Array.isArray(d)){
          const map = {};
          d.forEach(row=>{ map[row.cod] = {[listaVisitante]:row.precio}; });
          setPreciosMap(map);
        }
      }).catch(()=>{});
      if(sess?.u){
        SB("rpc/mi_perfil",{method:"POST",body:JSON.stringify({p_usuario:sess.u})}).then(r=>r.json()).then(d=>{
          const row = Array.isArray(d)?d[0]:d;
          if(row) setMisDatos({...row, u:row.usuario, nom:row.nombre});
        }).catch(()=>{});
      } else {
        setMisDatos(null);
      }
    }
  },[sess?.rol, sess?.u, sess?.lista]);
  const [condiciones,setCondiciones] = useState([]); // condiciones de pago (ajuste_pct)
  const [condicionSel,setCondicionSel] = useState(null); // id de la condición elegida en el carrito, o null = "Sin condición"
  const [editingOrder,setEditingOrder] = useState(null); // pedido confirmado que se está editando (o null = carrito nuevo)
  const [confirmResult,setConfirmResult] = useState(null); // {p, queued} — aviso post-confirmación con CTA de WhatsApp
  const [promos,setPromos] = useState([]); // promos v2: requisitos → beneficio
  const [showComparar,setShowComparar] = useState(false);
  const [nuLista,setNuLista] = useState("");
  const [editLista,setEditLista] = useState(null); // {key, lbl}
  const [nuCond,setNuCond] = useState({nombre:"",ajuste_pct:""});
  const NUEVA_PROMO = {nombre:"",req_tipo:"cod",req_cod:"",req_cat:"",req_cant:"1",benef_tipo:"cod",beneficio_cod:"",beneficio_cat:"",beneficio_descuento_pct:"",beneficio_cant:"1",listas:[],destacado:false};
  const [nuPromo,setNuPromo] = useState(NUEVA_PROMO);
  const [promoPickOpen,setPromoPickOpen] = useState(null); // "req" | "benef" | null — qué buscador de producto está abierto
  const [cart,setCart]   = useState([]);
  // v4.32: cargos adicionales de línea (visita a campo / viáticos) — SOLO
  // vendedores los pueden agregar a un pedido/presupuesto (no admin, no
  // cliente, por pedido explícito). Van como ítems sin código, IVA 21% fijo,
  // con monto y descripción editables (la descripción viene sugerida pero
  // se puede cambiar por cualquier texto). Ver calcularPedido/migracion_v9.
  const defaultExtraCargos = () => ([
    {key:"visita",   enabled:false, desc:"Visita a campo", monto:""},
    {key:"viaticos", enabled:false, desc:"Viáticos",        monto:""},
  ]);
  const [extraCargos,setExtraCargos] = useState(defaultExtraCargos());
  // v4.33: al principio esto era solo para vendedor ("SOLO usuarios
  // vendedores" en el pedido original) — ahora también lo puede usar admin,
  // que arma pedidos igual que un vendedor.
  const puedeCargosExtra = sess?.rol==="vendedor" || sess?.rol==="admin";
  // v4.32: código de descuento — cualquier usuario lo puede ingresar en el
  // carrito. Se valida contra validar_codigo_descuento() (RPC que devuelve
  // SOLO el código puntual preguntado, nunca la lista completa — ver
  // migracion_v9_codigos_descuento.sql). Sirve para trackear de dónde viene
  // un pedido y, si el código tiene %, aplica un descuento automático.
  const [codigoInput,setCodigoInput] = useState("");
  const [codigoAplicado,setCodigoAplicado] = useState(null); // {codigo,origen,descuento_pct}
  const [codigoValidando,setCodigoValidando] = useState(false);
  const [codigoError,setCodigoError] = useState("");
  const aplicarCodigoDescuento = () => {
    const c = codigoInput.trim();
    if(!c){ setCodigoError("Ingresá un código."); return; }
    setCodigoValidando(true); setCodigoError("");
    SB("rpc/validar_codigo_descuento",{method:"POST",body:JSON.stringify({p_codigo:c})})
      .then(r=>r.json()).then(rows=>{
        const row = Array.isArray(rows) ? rows[0] : rows;
        if(row && row.codigo){
          setCodigoAplicado({codigo:row.codigo, origen:row.origen||"", descuento_pct:Number(row.descuento_pct)||0});
          setCodigoError("");
        } else {
          setCodigoAplicado(null);
          setCodigoError("Código inválido o inactivo.");
        }
      })
      .catch(()=>{ setCodigoAplicado(null); setCodigoError("No se pudo validar ahora. Probá de nuevo."); })
      .finally(()=>setCodigoValidando(false));
  };
  const quitarCodigoDescuento = () => { setCodigoAplicado(null); setCodigoInput(""); setCodigoError(""); };
  const [q,setQ]         = useState("");
  const [cats2,setCats2]   = useState(new Set()); // selected categories (empty = all)
  const CAT_PAGE_SIZE = 12; // productos visibles por categoría antes de "Ver más" (pedido de Marcos 19/08)
  const [expandedCats,setExpandedCats] = useState(new Set());
  const [cartOp,setCartOp] = useState(false);
  // Botón flotante "volver arriba" — aparece una vez que se scrolleó lo
  // suficiente como para perder de vista el header, en cualquier tamaño de
  // pantalla (antes solo existía el flotante del carrito, y solo en mobile).
  const [showBackToTop,setShowBackToTop] = useState(false);
  // v5.11: la franja flotante de WhatsApp/sitio se esconde cerca del final de
  // la página porque ahí ya está el footer completo (con su propio link de
  // WhatsApp) — mostrar las dos juntas quedaba redundante y se pisaban.
  const [nearBottom,setNearBottom] = useState(false);
  useEffect(()=>{
    const onScroll = () => {
      setShowBackToTop(window.scrollY > 400);
      setNearBottom(window.innerHeight + window.scrollY > document.body.scrollHeight - 400);
    };
    window.addEventListener("scroll", onScroll, {passive:true});
    return () => window.removeEventListener("scroll", onScroll);
  },[]);
  // Pedido vs presupuesto: solo vendedor/admin pueden armar presupuestos (v4).
  const [tipo,setTipo]   = useState("pedido");
  const [confirmando,setConfirmando] = useState(false); // evita doble envío por doble-tap en mobile

  // v4: cola de sincronización offline, misma lógica que expo.tmcagro.com — si
  // un pedido/presupuesto no llega al servidor (sin señal o error de red) no
  // se pierde: queda guardado en el celular y se reintenta solo apenas vuelve
  // la conexión (evento 'online' + reintento periódico), o se puede reenviar
  // a mano por WhatsApp desde "Pendientes".
  const [online,setOnline] = useState(typeof navigator!=="undefined" ? navigator.onLine : true);
  const [queue,setQueue] = useState(()=>{
    try{ return JSON.parse(localStorage.getItem("tmc_queue")||"[]"); }catch{ return []; }
  });
  const queueRef = useRef([]);
  useEffect(()=>{ queueRef.current = queue; try{ localStorage.setItem("tmc_queue", JSON.stringify(queue)); }catch{} },[queue]);
  const [showPendientes,setShowPendientes] = useState(false);
  const flushQueue = async () => {
    if(typeof navigator!=="undefined" && !navigator.onLine) return;
    const pending = [...queueRef.current];
    for(const item of pending){
      try{
        const r = await SB("rpc/crear_pedido",{method:"POST",body:JSON.stringify({p_data:item.p_data})});
        if(!r.ok) throw new Error(await r.text());
        const row = await r.json();
        const saved = Array.isArray(row) ? row[0] : row;
        setMyOrders(prev=>[saved, ...prev]);
        setQueue(q=>q.filter(x=>x.id!==item.id));
        if(item.p_data.tipo==="pedido" && saved) enviarMailVentas(armarPedidoObj(saved));
      }catch(e){
        console.log("Sync pendiente, reintento más tarde:", e);
        break; // si el primero de la cola falló probablemente seguimos sin señal real — no sigas gastando intentos
      }
    }
  };
  useEffect(()=>{
    const goOnline = ()=>{ setOnline(true); flushQueue(); };
    const goOffline = ()=>setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    if(typeof navigator!=="undefined" && navigator.onLine) flushQueue();
    const iv = setInterval(()=>{ if(typeof navigator==="undefined"||navigator.onLine) flushQueue(); }, 15000);
    return ()=>{ window.removeEventListener("online",goOnline); window.removeEventListener("offline",goOffline); clearInterval(iv); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const puedePresupuesto = sess?.rol==="admin"||sess?.rol==="vendedor";
  const [modal,setModal] = useState(null);
  const [aTab,setATab]   = useState("prods");
  const [upMsg,setUpMsg] = useState("");
  const [preview,setPreview] = useState(null);
  // v4: listas de precio configurables (antes: listaMap fijo con 4 columnas pp/p1/pe/p2).
  // listasPrecio: [{id,key,lbl,orden,activa}, ...] ordenadas de más barata a más cara.
  // preciosMap: {[producto_cod]: {[lista_key]: precio}}.
  const [listasPrecio,setListasPrecio] = useState(Object.entries(DEFAULT_LISTA_MAP).map(([key,v],i)=>({key,lbl:v.lbl,orden:i+1,activa:true})));
  const [preciosMap,setPreciosMap] = useState({});
  // v4.36: perfil propio (para clientes/visitantes, que ya no reciben la
  // tabla completa de usuarios) — se usa para mostrar el CUIT propio en los
  // pedidos, igual que antes se buscaba en "users".
  const [misDatos,setMisDatos] = useState(null);
  const [adminLista,setAdminLista] = useState("lista1");
  const [banners,setBanners] = useState(DEFAULT_BANNERS);
  const [catOrder,setCatOrder] = useState([]);
  const [prodOrder,setProdOrder] = useState({}); // {cat: [cod, cod, ...]}
  const [adminCatFilter,setAdminCatFilter] = useState("");
  const [activ,setActiv] = useState([]);
  const [activFilter,setActivFilter] = useState(null);
  const [activUser,setActivUser] = useState(null);
  const [allPedidos,setAllPedidos] = useState([]);
  // v4.32: gestión de códigos de descuento (panel admin). listar/crear/
  // actualizar/eliminar_codigo_descuento son RPCs (la tabla tiene RLS sin
  // políticas, no se puede leer/escribir directo por REST — ver
  // migracion_v9_codigos_descuento.sql).
  const [codigosAdmin,setCodigosAdmin] = useState([]);
  const [nuCodigoAdmin,setNuCodigoAdmin] = useState({codigo:"",origen:"",descuento_pct:""});
  // v4: Tablero — vendedor/admin ven el agregado de todos los pedidos, el
  // cliente ve solo los suyos. Producto más vendido/comprado y monto del mes
  // en curso, siempre sin impuestos (campo "neto" del pedido) y en valores
  // absolutos, tal como se definió.
  const [tableroPedidos,setTableroPedidos] = useState(null); // null = todavía no se pidió
  useEffect(()=>{
    if(screen!=="tablero"||!sess) return;
    const isStaff = sess.rol==="admin"||sess.rol==="vendedor";
    const q = isStaff
      ? "pedidos_catalogo?select=items,neto,tipo,estado,created_at,usuario,nombre_cliente&order=created_at.desc&limit=500"
      : `pedidos_catalogo?select=items,neto,tipo,estado,created_at&usuario=eq.${encodeURIComponent(sess.u)}&order=created_at.desc&limit=200`;
    SB(q).then(r=>r.json()).then(d=>setTableroPedidos(Array.isArray(d)?d:[])).catch(()=>setTableroPedidos([]));
  },[screen,sess]);
  const [carIdx,setCarIdx]   = useState(0);
  const [galPhoto,setGalPhoto] = useState(null); // active photo in modal gallery
  const carRef = useRef(null);
  const fmtDate = d => { const [mes,...resto]=d.toLocaleDateString("es-AR",{month:"long",year:"numeric"}).split(" de "); return `${mes}/${resto.join("")}`; };
  const [lastUp,setLastUp] = useState(()=>fmtDate(new Date())); // ya no se muestra en el login (rediseño 19/08), sigue usándose para el admin
  const [uIn,setUIn]     = useState(""); const [pIn,setPIn] = useState(""); const [lerr,setLerr] = useState("");
  const [nuU,setNuU]     = useState(""); const [nuP,setNuP] = useState("");
  const [nuN,setNuN]     = useState(""); const [nuL,setNuL] = useState("__vendedor__");
  const fRef = useRef();
  const [confirmDel,setConfirmDel] = useState(null);
  const [editProd,setEditProd]     = useState(null);
  // v5.12: subida de fotos de producto directo a Supabase Storage (bucket
  // "productos", migración v12) — reemplaza la dependencia del WordPress que
  // se dio de baja. uploadingImg guarda qué campo (img/img2/img3/img4) está
  // subiendo en este momento, para deshabilitar solo ese botón.
  const [uploadingImg,setUploadingImg] = useState(null);
  const uploadProductImage = async (file, field) => {
    if(!file) return;
    if(!editProd?.cod){ alert("Completá el código del producto antes de subir fotos."); return; }
    setUploadingImg(field);
    try{
      const ext = (file.name.split(".").pop()||"jpg").toLowerCase().replace(/[^a-z0-9]/g,"") || "jpg";
      const path = `${slugify(editProd.cod)}-${field}-${Date.now()}.${ext}`;
      const r = await fetch(`${SB_URL}/storage/v1/object/productos/${path}`, {
        method:"POST",
        headers:{ apikey:SB_KEY, Authorization:`Bearer ${SB_KEY}`, "Content-Type": file.type||"application/octet-stream", "x-upsert":"true" },
        body:file
      });
      if(!r.ok){ const t=await r.text(); throw new Error(t); }
      const url = `${SB_URL}/storage/v1/object/public/productos/${path}`;
      setEditProd(p=>({...p,[field]:url}));
    }catch(e){
      console.error("Error subiendo imagen:",e);
      alert("No se pudo subir la imagen. Probá de nuevo.");
    }finally{
      setUploadingImg(null);
    }
  };
  const [editUser,setEditUser]     = useState(null); // {idx, lista, clave}
  const [userTypeFilter,setUserTypeFilter] = useState("todos"); // todos | admin | vendedor | cliente
  const [userListaFilter,setUserListaFilter] = useState(""); // solo aplica si userTypeFilter==="cliente"
  const [copied,setCopied]         = useState(false);
  // v4.36: feedback visual (tick) para botones de copiar que manejan más de
  // un ítem a la vez (una URL por categoría, un pedido por fila en "Mis
  // pedidos") — guarda qué ítem puntual se copió último, así cada botón
  // sabe si le toca mostrar el tick a él.
  const [copiedKey,setCopiedKey] = useState(null);
  const copyWithFeedback = (text,key) => {
    navigator.clipboard.writeText(text).then(()=>{
      setCopiedKey(key);
      setTimeout(()=>setCopiedKey(k=>k===key?null:k),2000);
    });
  };

  const li     = (sess?.rol==="admin"||sess?.rol==="vendedor") ? adminLista : (sess ? sess.lista : "publico");
  const liInfo = listasPrecio.find(l=>l.key===li) || listasPrecio[0] || {key:"publico",lbl:"Precio Público"};

  // v4: precio de un producto en una lista, con fallback a la lista más próxima
  // que sí tenga precio cargado — primero hacia arriba (listas más caras/orden
  // mayor), y si ninguna de esas tiene dato, hacia abajo como último recurso.
  const precioLista = (cod, listaKey) => {
    const propios = preciosMap[cod] || {};
    if(propios[listaKey]) return propios[listaKey];
    const actual = listasPrecio.find(l=>l.key===listaKey);
    const ordenados = [...listasPrecio].filter(l=>l.key!==listaKey);
    if(actual){
      const arriba = ordenados.filter(l=>l.orden>actual.orden).sort((a,b)=>a.orden-b.orden);
      for(const l of arriba) if(propios[l.key]) return propios[l.key];
      const abajo = ordenados.filter(l=>l.orden<actual.orden).sort((a,b)=>b.orden-a.orden);
      for(const l of abajo) if(propios[l.key]) return propios[l.key];
    } else {
      for(const l of ordenados) if(propios[l.key]) return propios[l.key];
    }
    return "";
  };
  // Parsea precio argentino (1.234,56) o americano (1234.56)
  const parsePrice = v => {
    if(!v) return 0;
    const s = v.toString().replace(/^(USD|ARS|EUR|\$)\s*/i,"").trim();
    // Si tiene coma y punto: detectar cuál es decimal
    if(s.includes(",") && s.includes(".")) {
      const lastComma = s.lastIndexOf(",");
      const lastDot   = s.lastIndexOf(".");
      if(lastComma > lastDot) return parseFloat(s.replace(/\./g,"").replace(",",".")) || 0; // 1.234,56
      return parseFloat(s.replace(/,/g,"")) || 0; // 1,234.56
    }
    if(s.includes(",")) return parseFloat(s.replace(",",".")) || 0; // 1234,56
    return parseFloat(s) || 0;
  };

  // IVA tolerante: acepta 21, "21", "21%", "10,5%", "0,21". Si no se entiende, asume 21.
  const parseIva = v => {
    if(v===null||v===undefined||v==="") return 21;
    let n = typeof v==="number" ? v : parseFloat(String(v).replace(/[^\d.,-]/g,"").replace(",","."));
    if(!isFinite(n)||n<=0) return 21;
    if(n<1) n = n*100;
    return n;
  };
  const alicTxt = n => Number.isInteger(n) ? String(n) : String(n).replace(".",",");

  // Dado un array de ítems ya con brutoConPromo/iva resueltos, arma el resto del
  // desglose (ajuste de condición, neto, IVA por alícuota, total). La usan tanto
  // el carrito en vivo como los pedidos ya guardados, para que el número sea
  // siempre el mismo cálculo determinístico a partir de los mismos ítems.
  // descCodigoPct (v4.32): descuento % de un código de descuento válido (ver
  // migracion_v9_codigos_descuento.sql) — se aplica DESPUÉS del ajuste de
  // condición de pago, sobre el neto ya ajustado, y también reduce la base
  // imponible de cada alícuota de IVA proporcionalmente.
  const desglosarItems = (items, ajustePct, descCodigoPct=0) => {
    const netoBruto = items.reduce((s,i)=>s+i.brutoConPromo,0);
    const montoAjuste = netoBruto*ajustePct/100;
    const netoConCondicion = netoBruto+montoAjuste;
    const montoDescCodigo = -(netoConCondicion*descCodigoPct/100);
    const neto = netoConCondicion+montoDescCodigo;
    const porAlic = {};
    items.forEach(it=>{
      const base = it.brutoConPromo*(1+ajustePct/100)*(1-descCodigoPct/100);
      const key = it.iva;
      if(!porAlic[key]) porAlic[key] = {base:0,iva:0};
      porAlic[key].base += base;
      porAlic[key].iva  += base*(key/100);
    });
    const ivaTotal = Object.values(porAlic).reduce((s,v)=>s+v.iva,0);
    const total = neto+ivaTotal;
    return { netoBruto, montoAjuste, montoDescCodigo, neto, porAlic, ivaTotal, total };
  };

  // Motor de desglose v4: condición de pago (ajuste %) + promos (trigger→beneficio,
  // ver migracion_v4_condiciones_promos.sql) + IVA discriminado por alícuota.
  // condObj: {ajuste_pct, nombre} o null ("Sin condición"). listaActiva: key de listaMap.
  const calcularPedido = (cartItems, condObj, listaActiva, extras=[], codigoDesc=null) => {
    const items = cartItems.map(({product,qty})=>({
      cod: product.cod, nom: product.nom||product.desc, cat: product.cat||null, qty,
      precioUnit: parsePrice(gp(product)), iva: parseIva(product.iva), mon: monNativa(product.mon),
      promoPct: 0, promoNombre: null,
    }));
    const promosAplicadas = [];
    (promos||[]).filter(p=>p.activa).forEach(promo=>{
      if(Array.isArray(promo.listas) && promo.listas.length && !promo.listas.includes(listaActiva)) return;
      const reqs = Array.isArray(promo.requisitos) ? promo.requisitos : [];
      if(!reqs.length) return;
      // "veces" = cuántas veces se cumplió el requisito (comprando de a
      // req.cant). Con varios requisitos, manda el que menos veces se
      // cumple — así "2x1 llevando A y B" no se dispara si solo hay A. Un
      // requisito puede ser por código puntual (req.cod) o por categoría
      // (req.cat, cuenta la suma de todos los productos de esa categoría).
      // Antes esto era un simple sí/no, y el descuento se aplicaba a TODA
      // la cantidad del producto beneficiado sin importar cuánto se compró
      // del que dispara la promo (bug: 1 bastón "regalaba" 1500 caravanas
      // si ponías 1500 en el carrito). Ver migracion_v5_promo_cantidad.sql.
      const veces = reqs.reduce((min,req)=>{
        const cant = Number(req.cant||1);
        const qtyTotal = req.cat
          ? items.filter(i=>i.cat===req.cat).reduce((s,i)=>s+i.qty,0)
          : (items.find(i=>i.cod===req.cod)?.qty || 0);
        return Math.min(min, Math.floor(qtyTotal/cant));
      }, Infinity);
      if(!veces || !isFinite(veces) || veces<=0) return;
      const cantPorVez = Number(promo.beneficio_cant)||1;
      let tope = veces*cantPorVez;
      if(promo.beneficio_cat){
        // El beneficio es una categoría entera: el tope de unidades se
        // reparte entre los productos de esa categoría que haya en el
        // carrito (en el orden en que están), sin pisar una promo que ya
        // tenga aplicada ese ítem.
        items.filter(i=>i.cat===promo.beneficio_cat && !i.promoPct).forEach(it=>{
          if(tope<=0) return;
          const usar = Math.min(it.qty, tope);
          it.promoPct = Number(promo.beneficio_descuento_pct)||0;
          it.promoQtyBonif = usar;
          it.promoNombre = promo.nombre;
          tope -= usar;
          promosAplicadas.push({nombre:promo.nombre, cod:it.cod, descuento_pct:it.promoPct, cant:usar});
        });
      } else {
        const benef = items.find(i=>i.cod===promo.beneficio_cod);
        if(!benef || benef.promoPct) return; // no pisa una promo ya aplicada a ese ítem
        benef.promoPct = Number(promo.beneficio_descuento_pct)||0;
        benef.promoQtyBonif = Math.min(benef.qty, tope); // unidades bonificadas; el resto se cobra normal
        benef.promoNombre = promo.nombre;
        promosAplicadas.push({nombre:promo.nombre, cod:benef.cod, descuento_pct:benef.promoPct, cant:benef.promoQtyBonif});
      }
    });
    // Cargos adicionales del vendedor (visita a campo / viáticos, v4.32): se
    // agregan como ítems sin código ni categoría — por eso nunca matchean un
    // requisito ni un beneficio de promo (los .find/.filter de arriba
    // comparan por cod/cat, que acá van null) — y siempre al 21% de IVA, en
    // la misma moneda del resto del pedido.
    const monedaPedido = items[0]?.mon || monNativa("USD");
    (extras||[]).filter(e=>e.enabled && Number(e.monto)>0).forEach(e=>{
      items.push({ cod:null, nom:(e.desc||"").trim()||"Cargo adicional", cat:null, qty:1,
        precioUnit:Number(e.monto)||0, iva:21, mon:monedaPedido,
        promoPct:0, promoNombre:null, esExtra:true });
    });
    items.forEach(it=>{
      it.bruto = it.precioUnit*it.qty;
      if(it.promoPct && it.promoQtyBonif!=null){
        const qtyResto = it.qty - it.promoQtyBonif;
        it.brutoConPromo = it.precioUnit*qtyResto + it.precioUnit*it.promoQtyBonif*(1-it.promoPct/100);
      } else {
        it.brutoConPromo = it.promoPct ? it.bruto*(1-it.promoPct/100) : it.bruto;
      }
    });
    const ajustePct = condObj ? Number(condObj.ajuste_pct)||0 : 0;
    const descCodigoPct = codigoDesc ? Number(codigoDesc.descuento_pct)||0 : 0;
    const d = desglosarItems(items, ajustePct, descCodigoPct);
    return { items, ajustePct, ...d,
      promosAplicadas, moneda: items[0]?.mon||"USD", condicionNombre: condObj?.nombre||null,
      codigoDescuento: codigoDesc?.codigo||null, codigoOrigen: codigoDesc?.origen||null, descCodigoPct };
  };

  const fmtPrice = v => {
    const n = parsePrice(v);
    if(!n) return "—";
    return n.toLocaleString("es-AR", {minimumFractionDigits:2, maximumFractionDigits:2});
  };

  // Estados de pedido: un color por estado (en vez de solo "pendiente" vs
  // "el resto"), así se distingue de un vistazo dónde está cada pedido.
  const ESTADOS = {
    pendiente:  {lbl:"Pendiente",   bg:"rgba(245,158,11,.18)", fg:"#fbbf24"},
    en_proceso: {lbl:"En proceso",  bg:"rgba(59,130,246,.18)", fg:"#93c5fd"},
    listo:      {lbl:"Listo",       bg:"rgba(99,102,241,.18)", fg:"#a5b4fc"},
    completado: {lbl:"Completado",  bg:"rgba(111,207,151,.18)", fg:"#6fcf97"},
    cancelado:  {lbl:"Cancelado",   bg:"rgba(220,38,38,.18)", fg:"#fca5a5"},
  };
  const estadoInfo = e => ESTADOS[e] || ESTADOS.pendiente;

  // v4: conversión automática USD→ARS con la cotización oficial (BNA, billete
  // vendedor) vía dolarapi.com. Los precios se cargan en USD pero se muestran
  // siempre en pesos al cliente/vendedor (en el catálogo, carrito, pedido/
  // presupuesto). Se cachea por día en localStorage para que funcione offline
  // si ya se consultó hoy, y para no pegarle a la API en cada render.
  const [bnaVenta,setBnaVenta] = useState(()=>{
    try{
      const c = JSON.parse(localStorage.getItem("tmc_bna")||"null");
      const hoy = new Date().toISOString().slice(0,10);
      return (c && c.fecha===hoy) ? c.venta : null;
    }catch{ return null; }
  });
  const [bnaFecha,setBnaFecha] = useState(()=>{
    try{ return JSON.parse(localStorage.getItem("tmc_bna")||"null")?.fecha || null; }catch{ return null; }
  });
  useEffect(()=>{
    const hoy = new Date().toISOString().slice(0,10);
    try{
      const c = JSON.parse(localStorage.getItem("tmc_bna")||"null");
      if(c && c.fecha===hoy) return; // ya está fresca, no hace falta pedirla de nuevo
    }catch{}
    fetch("https://dolarapi.com/v1/dolares/oficial").then(r=>r.json()).then(d=>{
      if(d && d.venta){
        setBnaVenta(d.venta); setBnaFecha(hoy);
        try{ localStorage.setItem("tmc_bna", JSON.stringify({fecha:hoy, venta:d.venta})); }catch{}
      }
    }).catch(()=>{}); // sin conexión: se queda con lo cacheado (o sin convertir) y no rompe nada
  },[]);
  // v4.32: el pedido/presupuesto vuelve a mostrarse SIEMPRE en la moneda
  // nativa del producto (antes se convertía todo a pesos como valor
  // principal) — la conversión a pesos pasa a ser solo una leyenda de
  // referencia debajo del total. monNativa() es la etiqueta sin conversión.
  // El catálogo (gp/precioLista) ya mostraba nativo desde antes.
  const monNativa = mon => {
    const m = String(mon||"USD").toUpperCase();
    if(m==="EUR") return "EUR";
    if(m==="ARS") return "$";
    return "USD";
  };
  // Texto de referencia en pesos para un total ya en moneda nativa. Solo
  // tiene sentido si el total está en USD (convertible) y ya tenemos la
  // cotización BNA — para ARS ya es pesos, para EUR no convertimos.
  const pesoRefTxt = (total, moneda) => {
    if(moneda!=="USD" || !bnaVenta || !total) return null;
    const pesos = total*bnaVenta;
    return `≈ $ ${pesos.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})} ARS de referencia · TC BNA $${bnaVenta.toLocaleString("es-AR")}${bnaFecha?` (${new Date(bnaFecha+"T12:00:00").toLocaleDateString("es-AR")})`:""}`;
  };

  // Carousel autoplay
  useEffect(()=>{
    const hasImg = banners.some(b=>b.img);
    if(!hasImg) return;
    const t = setInterval(()=>setCarIdx(i=>(i+1)%banners.length),5000);
    return ()=>clearInterval(t);
  },[banners]);

  // Reset gallery photo when modal opens
  useEffect(()=>{ if(modal) setGalPhoto(modal.img||null); },[modal]);

  // v4: recomendar instalar la app en el celular. En Android/Chrome se puede
  // instalar con un solo toque (beforeinstallprompt); en iOS Safari no existe
  // ese evento, así que se muestran los pasos manuales. No insiste si ya la
  // instaló o si el usuario cerró el aviso una vez.
  const [installEvt,setInstallEvt] = useState(null);
  const [showInstallBar,setShowInstallBar] = useState(false);
  const [showMenu,setShowMenu] = useState(false); // menú del header (todo lo que no es catálogo ni carrito)
  const [isIOSInstall,setIsIOSInstall] = useState(false);
  useEffect(()=>{
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
    if(standalone) return;
    let dismissed = false;
    try{ dismissed = localStorage.getItem("tmc_install_dismissed")==="1"; }catch{}
    if(dismissed) return;
    const onBip = e => { e.preventDefault(); setInstallEvt(e); setShowInstallBar(true); };
    window.addEventListener("beforeinstallprompt", onBip);
    const ua = navigator.userAgent||"";
    const iOS = /iphone|ipad|ipod/i.test(ua);
    const safari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    if(iOS && safari){ setIsIOSInstall(true); setShowInstallBar(true); }
    return ()=>window.removeEventListener("beforeinstallprompt", onBip);
  },[]);
  const dismissInstall = () => { setShowInstallBar(false); try{ localStorage.setItem("tmc_install_dismissed","1"); }catch{} };

  // gp(): precio del listado/ficha de producto, en la moneda original de carga
  // (USD/ARS/EUR según la lista) — no se convierte. Desde v4.32 el pedido/
  // presupuesto también usa este valor nativo (ver calcularPedido); la
  // conversión a pesos quedó solo como leyenda de referencia (pesoRefTxt).
  const gp = p => {
    const raw = precioLista(p.cod, li);
    if(!raw) return "—";
    return fmtPrice(raw);
  };

  const cats   = [...new Set(prods.map(p=>p.cat).filter(Boolean))].sort();
  const urlApplied = useRef(false);
  // URL routing — apply once after products load from Supabase. Si la URL es
  // una de las pantallas conocidas (/admin, /tablero, etc.) navega ahí; si no,
  // la interpreta como slug de categoría, como ya hacía antes.
  useEffect(()=>{
    if(!prods.length || urlApplied.current) return;
    const path = window.location.pathname;
    if(path.startsWith("/admin")){
      setSc("admin");
      const tab = path.replace(/^\/admin\/?/,'');
      if(tab) setATab(tab);
      urlApplied.current = true;
      return;
    }
    const screenMatch = Object.entries(SCREEN_PATH).find(([,p])=>p===path);
    if(screenMatch){ setSc(screenMatch[0]); urlApplied.current = true; return; }
    const slug = path.replace(/^\/+/,'').replace(/-+/g,' ').trim();
    if(!slug) { urlApplied.current = true; return; }
    const allCats = [...new Set(prods.map(p=>p.cat).filter(Boolean))];
    const match = allCats.find(c=>normSearch(c)===normSearch(slug));
    if(match) setCats2(new Set([match]));
    urlApplied.current = true;
  },[prods]);

  // Sincroniza la URL con la pantalla activa (y con la categoría filtrada, si
  // estás en el catálogo) — así se puede compartir un link directo y anda el
  // atrás/adelante del navegador.
  useEffect(()=>{
    if(!urlApplied.current) return; // no pisar el deep-link inicial antes de aplicarlo
    let path;
    if(screen==="admin") path = `/admin/${aTab}`;
    else if(SCREEN_PATH[screen]) path = SCREEN_PATH[screen];
    else if(cats2.size===1) path = `/${slugify([...cats2][0])}`;
    else path = "/";
    if(window.location.pathname !== path) window.history.pushState({screen,aTab}, "", path);
  },[screen,cats2,aTab]);

  useEffect(()=>{
    const onPop = () => {
      const path = window.location.pathname;
      if(path.startsWith("/admin")){
        setSc("admin"); setCats2(new Set());
        const tab = path.replace(/^\/admin\/?/,'');
        if(tab) setATab(tab);
        return;
      }
      const screenMatch = Object.entries(SCREEN_PATH).find(([,p])=>p===path);
      if(screenMatch){ setSc(screenMatch[0]); setCats2(new Set()); return; }
      const slug = path.replace(/^\/+/,'').replace(/-+/g,' ').trim();
      setSc("cat");
      if(!slug){ setCats2(new Set()); return; }
      const allCats = [...new Set(prods.map(p=>p.cat).filter(Boolean))];
      const match = allCats.find(c=>normSearch(c)===normSearch(slug));
      setCats2(match ? new Set([match]) : new Set());
    };
    window.addEventListener("popstate", onPop);
    return ()=>window.removeEventListener("popstate", onPop);
  },[prods]);

  const fil = prods.filter(p=>{
    const matchCat = cats2.size===0 || cats2.has(p.cat);
    const matchQ   = !q || normSearch(p.nom||"").includes(normSearch(q)) || normSearch(p.desc||"").includes(normSearch(q)) || normSearch(p.cod||"").includes(normSearch(q));
    return matchCat && matchQ;
  });
  const groups = groupBy(fil,"cat");
  // Apply product order within each category
  Object.keys(groups).forEach(cat=>{
    const order = prodOrder[cat];
    if(order?.length) {
      groups[cat] = [...order.map(cod=>groups[cat].find(p=>p.cod===cod)).filter(Boolean),
                     ...groups[cat].filter(p=>!order.includes(p.cod))];
    }
  });
  const orderedGroups = catOrder.length
    ? [...catOrder.filter(c=>groups[c]), ...Object.keys(groups).filter(c=>!catOrder.includes(c))].map(c=>[c,groups[c]])
    : Object.entries(groups);

  const inC  = p => cart.some(x=>x.product.cod===p.cod);
  const cnt  = cart.reduce((s,i)=>s+i.qty,0);
  const add  = p => { setCart(c=>{ const e=c.find(x=>x.product.cod===p.cod); return e?c.map(x=>x.product.cod===p.cod?{...x,qty:x.qty+1}:x):[...c,{product:p,qty:1}]; }); track("agregar_carrito",{cod:p.cod,nom:p.nom,precio:gp(p),lista:li}); };
  const rm   = cd=> setCart(c=>c.filter(x=>x.product.cod!==cd));
  const upd  = (cd,q2)=>{ if(q2<=0){rm(cd);return;} setCart(c=>c.map(x=>x.product.cod===cd?{...x,qty:q2}:x)); };

  const track = (tipo, detalle={}) => {
    if(!sess) return;
    SB("actividad",{method:"POST",headers:{"Prefer":"return=minimal"},
      body:JSON.stringify({usuario:sess.u, tipo, detalle})
    }).catch(()=>{});
  };

  const doRegister = async () => {
    const {p,nom,email,tel,cuit,docTipo,loc,prov,cp} = regForm;
    const u = email.trim(); // email is the username
    const docLabel = docTipo==="dni" ? "DNI" : "C.U.I.T";
    const missing = [];
    if(!p) missing.push("contraseña");
    if(!nom) missing.push("nombre");
    if(!email) missing.push("email");
    if(!cuit) missing.push(docLabel);
    if(!prov) missing.push("provincia");
    if(missing.length) { setRegMsg(`Faltá completar: ${missing.join(", ")}`); return; }
    if(!validarEmail(email)) { setRegMsg("Ese email no parece válido — revisalo."); return; }
    if(docTipo==="dni" ? !validarDNI(cuit) : !validarCUIT(cuit)) {
      setRegMsg(docTipo==="dni" ? "El DNI no parece válido (tiene que tener 7 u 8 números)." : "El CUIT no parece válido — revisá los números.");
      return;
    }
    // v4.36: antes chequeaba contra "users" en memoria, que para un
    // visitante sin login ya no trae la tabla completa (ver migración v11) —
    // ahora pregunta puntualmente por ese usuario con existe_usuario().
    if(users.find(x=>x.u===u)) { setRegMsg("Ese email ya tiene una cuenta."); return; }
    try{
      const rExiste = await SB("rpc/existe_usuario",{method:"POST",body:JSON.stringify({p_usuario:u})});
      if(rExiste.ok){ const existe = await rExiste.json(); if(existe===true){ setRegMsg("Ese email ya tiene una cuenta."); return; } }
    }catch{}
    const hashed = await hashPwd(p);
    const newU = {id:Date.now(),u,p:hashed,nom,lista:"publico",rol:"cliente"};
    setUsers(us=>[...us,newU]);
    SB("rpc/create_user",{method:"POST",body:JSON.stringify({
      p_usuario:u,p_clave:hashed,p_nombre:nom,p_lista:"publico",p_rol:"cliente",
      p_email:email,p_telefono:tel||"",p_cuit:cuit.replace(/\D/g,""),p_localidad:loc||"",p_provincia:prov,p_cp:cp||""
    })}).catch(e=>console.error("Registro Supabase error:",e));
    setLerr(""); setUIn(u);
    setRegMsg(""); setRegForm({p:"",nom:"",email:"",tel:"",cuit:"",docTipo:"cuit",loc:"",prov:"",cp:""});
    setSc("login");
    setTimeout(()=>setLerr("OK:Cuenta creada. Ya podés ingresar."),100);
  };

  const doLogin = async () => {
    const hashed = await hashPwd(pIn);
    // Try Supabase secure login first
    try {
      const r = await SB("rpc/check_login",{method:"POST",body:JSON.stringify({p_usuario:uIn,p_clave:hashed})});
      const data = await r.json();
      if(data && data.usuario) {
        const u = {u:data.usuario,nom:data.nombre,rol:data.rol,lista:data.lista,email:data.email};
        setSess(u); saveSession(u); setSc("cat"); setLerr("");
        // Load user's orders
        SB(`pedidos_catalogo?usuario=eq.${encodeURIComponent(u.u)}&order=created_at.desc&limit=20`)
          .then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setMyOrders(d); }).catch(()=>{});
        SB("actividad",{method:"POST",headers:{"Prefer":"return=minimal"},
          body:JSON.stringify({usuario:u.u,tipo:"login",detalle:{lista:u.lista,nom:u.nom}})
        }).catch(()=>{});
        return;
      }
    } catch(e) { console.log("Supabase RPC unavailable, using local"); }
    // Fallback: local users (hardcoded admin)
    const u = users.find(x=>x.u===uIn && (x.p===hashed||x.p===pIn));
    if(u){
      setSess(u); saveSession(u); setSc("cat"); setLerr("");
      SB("actividad",{method:"POST",headers:{"Prefer":"return=minimal"},
        body:JSON.stringify({usuario:u.u,tipo:"login",detalle:{lista:u.lista,nom:u.nom}})
      }).catch(()=>{});
    } else setLerr("Usuario o contraseña incorrectos.");
  };
  const doOut = () => { setSess(null); clearSession(); setSc("cat"); setCart([]); setUIn(""); setPIn(""); setMisDatos(null); };

  /* ————————————————————————————————————————————————————————————
     Comprobante de pedido/presupuesto — mismo formato que expo.tmcagro.com
     (v4): tag PEDIDO/PRESUPUESTO, código correlativo CAT-AA-0000, logo TMC
     completo, datos de cliente, condición de pago, promos aplicadas, IVA
     discriminado por alícuota, y aviso de revisión si fue editado.
     ———————————————————————————————————————————————————————————— */
  const esc = s => String(s ?? "").replace(/[&<>]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;"}[c]));

  // Arma el objeto pedido/presupuesto: del carrito actual (antes de confirmar) o
  // de un registro ya guardado (saved). En ambos casos pasa por desglosarItems,
  // así el número que se ve en pantalla, el PDF y el mail siempre coinciden.
  const armarPedidoObj = (saved=null) => {
    if(saved){
      // El cliente/CUIT del pedido guardado se toman de quien lo generó
      // (saved.usuario/nombre_cliente), no de quien lo está mirando ahora —
      // así un admin/vendedor que reabre un pedido ve siempre al cliente
      // correcto. El CUIT se busca en vivo en la tabla de usuarios (no se
      // guarda un histórico por pedido) para reflejar el dato más actual.
      // Staff tiene la tabla completa de usuarios (users); un cliente/
      // visitante solo tiene su propio perfil (misDatos, v4.36) — si el
      // pedido guardado es el suyo, lo usa; si no, no hay CUIT para mostrar
      // (nunca fue suyo verlo, tampoco antes tenía sentido).
      const clienteRow = saved.usuario
        ? (users.find(u=>u.u===saved.usuario) || (misDatos?.u===saved.usuario ? misDatos : null))
        : null;
      const cl = saved.nombre_cliente ? `${saved.nombre_cliente} (${saved.usuario||"—"})` : (sess?`${sess.nom} (${sess.u})`:"Cliente público");
      const items = (saved.items||[]).map(it=>{
        const precioUnit = it.precioUnit!=null ? Number(it.precioUnit) : parsePrice(it.precio);
        const bruto = precioUnit*it.qty;
        const promoPct = Number(it.promoPct)||0;
        return { cod:it.cod, nom:it.nom, qty:it.qty, mon:it.mon||"USD", precioUnit,
          iva: it.iva||21, promoPct, promoNombre: it.promoNombre||null, esExtra: it.esExtra||false,
          bruto, brutoConPromo: promoPct ? bruto*(1-promoPct/100) : bruto };
      });
      const ajustePct = Number(saved.condicion_ajuste_pct)||0;
      const descCodigoPct = Number(saved.descuento_codigo_pct)||0;
      const d = desglosarItems(items, ajustePct, descCodigoPct);
      return {
        codigo: saved.codigo||null, tipo: saved.tipo||"pedido",
        revisiones: saved.ediciones?.length||0,
        cliente: cl, clienteCuit: clienteRow?.cuit||"", lista: saved.lista_lbl||liInfo.lbl, fecha: saved.created_at?new Date(saved.created_at):new Date(),
        items, ajustePct, ...d,
        promosAplicadas: saved.promos_aplicadas||[],
        moneda: items[0]?.mon||"USD", condicionNombre: saved.condicion||null,
        codigoDescuento: saved.codigo_descuento||null, descCodigoPct,
      };
    }
    const cl = sess ? `${sess.nom} (${sess.u})` : "Cliente público";
    const clienteRow = sess ? (users.find(u=>u.u===sess.u) || misDatos) : null;
    const condObj = condiciones.find(c=>c.id===condicionSel) || null;
    const calc = calcularPedido(cart.map(i=>({product:i.product,qty:i.qty})), condObj, li, puedeCargosExtra ? extraCargos : [], codigoAplicado);
    return { codigo:null, tipo, revisiones:0, cliente:cl, clienteCuit: clienteRow?.cuit||"", lista:liInfo.lbl, fecha:new Date(), ...calc };
  };

  const pedidoHTML = (p) => {
    const esPres = p.tipo === "presupuesto";
    const money = n => `${p.moneda} ${Number(n||0).toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}`;
    const filas = p.items.map(it=>`<tr>
        <td class="l">${esc(it.cod)}</td>
        <td>${esc(it.nom)}${it.promoPct>0?`<div class="mut">promo${it.promoNombre?` ${esc(it.promoNombre)}`:""} -${alicTxt(it.promoPct)}%</div>`:""}</td>
        <td class="c">${it.qty}</td>
        <td class="c">${alicTxt(it.iva)}%</td>
        <td class="r">${money(it.precioUnit)}</td>
        <td class="r">${money(it.brutoConPromo)}</td></tr>`).join("");
    const ajustes = [];
    if(p.ajustePct) ajustes.push(`<tr><td colspan="5" class="r">${esc(p.condicionNombre||"Condición")} (${p.ajustePct>0?"+":""}${alicTxt(p.ajustePct)}%)</td><td class="r">${money(p.montoAjuste)}</td></tr>`);
    if(p.descCodigoPct) ajustes.push(`<tr><td colspan="5" class="r">Código ${esc(p.codigoDescuento||"")} (-${alicTxt(p.descCodigoPct)}%)</td><td class="r">${money(p.montoDescCodigo)}</td></tr>`);
    const ivas = Object.entries(p.porAlic||{}).sort((a,b)=>Number(a[0])-Number(b[0]))
      .map(([alic,v])=>`<tr><td colspan="5" class="r">IVA ${alicTxt(Number(alic))}% <span class="mut">(sobre ${money(v.base)})</span></td><td class="r">${money(v.iva)}</td></tr>`).join("");
    return `<!doctype html><html lang="es"><head><meta charset="utf-8"><title>${esPres?"Presupuesto":"Pedido"} ${esc(p.codigo||"borrador")}</title>
<style>
  *{box-sizing:border-box} body{font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:#1e293b;margin:0;padding:24px;font-size:13px;max-width:760px;margin:0 auto}
  .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #116735;padding-bottom:12px;margin-bottom:16px}
  .logo{padding:8px 12px;background:#116735;color:#fff;border-radius:8px;font-weight:800;font-size:18px;letter-spacing:.5px}
  h1{font-size:16px;margin:0;color:#0d4d27} .doc{text-align:right} .doc .big{font-size:20px;font-weight:700}
  .tag{display:inline-block;background:${esPres?"#fef3c7":"#dcfce7"};color:${esPres?"#92400e":"#116735"};border-radius:99px;padding:2px 10px;font-size:11px;font-weight:700}
  .rev{display:inline-block;margin-left:6px;background:#eef2ff;color:#3730a3;border-radius:99px;padding:2px 10px;font-size:11px;font-weight:700}
  .cli{background:#f8fafc;border-radius:8px;padding:10px 12px;margin-bottom:14px}
  table{width:100%;border-collapse:collapse} th{text-align:left;background:#f1f5f9;padding:6px 8px;font-size:11px;text-transform:uppercase;color:#64748b}
  td{padding:6px 8px;border-bottom:1px solid #f1f5f9} .l{font-family:monospace;font-size:11px;color:#64748b} .c{text-align:center} .r{text-align:right} .mut{color:#94a3b8;font-size:11px}
  .tot td{border:0;padding:3px 8px} .tot .fin td{border-top:2px solid #cbd5e1;font-size:16px;font-weight:700;color:#116735;padding-top:8px}
  .foot{margin-top:24px;color:#94a3b8;font-size:11px;text-align:center}
  @media print{@page{margin:1.5cm}}
</style></head><body>
  <div class="head">
    <div style="display:flex;gap:10px;align-items:center"><div class="logo">TMC</div><div><h1>TMC.agro</h1><div style="font-size:11px;color:#94a3b8">catalogo.tmcagro.com</div></div></div>
    <div class="doc"><div class="tag">${esPres?"PRESUPUESTO":"PEDIDO"}</div>${p.revisiones>0?`<div class="rev">Rev. ${p.revisiones}</div>`:""}<div class="big">${esc(p.codigo||"Borrador")}</div><div style="font-size:11px;color:#94a3b8">${p.fecha.toLocaleString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})}</div></div>
  </div>
  <div class="cli"><b>${esc(p.cliente)}</b>${p.clienteCuit?`<br><span style="color:#94a3b8">CUIT/DNI:</span> ${esc(p.clienteCuit)}`:""}<br><span style="color:#94a3b8">Lista:</span> ${esc(p.lista)}${p.condicionNombre?`<br><span style="color:#94a3b8">Condición de pago:</span> ${esc(p.condicionNombre)}`:""}</div>
  <table>
    <thead><tr><th>Código</th><th>Producto</th><th class="c">Cant.</th><th class="c">IVA</th><th class="r">P. unit.</th><th class="r">Importe</th></tr></thead>
    <tbody>${filas}</tbody>
  </table>
  <table class="tot" style="margin-top:10px">
    <tr><td colspan="5" class="r">Subtotal según lista</td><td class="r">${money(p.netoBruto)}</td></tr>
    ${ajustes.join("")}
    <tr><td colspan="5" class="r"><b>Neto gravado</b></td><td class="r"><b>${money(p.neto)}</b></td></tr>
    ${ivas}
    <tr class="fin"><td colspan="5" class="r">TOTAL${esPres?" (presupuesto)":""}</td><td class="r">${money(p.total)}</td></tr>
  </table>
  <div class="foot">${esPres?"Presupuesto sin validez fiscal · sujeto a confirmación y stock.":"Comprobante interno · no válido como factura."}${pesoRefTxt(p.total,p.moneda)?`<br>${esc(pesoRefTxt(p.total,p.moneda))} (a modo de referencia, no forma parte del total).`:""}</div>
</body></html>`;
  };

  const resumenTexto = (p) => {
    const esPres = p.tipo === "presupuesto";
    const money = n => `${p.moneda} ${Number(n||0).toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}`;
    const L = [];
    L.push(`${esPres?"PRESUPUESTO":"PEDIDO"} TMC.agro${p.codigo?` ${p.codigo}`:""}${p.revisiones>0?` (Rev. ${p.revisiones})`:""}`);
    L.push(`Cliente: ${p.cliente}${p.clienteCuit?` | CUIT/DNI: ${p.clienteCuit}`:""} | ${p.lista}`);
    L.push(`Fecha: ${p.fecha.toLocaleString("es-AR")}`);
    L.push("");
    p.items.forEach(it=>L.push(`  • ${it.qty}x ${it.nom} (${it.cod}) — ${p.moneda} ${it.precioUnit.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}${it.promoPct>0?` · promo -${alicTxt(it.promoPct)}%`:""}`));
    L.push("");
    L.push(`Subtotal según lista: ${money(p.netoBruto)}`);
    if(p.ajustePct) L.push(`${p.condicionNombre||"Condición"} (${p.ajustePct>0?"+":""}${alicTxt(p.ajustePct)}%): ${money(p.montoAjuste)}`);
    if(p.descCodigoPct) L.push(`Código ${p.codigoDescuento||""} (-${alicTxt(p.descCodigoPct)}%): ${money(p.montoDescCodigo)}`);
    L.push(`Neto gravado: ${money(p.neto)}`);
    Object.entries(p.porAlic||{}).sort((a,b)=>Number(a[0])-Number(b[0])).forEach(([alic,v])=>L.push(`IVA ${alicTxt(Number(alic))}% (sobre ${money(v.base)}): ${money(v.iva)}`));
    L.push(`TOTAL: ${money(p.total)}`);
    const ref = pesoRefTxt(p.total,p.moneda);
    if(ref) L.push(`\n(${ref})`);
    return L.join("\n");
  };

  const printCart = () => {
    const p = armarPedidoObj();
    const w = window.open("","_blank","width=800,height=600");
    w.document.write(pedidoHTML(p));
    w.document.close();
    w.onload = () => { w.print(); };
    track("descarga_pdf",{items:cart.length,tipo});
  };

  const [myOrders,setMyOrders] = useState([]);
  const [showMyOrders,setShowMyOrders] = useState(false);
  const [showPromos,setShowPromos] = useState(false);
  // Vitrina de promos: visible para cliente final (lista "publico") y para
  // vendedor/admin, que ven todo lo relacionado a ventas. El resto de las
  // listas no la ve, aunque una promo pueda seguir aplicándose en su carrito
  // si el campo "listas" de la promo la incluye.
  const puedeVerVitrina = li==="publico" || sess?.rol==="admin" || sess?.rol==="vendedor";
  const promosVitrina = promos.filter(p=>p.activa && p.destacado);
  // Etiqueta de promo en la tarjeta de un producto: si es el que se
  // beneficia (más importante, se lo lleva con descuento) o si es el que
  // dispara la promo (comprándolo, otro producto sale con descuento). Solo
  // considera promos de vitrina que apliquen a la lista de precio actual.
  const promoAplicaALista = pr => !Array.isArray(pr.listas) || !pr.listas.length || pr.listas.includes(li);
  const promoBadgeFor = p => {
    const cod = p?.cod, cat = p?.cat;
    const benef = promosVitrina.find(pr=>promoAplicaALista(pr) && (pr.beneficio_cod===cod || (pr.beneficio_cat && pr.beneficio_cat===cat)));
    if(benef) return {type:"benef", pct:Number(benef.beneficio_descuento_pct)||0};
    const req = promosVitrina.find(pr=>promoAplicaALista(pr) && Array.isArray(pr.requisitos) && pr.requisitos.some(r=>r.cod===cod || (r.cat && r.cat===cat)));
    if(req) return {type:"req"};
    return null;
  };
  const [showCondiciones,setShowCondiciones] = useState(false);
  const condicionesActivas = condiciones.filter(c=>c.activa);

  // Mobile fix heredado de Rural: bloquear el scroll del fondo mientras hay un
  // drawer o modal abierto — si no, en el celular se scrollea el catálogo por
  // detrás del carrito/modal y se pierde de dónde estabas.
  useEffect(()=>{
    const anyOpen = cartOp || !!modal || !!activUser || !!editProd || showMyOrders || showPromos || showCondiciones || showPendientes || !!confirmResult;
    document.body.style.overflow = anyOpen ? "hidden" : "";
    return ()=>{ document.body.style.overflow = ""; };
  },[cartOp,modal,activUser,editProd,showMyOrders,showPromos,showCondiciones,showPendientes,confirmResult]);

  // Mail a ventas — se dispara solo cuando se confirma un PEDIDO (no un presupuesto),
  // y también cada vez que se edita un pedido ya confirmado (mismo aviso que uno nuevo).
  const enviarMailVentas = (p) => {
    const subject = encodeURIComponent(`Pedido ${p.codigo||""} TMC.agro — ${p.cliente} — ${p.fecha.toLocaleDateString("es-AR")}${p.revisiones>0?` (Rev. ${p.revisiones})`:""}`);
    const body = encodeURIComponent(`Pedido recibido desde el catálogo digital${p.revisiones>0?`\nOJO: esta es la revisión N.º ${p.revisiones} de este pedido.`:""}\n\n${resumenTexto(p)}\n\n---\ncatalogo.tmcagro.com`);
    window.open(`mailto:ventas@tmcagro.com?subject=${subject}&body=${body}`,"_blank");
  };

  const confirmarPedido = () => {
    if(!sess||!cart.length||confirmando) return;
    setConfirmando(true);
    const p = armarPedidoObj();
    const p_data = {
      tipo,
      usuario: sess.u,
      nombre_cliente: sess.nom,
      lista: li,
      items: p.items,
      subtotal: `${p.moneda} ${p.total.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}`,
      estado: "pendiente",
      condicion: p.condicionNombre,
      condicion_ajuste_pct: p.ajustePct,
      promos_aplicadas: p.promosAplicadas,
      neto: p.neto,
      iva_total: p.ivaTotal,
      total: p.total,
      codigo_descuento: p.codigoDescuento||null,
      descuento_codigo_pct: p.descCodigoPct||null,
    };
    // RPC crear_pedido: asigna el código correlativo CAT-AA-0000 de forma atómica
    // (ver migración SQL) y guarda el registro. Devuelve la fila ya con código.
    SB("rpc/crear_pedido",{method:"POST",body:JSON.stringify({p_data})})
      .then(async r=>{
        if(!r.ok){ throw new Error(await r.text()); }
        const row = await r.json();
        const saved = Array.isArray(row) ? row[0] : row;
        setMyOrders(prev=>[saved, ...prev]);
        track(tipo==="presupuesto"?"presupuesto_confirmado":"pedido_confirmado",{items:cart.length,total:p_data.subtotal,codigo:saved?.codigo});
        const pSaved = armarPedidoObj(saved);
        // El mail a ventas solo se dispara para pedidos, no para presupuestos.
        // Es un mailto: se abre la ventana pero el cliente tiene que apretar
        // "enviar" ahí — por eso el aviso de acá abajo insiste con WhatsApp
        // como forma confiable de que Ventas lo vea sí o sí.
        if(tipo==="pedido" && saved) enviarMailVentas(pSaved);
        setConfirmResult({ p: pSaved, queued: false });
      })
      .catch(e=>{
        console.error("No se pudo guardar en el momento, queda en la cola:",e);
        // Sin señal (o el servidor no respondió): no se pierde — queda guardado en
        // el celular y se sube solo apenas vuelva la conexión (o desde "Pendientes").
        setQueue(q=>[...q, {id:`${Date.now()}-${Math.random().toString(36).slice(2,7)}`, p_data, ts:Date.now()}]);
        setConfirmResult({ p, queued: true });
      })
      .finally(()=>setConfirmando(false));
    setCart([]);
    setCartOp(false);
    setTipo("pedido");
    setCondicionSel(null);
    setExtraCargos(defaultExtraCargos());
    quitarCodigoDescuento();
  };

  // v4: edición de pedidos/presupuestos ya guardados. Carga el registro de
  // nuevo en el carrito (a los precios vigentes hoy) para que se pueda
  // modificar cantidades/condición, y al guardar llama a editar_pedido() en
  // vez de crear_pedido() — esa RPC arma el log de revisiones (ver migración
  // SQL). Solo si no está cancelado.
  const startEditOrder = (o) => {
    const savedItems = Array.isArray(o.items)?o.items:[];
    // Los cargos extra (visita a campo/viáticos) no son productos reales —
    // no van al carrito, se reconstruyen aparte en extraCargos para poder
    // seguir editando monto/descripción.
    const items = savedItems.filter(it=>!it.esExtra).map(it=>{
      const prod = prods.find(p=>p.cod===it.cod) || {cod:it.cod, nom:it.nom, desc:it.nom, cat:"", mon:it.mon||"USD", iva:String(it.iva||21)};
      return {product:prod, qty:it.qty};
    });
    setCart(items);
    setTipo(o.tipo==="presupuesto" ? "presupuesto" : "pedido");
    const cond = condiciones.find(c=>c.nombre===o.condicion);
    setCondicionSel(cond?cond.id:null);
    const extrasGuardados = savedItems.filter(it=>it.esExtra);
    if(extrasGuardados.length){
      const base = defaultExtraCargos();
      extrasGuardados.forEach((it,i)=>{
        const slot = base.find(b=>!b.enabled) || null;
        const target = slot || (base.push({key:`extra_${i}`, enabled:false, desc:"", monto:""}), base[base.length-1]);
        target.enabled = true; target.desc = it.nom||""; target.monto = String(it.precioUnit||"");
      });
      setExtraCargos(base);
    } else {
      setExtraCargos(defaultExtraCargos());
    }
    // Reconstruye el código de descuento ya aplicado (si lo hubiera) para
    // seguir viéndolo/editándolo. El origen no se guarda en el pedido (solo
    // código + %), así que se muestra vacío hasta que se vuelva a validar.
    if(o.codigo_descuento){
      setCodigoAplicado({codigo:o.codigo_descuento, origen:"", descuento_pct:Number(o.descuento_codigo_pct)||0});
      setCodigoInput(o.codigo_descuento);
      setCodigoError("");
    } else {
      quitarCodigoDescuento();
    }
    setEditingOrder(o);
    setShowMyOrders(false);
    setCartOp(true);
  };
  const cancelEditOrder = () => {
    setEditingOrder(null); setCart([]); setCondicionSel(null); setCartOp(false); setExtraCargos(defaultExtraCargos()); quitarCodigoDescuento();
  };

  const guardarEdicionPedido = () => {
    if(!sess||!cart.length||!editingOrder||confirmando) return;
    setConfirmando(true);
    const condObj = condiciones.find(c=>c.id===condicionSel) || null;
    const calc = calcularPedido(cart.map(i=>({product:i.product,qty:i.qty})), condObj, li, puedeCargosExtra ? extraCargos : [], codigoAplicado);
    const p_data = {
      items: calc.items,
      subtotal: `${calc.moneda} ${calc.total.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}`,
      condicion: condObj?.nombre||null,
      condicion_ajuste_pct: calc.ajustePct,
      promos_aplicadas: calc.promosAplicadas,
      neto: calc.neto,
      iva_total: calc.ivaTotal,
      total: calc.total,
      codigo_descuento: calc.codigoDescuento||null,
      descuento_codigo_pct: calc.descCodigoPct||null,
    };
    const editId = editingOrder.id;
    SB("rpc/editar_pedido",{method:"POST",body:JSON.stringify({p_id:editId, p_data, p_editor:sess.u})})
      .then(async r=>{
        if(!r.ok) throw new Error(await r.text());
        const row = await r.json();
        const saved = Array.isArray(row) ? row[0] : row;
        setMyOrders(prev=>prev.map(o=>o.id===saved.id?saved:o));
        const p = armarPedidoObj(saved);
        track("pedido_editado",{codigo:saved?.codigo, revision:p.revisiones});
        // Mismo aviso que un pedido nuevo — pero solo si es un pedido de
        // verdad. Ahora que también se pueden editar presupuestos (v4.38),
        // no hay que avisarle a Ventas por un presupuesto sin confirmar.
        if(p.tipo==="pedido") enviarMailVentas(p);
      })
      .catch(e=>{
        console.error("No se pudo guardar la edición:",e);
        alert("No se pudo guardar la edición del pedido. Probá de nuevo cuando tengas señal.");
      })
      .finally(()=>setConfirmando(false));
    setCart([]);
    setCartOp(false);
    setEditingOrder(null);
    setCondicionSel(null);
    setExtraCargos(defaultExtraCargos());
    quitarCodigoDescuento();
    setShowMyOrders(true);
  };

  // v4.38: convertir un presupuesto ya guardado en pedido — antes no había
  // ninguna forma de hacerlo (ni admin ni vendedor podían "confirmar" un
  // presupuesto), quedaba guardado como presupuesto para siempre. Reusa el
  // mismo código (CAT-AA-0000) y, como un pedido nuevo, avisa a Ventas.
  const convertirEnPedido = (o) => {
    if(!window.confirm(`¿Convertir ${o.codigo||"este presupuesto"} en pedido? Se le va a avisar a Ventas.`)) return;
    setMyOrders(ps=>ps.map(x=>x.id===o.id?{...x,tipo:"pedido"}:x));
    SB(`pedidos_catalogo?id=eq.${o.id}`,{method:"PATCH",headers:{"Prefer":"return=minimal"},body:JSON.stringify({tipo:"pedido"})})
      .then(r=>{ if(!r.ok) throw new Error(); return r; })
      .then(()=>{
        const pConvertido = armarPedidoObj({...o, tipo:"pedido"});
        track("presupuesto_convertido",{codigo:o.codigo});
        enviarMailVentas(pConvertido);
      })
      .catch(()=>{
        setMyOrders(ps=>ps.map(x=>x.id===o.id?{...x,tipo:"presupuesto"}:x)); // revierte el optimista si falló
        alert("No se pudo convertir el presupuesto en pedido. Probá de nuevo.");
      });
  };

  const downloadExcel = () => {
    if(!sess){ setSc("login"); return; }
    track("descarga_excel", {productos: fil.length, lista: li});
    const stamp = new Date().toLocaleString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});
    // Antes esto exportaba TODAS las listas de precio en columnas, sin
    // importar qué lista tenía asignada el que descarga — un cliente de
    // Precio Público terminaba llevándose también los precios de Lista 1/2/3
    // en el Excel. Admin/vendedor sí ven todas (las necesitan para comparar),
    // pero un cliente solo se lleva la suya.
    const isStaff = sess?.rol==="admin"||sess?.rol==="vendedor";
    const listasAct = isStaff ? listasPrecio.filter(l=>l.activa) : listasPrecio.filter(l=>l.key===li && l.activa);
    const data = fil.map(p=>{
      const row = {
        "Código": p.cod||"",
        "Nombre": p.nom||p.desc||"",
        "Categoría": p.cat||"",
        "Marca": p.marca||"",
        "Moneda": p.mon||"USD",
      };
      listasAct.forEach(l=>{ const v=precioLista(p.cod,l.key); row[l.lbl] = v ? fmtPrice(v) : ""; });
      row["IVA"] = p.iva||"";
      row["Fecha descarga"] = stamp;
      row["Lista actual"] = liInfo.lbl;
      row["Cliente"] = sess?.nom||"Público";
      return row;
    });
    const ws = XLSX.utils.json_to_sheet(data);
    // Column widths
    ws["!cols"] = [{wch:12},{wch:40},{wch:20},{wch:15},{wch:8},...listasAct.map(()=>({wch:14})),{wch:8},{wch:18},{wch:16},{wch:20}];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Catálogo TMC.agro");
    XLSX.writeFile(wb, `catalogo_tmc_${li}_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  const parseR = rows => {
    if(!rows.length) return;
    const keys = Object.keys(rows[0]).map(nk);
    const incoming = rows
      .map((r,i)=>{ const n={id:Date.now()+i}; Object.entries(r).forEach(([k,v],j)=>{n[keys[j]]=v;}); return n; })
      .filter(r=>r.cod)
      .map(r=>({...r, cat:r.cat?normCat(r.cat):undefined}));
    if(!incoming.length) return;
    const known = new Set(['pp','p1','pe','p2','cod','nom','desc','cat','marca','iva','mon','img','img2','img3','img4','video','videos','id']);
    const newCols = keys.filter(k=>!known.has(k.toLowerCase().trim())&&incoming.some(p=>p[k]));
    const statusMap = new Map(incoming.map(p=>[String(p.cod), p.img ? null : "nophoto"]));
    // Store ALL columns from CSV (not just known ones) so PATCH sends them all
    const csvCols = keys.filter(k=>k!=='id');
    setPreview({rows:incoming, imgStatus:statusMap, unknownCols:newCols, acceptedCols:[], csvCols});
    setUpMsg("");
    incoming.forEach(p => {
      if(!p.img) return;
      const im = new Image();
      im.onload  = () => setPreview(pv=>{ if(!pv) return pv; const m=new Map(pv.imgStatus); m.set(String(p.cod),"ok"); return {...pv,imgStatus:m}; });
      im.onerror = () => setPreview(pv=>{ if(!pv) return pv; const m=new Map(pv.imgStatus); m.set(String(p.cod),"err"); return {...pv,imgStatus:m}; });
      setTimeout(()=> setPreview(pv=>{ if(!pv) return pv; const m=new Map(pv.imgStatus); if(m.get(String(p.cod))===null) m.set(String(p.cod),"timeout"); return {...pv,imgStatus:m}; }), 6000);
      im.src = p.img;
    });
  };

  // v4: pp/p1/pe/p2 (alias cortos del CSV) → key real de listas_precio.
  const PRICE_ALIAS_TO_KEY = {pp:"publico", p1:"lista1", pe:"especial", p2:"lista2"};

  const confirmImport = () => {
    if(!preview) return;
    const incoming = preview.rows;
    // Columnas de precio nuevas (no pp/p1/pe/p2): se crean como listas_precio nuevas,
    // ya no hace falta tocar código para que un CSV traiga una lista que no existía.
    const nuevasListas = preview.acceptedCols || [];
    if(nuevasListas.length){
      const yaExisten = new Set(listasPrecio.map(l=>l.key));
      const aCrear = nuevasListas.filter(k=>!yaExisten.has(k));
      aCrear.forEach((k,i)=>{
        const lbl = k.replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
        const orden = Math.max(0,...listasPrecio.map(l=>l.orden)) + i + 1;
        SB("listas_precio",{method:"POST",headers:{"Prefer":"return=representation"},body:JSON.stringify({key:k,lbl,orden,activa:true})})
          .then(r=>r.json()).then(d=>{ const row=Array.isArray(d)?d[0]:d; if(row) setListasPrecio(ls=>[...ls,row]); }).catch(()=>{});
      });
    }

    let upd=0, add=0;
    setProds(current => {
      const map = new Map(current.map(p=>[String(p.cod),p]));
      incoming.forEach(p => { const k=String(p.cod); if(map.has(k)){map.set(k,{...map.get(k),...p});upd++;}else{map.set(k,p);add++;} });
      const d=new Date();
      setTimeout(()=>{ setLastUp(fmtDate(d)); setUpMsg(`${incoming.length} procesados · ${upd} actualizados · ${add} nuevos · ${d.toLocaleDateString("es-AR",{day:"2-digit",month:"long",year:"numeric"})}`); },0);
      return Array.from(map.values());
    });
    const seen = new Map();
    incoming.forEach(p=>seen.set(String(p.cod),p));
    const unique = Array.from(seen.values());

    // Columnas que van al producto en sí (no son precios de lista)
    const colMap = {nom:"nom",desc:"descripcion",cat:"cat",marca:"marca",iva:"iva",mon:"mon",img:"img",img2:"img2",img3:"img3",img4:"img4",video:"video"};
    const csvCols = (preview.csvCols || Object.keys(colMap)).filter(c=>c!=='cod'&&c!=='id');
    const nuevoPreciosMap = {};

    unique.forEach(p=>{
      const row = {cod: p.cod};
      csvCols.forEach(col=>{
        if(col in PRICE_ALIAS_TO_KEY || nuevasListas.includes(col)) return; // esto va a precios_producto, no acá
        const sbCol = colMap[col];
        if(sbCol) row[sbCol] = String(p[col]||"");
        else if(col!=='id') row[col] = String(p[col]||"");
      });

      // Precios: alias conocidos (pp/p1/pe/p2) + columnas nuevas aceptadas como lista
      const listaKeysDeEsteRow = [...Object.keys(PRICE_ALIAS_TO_KEY), ...nuevasListas];
      listaKeysDeEsteRow.forEach(col=>{
        if(p[col]===undefined || p[col]==="") return;
        const listaKey = PRICE_ALIAS_TO_KEY[col] || col;
        const precio = String(p[col]);
        if(!nuevoPreciosMap[p.cod]) nuevoPreciosMap[p.cod]={};
        nuevoPreciosMap[p.cod][listaKey] = precio;
        SB("rpc/upsert_precio_producto",{method:"POST",body:JSON.stringify({p_cod:p.cod,p_lista_key:listaKey,p_precio:precio})}).catch(()=>{});
      });

      if(Object.keys(row).length<=1) return; // solo cod, nada de datos del producto para actualizar

      // Use secure RPC — works with RLS enabled
      SB("rpc/upsert_producto",{
        method:"POST",
        body:JSON.stringify({p_data: row})
      }).then(async r=>{
        if(!r.ok){ const e=await r.text(); console.error("upsert error:",r.status,e); }
      }).catch(e=>console.error("upsert fetch error:",e));
    });
    setPreciosMap(m=>{
      const upd = {...m};
      Object.entries(nuevoPreciosMap).forEach(([cod,precios])=>{ upd[cod] = {...(upd[cod]||{}), ...precios}; });
      return upd;
    });
    setPreview(null);
  };

  const downloadTemplate = () => {
    const cols = "cat,cod,nom,desc,marca,iva,mon,pp,p1,pe,p2,img,img2,img3,img4,video";
    const blob = new Blob([cols+"\n"], {type:"text/csv;charset=utf-8;"});
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "plantilla_catalogo_tmc.csv";
    a.click();
  };
  const handleF = f => {
    if(!f) return;
    const e=f.name.split(".").pop().toLowerCase();
    if(["csv","txt"].includes(e)) Papa.parse(f,{header:true,skipEmptyLines:true,delimiter:"",delimitersToGuess:[',',';','\t','|'],complete:r=>parseR(r.data)});
    else if(["xlsx","xls"].includes(e)){ const rd=new FileReader(); rd.onload=ev=>{ const wb=XLSX.read(ev.target.result,{type:"array"}); parseR(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]],{defval:""})); }; rd.readAsArrayBuffer(f); }
  };

  // Nota: estas tres comparten armarPedidoObj()/resumenTexto() con printCart, por eso
  // el texto y el PDF siempre muestran exactamente lo mismo (código, tipo, revisión).
  const sendWA = () => {
    const p = armarPedidoObj();
    track("envio_wa",{items:cart.length,tipo});
    window.open(`https://wa.me/${WA}?text=${encodeURIComponent(`Hola TMC.agro!\n\n${resumenTexto(p)}\n\n¿Tienen stock? Gracias!`)}`,"_blank");
  };

  const downloadPDF = () => {
    if(!sess){ setSc("login"); return; }
    track("descarga_catalogo_pdf",{productos:fil.length});
    window.print();
  };

  const sendMail = () => {
    const p = armarPedidoObj();
    track("envio_mail",{items:cart.length,tipo});
    enviarMailVentas(p);
  };

  const copyOrder = () => {
    const p = armarPedidoObj();
    track("copia_pedido",{items:cart.length,tipo});
    navigator.clipboard.writeText(resumenTexto(p)).then(()=>{
      setCopied(true);
      setTimeout(()=>setCopied(false),2000);
    });
  };

  const addUser = async () => {
    if(!nuU||!nuP||!nuN) return;
    if(users.find(x=>x.u===nuU)){ alert(`El usuario "${nuU}" ya existe.`); return; }
    const isVendedor = nuL === "__vendedor__";
    const isAdmin = nuL === "__admin__";
    const rol = isAdmin ? "admin" : isVendedor ? "vendedor" : "cliente";
    const lista = (isAdmin||isVendedor) ? "lista1" : nuL;
    const hashed = await hashPwd(nuP);
    const newU = {id:Date.now(),u:nuU,p:hashed,nom:nuN,lista,rol};
    setUsers(u=>[...u,newU]);
    SB("rpc/create_user",{method:"POST",body:JSON.stringify({
      p_usuario:nuU,p_clave:hashed,p_nombre:nuN,p_lista:lista,p_rol:rol
    })}).then(async r=>{ if(!r.ok){ const e=await r.text(); console.error("Error:",e); } else { console.log("✅ Usuario guardado"); } })
      .catch(e=>console.error("Supabase error:",e));
    setNuU("");setNuP("");setNuN("");setNuL("__vendedor__");
  };

  // Un ícono de línea por pestaña del panel — mismo estilo que el menú
  // hamburguesa del catálogo (monocromo, sin emoji).
  const atIcon = k => {
    const p = {width:14,height:14,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"};
    switch(k){
      case "prods":     return <svg {...p}><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>;
      case "users":     return <svg {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
      case "listas":    return <svg {...p}><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
      case "cond":      return <svg {...p}><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>;
      case "promos":    return <svg {...p}><path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l8 8a1 1 0 0 1 0 1.41z"/><line x1="7" y1="7.5" x2="7.01" y2="7.5"/></svg>;
      case "banners":   return <svg {...p}><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>;
      case "actividad": return <svg {...p}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
      case "pedidos":   return <svg {...p}><path d="M9 2h6a1 1 0 0 1 1 1v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 1-1z"/><line x1="8" y1="11" x2="16" y2="11"/><line x1="8" y1="15" x2="13" y2="15"/></svg>;
      case "codigos":   return <svg {...p}><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="6" y1="10" x2="6" y2="10.01"/><line x1="6" y1="14" x2="6" y2="14.01"/><path d="M12 10h6"/><path d="M12 14h4"/></svg>;
      case "up":        return <svg {...p}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>;
      default:          return null;
    }
  };

  // Buscador de producto para los campos "código" de una promo — en vez de
  // tipear el código a ciegas, se busca por código o nombre y se elige de una
  // lista. Función común (no componente separado) para no perder el foco del
  // input en cada tecla, mismo motivo por el que adminJSX está todo inline.
  const codPicker = (field, value, placeholder) => {
    const fkey = field==="req" ? "req_cod" : "beneficio_cod";
    const q = value.trim().toLowerCase();
    const matches = q.length>=1 ? prods.filter(p=>
      (p.cod||"").toLowerCase().includes(q) || (p.nom||p.desc||"").toLowerCase().includes(q)
    ).slice(0,8) : [];
    const found = q ? prods.find(p=>(p.cod||"").toLowerCase()===q) : null;
    return (
      <div style={{position:"relative"}}>
        <input placeholder={placeholder} value={value}
          onChange={e=>{ setNuPromo(v=>({...v,[fkey]:e.target.value})); setPromoPickOpen(field); }}
          onFocus={()=>setPromoPickOpen(field)}
          onBlur={()=>setTimeout(()=>setPromoPickOpen(p=>p===field?null:p),150)}
          style={{width:"100%",boxSizing:"border-box",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
        {q && (
          <div style={{fontSize:10,marginTop:2,color:found?"#6fcf97":"#fbbf24"}}>
            {found ? `✓ ${found.nom||found.desc}` : "No coincide con ningún producto cargado"}
          </div>
        )}
        {promoPickOpen===field && matches.length>0 && (
          <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:20,background:"#232323",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:7,marginTop:2,maxHeight:200,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,.15)"}}>
            {matches.map(p=>(
              <div key={p.cod} onMouseDown={()=>{ setNuPromo(v=>({...v,[fkey]:p.cod})); setPromoPickOpen(null); }}
                style={{padding:"7px 10px",fontSize:11.5,cursor:"pointer",borderBottom:"1px solid rgba(255,255,255,.08)"}}>
                <span style={{fontWeight:700,color:"#6fcf97"}}>{p.cod}</span> — {p.nom||p.desc}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Toggle "Producto" / "Categoría" para elegir cómo se define el disparador
  // o el beneficio de una promo.
  const tipoToggle = (value, onChange) => (
    <div style={{display:"flex",gap:4,marginBottom:5}}>
      {[["cod","Producto"],["cat","Categoría"]].map(([k,l])=>(
        <button key={k} type="button" onClick={()=>onChange(k)}
          style={{background:value===k?"#116735":"rgba(255,255,255,.06)",color:value===k?"#fff":"#c0c0c0",border:"none",borderRadius:5,padding:"3px 10px",fontSize:10.5,fontWeight:700,cursor:"pointer"}}>
          {l}
        </button>
      ))}
    </div>
  );

  // Selector de categoría para el disparador/beneficio de una promo por
  // categoría (a diferencia de codPicker, que busca un producto puntual).
  const catPicker = (value, onChange) => (
    <select value={value} onChange={e=>onChange(e.target.value)}
      style={{width:"100%",boxSizing:"border-box",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12,fontFamily:"var(--mf)",background:"#232323"}}>
      <option value="">Elegir categoría...</option>
      {cats.map(c=><option key={c} value={c}>{c}</option>)}
    </select>
  );

  // ADMIN JSX (inlined to avoid focus-loss remount bug)
  const adminJSX = screen==="admin"&&sess?.rol==="admin" && (
    <div className="aw">
      <div className="att">Configuraciones</div>
      <div className="ats">
        {[["prods","Productos"],["users","Usuarios"],["listas","Listas de precio"],["cond","Condiciones"],["promos","Promos"],["codigos","Códigos"],["banners","Banners"],["actividad","Actividad"],["pedidos","Pedidos"],["up","Importar"]].map(([k,l])=>(
          <button key={k} className={`at ${aTab===k?"on":""}`} onClick={()=>setATab(k)}>{atIcon(k)}{l}</button>
        ))}
      </div>

      {aTab==="prods"&&(
        <div className="ac">
          <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{prods.length} productos · <span style={{fontWeight:400,color:"#c0c0c0"}}>click para editar</span></span>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
              <select value={adminCatFilter} onChange={e=>setAdminCatFilter(e.target.value)}
                style={{border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"5px 10px",fontFamily:"var(--mf)",fontSize:12,outline:"none",background:"#232323"}}>
                <option value="">Todas las categorías</option>
                {cats.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
              <input placeholder="Buscar..." onChange={e=>setQ(e.target.value)} style={{border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"5px 10px",fontFamily:"var(--mf)",fontSize:12,outline:"none",width:160}}/>
            </div>
          </div>
          {adminCatFilter && <div style={{padding:"6px 14px",background:"rgba(111,207,151,.15)",borderBottom:"1px solid rgba(255,255,255,.15)",fontSize:11,color:"#6fcf97",fontWeight:600}}>
            Arrastrá los productos para cambiar el orden en el catálogo
          </div>}
          <div style={{maxHeight:520,overflowY:"auto"}}>
            <table className="atb">
              <thead><tr><th style={{width:30}}></th><th style={{width:50}}>Img</th><th>Código</th><th>Nombre</th><th>Categoría</th><th style={{width:120}}>Precio Público</th><th style={{width:40}}></th></tr></thead>
              <tbody>{(()=>{
                let filtered = prods.filter(p=>
                  (!adminCatFilter||p.cat===adminCatFilter)&&
                  (!q||(p.nom||"").toLowerCase().includes(q.toLowerCase())||(p.cod||"").toLowerCase().includes(q.toLowerCase()))
                );
                // Apply prod order for the selected category
                if(adminCatFilter && prodOrder[adminCatFilter]?.length) {
                  const order = prodOrder[adminCatFilter];
                  filtered = [...order.map(cod=>filtered.find(p=>p.cod===cod)).filter(Boolean),
                              ...filtered.filter(p=>!order.includes(p.cod))];
                }
                let dragProd = null;
                return filtered.map((p,i)=>(
                  <tr key={i} className="tr-edit"
                    draggable={!!adminCatFilter}
                    onDragStart={()=>{ dragProd=p.cod; }}
                    onDragOver={e=>e.preventDefault()}
                    onDrop={()=>{
                      if(!dragProd||dragProd===p.cod) return;
                      const catProds = adminCatFilter
                        ? prods.filter(x=>x.cat===adminCatFilter).map(x=>x.cod)
                        : prods.map(x=>x.cod);
                      const curOrder = prodOrder[adminCatFilter]?.length ? prodOrder[adminCatFilter] : catProds;
                      const arr = [...new Set([...curOrder, ...catProds])];
                      const fromIdx = arr.indexOf(dragProd);
                      const toIdx = arr.indexOf(p.cod);
                      if(fromIdx<0||toIdx<0) return;
                      const newArr = [...arr];
                      const [moved] = newArr.splice(fromIdx,1);
                      newArr.splice(toIdx,0,moved);
                      const newProdOrder = {...prodOrder,[adminCatFilter]:newArr};
                      setProdOrder(newProdOrder);
                      SB("configuracion",{method:"POST",headers:{"Prefer":"resolution=merge-duplicates"},
                        body:JSON.stringify({clave:"prod_order",valor:newProdOrder})
                      }).catch(()=>{});
                      dragProd=null;
                    }}
                    onClick={()=>setEditProd({...p, _origCod:p.cod, _precios:{...(preciosMap[p.cod]||{})}})}>
                    <td style={{cursor:adminCatFilter?"grab":"default",color:"#888",textAlign:"center"}}>
                      {adminCatFilter ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg> : ""}
                    </td>
                    <td><div onClick={e=>e.stopPropagation()}>{p.img?<img src={p.img} style={{width:40,height:40,borderRadius:5,objectFit:"cover",border:"1px solid rgba(255,255,255,.15)"}} alt="" onError={e=>e.target.src=NO_IMG}/>:<img src={NO_IMG} style={{width:40,height:40,borderRadius:5,objectFit:"contain",border:"1px solid rgba(255,255,255,.15)"}} alt=""/>}</div></td>
                    <td><span style={{fontSize:11,fontWeight:700,color:"#6fcf97",background:"rgba(111,207,151,.15)",padding:"2px 6px",borderRadius:4}}>{p.cod||"—"}</span></td>
                    <td style={{fontWeight:600,fontSize:12.5,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.nom||p.desc}</td>
                    <td style={{fontSize:12,color:"#c0c0c0"}}>{p.cat||"—"}</td>
                    <td style={{fontFamily:"var(--bf)",fontWeight:800,fontSize:15}}>{p.mon||"USD"} {fmtPrice(precioLista(p.cod,"publico"))}</td>
                    <td onClick={e=>e.stopPropagation()}>
                      {confirmDel===("admin-"+p.cod)
                        ? <div style={{display:"flex",gap:3}}>
                            <button onClick={()=>{
                              if(!p.cod){ return; }
                              setProds(ps=>ps.filter(x=>x.cod!==p.cod));
                              SB(`productos?cod=eq.${encodeURIComponent(p.cod)}`,{method:"DELETE"}).catch(()=>{});
                              setConfirmDel(null);
                            }} style={{background:"#c0392b",color:"#fff",border:"none",borderRadius:4,padding:"3px 7px",fontSize:11,fontWeight:700,cursor:"pointer"}}>✓</button>
                            <button onClick={()=>setConfirmDel(null)} style={{background:"rgba(111,207,151,.15)",color:"#c0c0c0",border:"none",borderRadius:4,padding:"3px 7px",fontSize:11,cursor:"pointer"}}>✗</button>
                          </div>
                        : <button className="adl" onClick={()=>setConfirmDel("admin-"+p.cod)}>✕</button>
                      }
                    </td>
                  </tr>
                ));
              })()}</tbody>
            </table>
          </div>
        </div>
      )}
      {aTab==="users"&&(()=>{
        const counts = {
          todos: users.length,
          admin: users.filter(u=>u.rol==="admin").length,
          vendedor: users.filter(u=>u.rol==="vendedor").length,
          cliente: users.filter(u=>u.rol!=="admin"&&u.rol!=="vendedor").length,
        };
        const filteredUsers = users
          .map((u,i)=>({u,i}))
          .filter(({u})=>{
            if(userTypeFilter==="admin") return u.rol==="admin";
            if(userTypeFilter==="vendedor") return u.rol==="vendedor";
            if(userTypeFilter==="cliente") return u.rol!=="admin"&&u.rol!=="vendedor"&&(!userListaFilter||u.lista===userListaFilter);
            return true;
          });
        return (<>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center",marginBottom:10}}>
          {[["todos","Todos"],["admin","Admin"],["vendedor","Vendedor"],["cliente","Cliente"]].map(([k,l])=>(
            <button key={k} onClick={()=>{ setUserTypeFilter(k); if(k!=="cliente") setUserListaFilter(""); }}
              style={{background:userTypeFilter===k?"#116735":"rgba(111,207,151,.15)",color:userTypeFilter===k?"#fff":"#6fcf97",border:"none",borderRadius:6,padding:"5px 12px",fontSize:11.5,fontWeight:700,cursor:"pointer",fontFamily:"var(--mf)"}}>
              {l} <span style={{opacity:.75}}>({counts[k]})</span>
            </button>
          ))}
          {userTypeFilter==="cliente" && (
            <select value={userListaFilter} onChange={e=>setUserListaFilter(e.target.value)}
              style={{border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"5px 8px",fontSize:11.5,fontFamily:"var(--mf)",outline:"none",background:"#232323",color:"#f9fffc"}}>
              <option value="">Todas las listas</option>
              {listasPrecio.map(l=><option key={l.key} value={l.key}>{l.lbl}</option>)}
            </select>
          )}
        </div>
        <div className="ac">
          <table className="atb">
            <thead><tr><th>Usuario</th><th>Nombre</th><th>Lista</th><th>Clave</th><th style={{width:32}}></th><th></th></tr></thead>
            <tbody>{filteredUsers.length===0
              ? <tr><td colSpan={6} style={{textAlign:"center",padding:24,color:"#999",fontSize:12.5}}>No hay usuarios para este filtro.</td></tr>
              : filteredUsers.map(({u,i})=>(
              <tr key={i}>
                <td style={{fontWeight:700,fontFamily:"monospace",fontSize:12}}>{u.u}</td>
                <td style={{fontSize:12}}>{u.nom}</td>
                <td>
                  {editUser?.idx===i ? (
                    <select value={editUser.lista} onChange={e=>setEditUser(eu=>({...eu,lista:e.target.value}))}
                      style={{border:"1.5px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 6px",fontSize:12,fontFamily:"var(--mf)",outline:"none"}}>
                      <option value="__vendedor__">Vendedor</option>
                      {listasPrecio.map(l=><option key={l.key} value={l.key}>{l.lbl}</option>)}
                    </select>
                  ) : (
                    <span className={`tl ${u.lista||u.rol}`}>{u.rol==="vendedor"?"Vendedor":u.rol==="admin"?"Admin":listasPrecio.find(l=>l.key===u.lista)?.lbl||u.lista}</span>
                  )}
                </td>
                <td>
                  {editUser?.idx===i ? (
                    <input value={editUser.clave} onChange={e=>setEditUser(eu=>({...eu,clave:e.target.value}))}
                      placeholder="Nueva clave" style={{border:"1.5px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 6px",fontSize:12,width:100,fontFamily:"var(--mf)",outline:"none"}}/>
                  ) : (
                    <span style={{fontSize:11,color:"#999"}}>••••••</span>
                  )}
                </td>
                <td>
                  <button onClick={()=>setActivUser(u)} title="Ver datos del cliente"
                    style={{background:"none",border:"1px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 6px",cursor:"pointer",color:"#6fcf97",display:"inline-flex",alignItems:"center"}}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                  </button>
                </td>
                <td style={{whiteSpace:"nowrap"}}>
                  {u.rol!=="admin" && (
                    editUser?.idx===i ? (
                      <div style={{display:"flex",gap:4}}>
                        <button onClick={async ()=>{
                          const isVend = editUser.lista==="__vendedor__";
                          const newLista = isVend?"lista1":editUser.lista;
                          const newRol   = isVend?"vendedor":"cliente";
                          let newHash = null;
                          if(editUser.clave){ newHash = await hashPwd(editUser.clave); }
                          setUsers(us=>us.map((x,j)=>j===i?{...x,lista:newLista,rol:newRol,...(newHash?{p:newHash}:{})}:x));
                          SB("rpc/update_user",{method:"POST",body:JSON.stringify({
                            p_admin_usuario:"admin",
                            p_admin_clave:"d6aa7749ff88903b983b9535a4a0bde0966c240dbdd7f1d5d3e6c0c36809d209",
                            p_usuario:u.u, p_lista:newLista, p_rol:newRol,
                            ...(newHash?{p_clave:newHash}:{})
                          })}).catch(()=>{});
                          setEditUser(null);
                        }} style={{background:"#116735",color:"#fff",border:"none",borderRadius:4,padding:"3px 8px",fontSize:11,fontWeight:700,cursor:"pointer"}}>✓</button>
                        <button onClick={()=>setEditUser(null)} style={{background:"rgba(111,207,151,.15)",color:"#c0c0c0",border:"none",borderRadius:4,padding:"3px 7px",fontSize:11,cursor:"pointer"}}>✗</button>
                      </div>
                    ) : (
                      <div style={{display:"flex",gap:4}}>
                        <button onClick={()=>setEditUser({idx:i,lista:u.rol==="vendedor"?"__vendedor__":u.lista,clave:""})}
                          style={{background:"rgba(111,207,151,.15)",color:"#6fcf97",border:"1px solid rgba(255,255,255,.15)",borderRadius:4,padding:"3px 8px",fontSize:11,cursor:"pointer",display:"inline-flex",alignItems:"center"}}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        </button>
                        <button className="adl" onClick={()=>{
                          if(!window.confirm(`¿Eliminar usuario "${u.u}"?`)) return;
                          setUsers(us=>us.filter((_,j)=>j!==i));
                          // Antes esto borraba directo contra la tabla "usuarios" con
                          // el anon key — RLS lo bloquea (401), así que en la base
                          // nunca se borraba nada aunque en la pantalla sí desaparecía.
                          // Ahora pasa por una RPC segura, igual que crear/editar.
                          SB("rpc/delete_user",{method:"POST",body:JSON.stringify({
                            p_admin_usuario:"admin",
                            p_admin_clave:"d6aa7749ff88903b983b9535a4a0bde0966c240dbdd7f1d5d3e6c0c36809d209",
                            p_usuario:u.u
                          })}).catch(()=>{});
                        }}>✕</button>
                      </div>
                    )
                  )}
                </td>
              </tr>
            ))}</tbody>
          </table>
        </div>
        <div style={{background:"rgba(111,207,151,.15)",borderRadius:9,padding:"14px 16px"}}>
          <div style={{fontSize:12.5,fontWeight:700,color:"#6fcf97",marginBottom:9}}>+ Nuevo usuario</div>
          <div className="ur">
            <input className="ui" placeholder={(nuL==="__admin__"||nuL==="__vendedor__")?"Usuario":"Email del cliente (va a ser su usuario)"} value={nuU} onChange={e=>setNuU(e.target.value.replace(/\s/g,""))}/>
            <input className="ui" placeholder="Contraseña" value={nuP} onChange={e=>setNuP(e.target.value)}/>
            <input className="ui" placeholder="Nombre / Empresa" value={nuN} onChange={e=>setNuN(e.target.value)}/>
            <select className="us" value={nuL} onChange={e=>setNuL(e.target.value)}>
              <option value="__admin__">Admin (acceso total)</option>
              <option value="__vendedor__">Vendedor (todas las listas)</option>
              {listasPrecio.map(l=>(
                <option key={l.key} value={l.key}>{l.lbl}</option>
              ))}
            </select>
            <button className="ua" onClick={addUser}>+ Agregar</button>
          </div>
          <div className="tip">Para clientes, usá su email como usuario — así coincide con lo que usan si se registran ellos mismos. Hacé clic en el ícono de lápiz para cambiar la lista o resetear la clave de cualquier usuario. Los admin no se pueden editar/eliminar desde acá, por seguridad.</div>
        </div>
        </>);
      })()}
      {aTab==="listas"&&(
        <div className="ac">
          <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)"}}>
            <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{listasPrecio.length} listas de precio</span>
          </div>
          <div style={{padding:"6px 14px",background:"rgba(111,207,151,.15)",borderBottom:"1px solid rgba(255,255,255,.15)",fontSize:11,color:"#6fcf97",fontWeight:600}}>
            Arrastrá para ordenar la jerarquía · si a un producto le falta precio en una lista, se usa el de la lista más cercana (primero probando hacia arriba en este orden, después hacia abajo)
          </div>
          <div style={{padding:14}}>
            {(()=>{
              let dragIdx = null;
              const saveOrder = arr => {
                const withOrden = arr.map((l,i)=>({...l,orden:i+1}));
                setListasPrecio(withOrden);
                withOrden.forEach(l=>{ SB(`listas_precio?key=eq.${encodeURIComponent(l.key)}`,{method:"PATCH",body:JSON.stringify({orden:l.orden})}).catch(()=>{}); });
              };
              return listasPrecio.map((l,i)=>(
                <div key={l.key}
                  draggable
                  onDragStart={()=>{ dragIdx=i; }}
                  onDragOver={e=>e.preventDefault()}
                  onDrop={()=>{
                    if(dragIdx===null||dragIdx===i) return;
                    const arr=[...listasPrecio];
                    const [moved]=arr.splice(dragIdx,1);
                    arr.splice(i,0,moved);
                    saveOrder(arr);
                    dragIdx=null;
                  }}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",marginBottom:5,background:"#191919",border:"1px solid rgba(255,255,255,.15)",borderRadius:7,cursor:"grab",userSelect:"none"}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                  <span style={{fontSize:12,color:"#999",minWidth:18}}>{i+1}</span>
                  {editLista?.key===l.key ? (
                    <input autoFocus defaultValue={l.lbl} onBlur={e=>{
                      const lbl=e.target.value.trim()||l.lbl;
                      setListasPrecio(ls=>ls.map(x=>x.key===l.key?{...x,lbl}:x));
                      SB(`listas_precio?key=eq.${encodeURIComponent(l.key)}`,{method:"PATCH",body:JSON.stringify({lbl})}).catch(()=>{});
                      setEditLista(null);
                    }} onKeyDown={e=>{ if(e.key==="Enter") e.target.blur(); }}
                      style={{flex:1,fontSize:13,border:"1px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 8px",outline:"none"}}/>
                  ) : (
                    <span style={{flex:1,fontSize:13,color:"#f9fffc",fontWeight:500,cursor:"text"}} onClick={()=>setEditLista({key:l.key})}>{l.lbl}</span>
                  )}
                  <span style={{fontSize:10,color:"#888",fontFamily:"monospace"}}>{l.key}</span>
                  <label style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:"#c0c0c0",cursor:"pointer"}}>
                    <input type="checkbox" checked={l.activa!==false} onChange={e=>{
                      const activa=e.target.checked;
                      setListasPrecio(ls=>ls.map(x=>x.key===l.key?{...x,activa}:x));
                      SB(`listas_precio?key=eq.${encodeURIComponent(l.key)}`,{method:"PATCH",body:JSON.stringify({activa})}).catch(()=>{});
                    }}/> Activa
                  </label>
                  <button onClick={()=>{
                    if(!window.confirm(`¿Eliminar la lista "${l.lbl}"? Los precios cargados para esta lista también se van a borrar.`)) return;
                    setListasPrecio(ls=>ls.filter(x=>x.key!==l.key));
                    SB(`listas_precio?key=eq.${encodeURIComponent(l.key)}`,{method:"DELETE"}).catch(()=>{});
                  }} style={{background:"none",border:"none",color:"#b9c4bd",cursor:"pointer",fontSize:13}}>✕</button>
                </div>
              ));
            })()}
          </div>
          <div style={{padding:"10px 14px",borderTop:"1px solid rgba(255,255,255,.15)",display:"flex",gap:8,flexWrap:"wrap"}}>
            <input placeholder="Nombre de la nueva lista (ej: Mayorista)" value={nuLista} onChange={e=>setNuLista(e.target.value)}
              style={{flex:1,minWidth:180,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <button onClick={()=>{
              const lbl=nuLista.trim(); if(!lbl) return;
              let key = lbl.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-z0-9]+/g,"_").replace(/^_+|_+$/g,"");
              if(!key) return;
              if(listasPrecio.some(l=>l.key===key)) key = `${key}_${Date.now().toString(36)}`;
              const orden = Math.max(0,...listasPrecio.map(l=>l.orden||0)) + 1;
              SB("listas_precio",{method:"POST",headers:{"Prefer":"return=representation"},body:JSON.stringify({key,lbl,orden,activa:true})})
                .then(async r=>{ if(!r.ok) throw new Error(await r.text()); return r.json(); })
                .then(d=>{ const row=Array.isArray(d)?d[0]:d; if(row) setListasPrecio(ls=>[...ls,row]); setNuLista(""); })
                .catch(e=>{ console.error("No se pudo crear la lista:",e); alert("No se pudo agregar la lista de precios:\n\n"+e.message); });
            }} style={{background:"#116735",color:"#fff",border:"none",borderRadius:6,padding:"6px 14px",fontSize:12,fontWeight:600,cursor:"pointer"}}>+ Agregar lista</button>
          </div>
        </div>
      )}
      {aTab==="cond"&&(
        <div className="ac">
          <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)"}}>
            <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{condiciones.length} condiciones de pago</span>
          </div>
          <div style={{padding:"6px 14px",background:"rgba(111,207,151,.15)",borderBottom:"1px solid rgba(255,255,255,.15)",fontSize:11,color:"#6fcf97",fontWeight:600}}>
            Arrastrá para ordenar (mismo orden en el que aparecen en el carrito)
          </div>
          <table className="atb">
            <thead><tr><th style={{width:24}}></th><th>Nombre / descripción</th><th style={{width:110}}>Ajuste %</th><th style={{width:60}}>Activa</th><th style={{width:36}}></th></tr></thead>
            <tbody>{(()=>{
              // v4.38: arrastrar y soltar para reordenar — mismo patrón que
              // "listas de precio" y las categorías (dragIdx + splice al
              // soltar), en vez de las flechas ▲▼ que no andaban bien.
              const ordenadas = [...condiciones].sort((a,b)=>(Number(a.orden)||0)-(Number(b.orden)||0) || String(a.nombre||"").localeCompare(String(b.nombre||"")));
              let dragIdx = null;
              const saveOrder = arr => {
                const withOrden = arr.map((c,i)=>({...c,orden:i+1}));
                setCondiciones(cs=>{
                  const porId = Object.fromEntries(withOrden.map(c=>[c.id,c.orden]));
                  return cs.map(x=>porId[x.id]!=null ? {...x,orden:porId[x.id]} : x);
                });
                withOrden.forEach(c=>{ SB(`condiciones?id=eq.${encodeURIComponent(c.id)}`,{method:"PATCH",body:JSON.stringify({orden:c.orden})}).catch(()=>{}); });
              };
              // v4.39: guarda un campo suelto (nombre/notas/ajuste_pct/activa)
              // y, si falla, avisa — antes fallaba en silencio y parecía que
              // "no se podía editar" cuando en realidad el cambio no se
              // guardaba nunca.
              const patchCampo = (c,campo,valor,label) => {
                setCondiciones(cs=>cs.map(x=>x.id===c.id?{...x,[campo]:valor}:x));
                SB(`condiciones?id=eq.${encodeURIComponent(c.id)}`,{method:"PATCH",body:JSON.stringify({[campo]:valor})})
                  .then(r=>{ if(!r.ok) throw new Error(); })
                  .catch(()=>alert(`No se pudo guardar el cambio en "${label}". Probá de nuevo.`));
              };
              return ordenadas.map((c,idx)=>(
              <tr key={c.id}
                draggable
                onDragStart={()=>{ dragIdx=idx; }}
                onDragOver={e=>e.preventDefault()}
                onDrop={()=>{
                  if(dragIdx===null||dragIdx===idx) return;
                  const arr=[...ordenadas];
                  const [moved]=arr.splice(dragIdx,1);
                  arr.splice(idx,0,moved);
                  saveOrder(arr);
                  dragIdx=null;
                }}
                style={{cursor:"grab"}}>
                <td>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                </td>
                <td>
                  <input key={`nom_${c.id}`} defaultValue={c.nombre} placeholder="Nombre"
                    onBlur={e=>{ const v=e.target.value.trim(); if(v!==c.nombre) patchCampo(c,"nombre",v,"nombre"); }}
                    style={{border:"none",background:"transparent",fontSize:12.5,fontWeight:600,width:"100%",outline:"none"}}/>
                  <input key={`notas_${c.id}`} defaultValue={c.notas||""} placeholder="Descripción (opcional)"
                    onBlur={e=>{ const v=e.target.value; if(v!==(c.notas||"")) patchCampo(c,"notas",v,"descripción"); }}
                    style={{border:"none",background:"transparent",fontSize:11,color:"#999",width:"100%",outline:"none",marginTop:2}}/>
                </td>
                <td>
                  <input key={`aj_${c.id}`} type="number" step="0.5" defaultValue={c.ajuste_pct}
                    onBlur={e=>{ const v=parseFloat(e.target.value)||0; if(v!==(Number(c.ajuste_pct)||0)) patchCampo(c,"ajuste_pct",v,"ajuste %"); }}
                    style={{border:"1px solid rgba(255,255,255,.1)",borderRadius:5,padding:"3px 6px",width:70,fontSize:12}}/>
                </td>
                <td style={{textAlign:"center"}}>
                  <input type="checkbox" checked={c.activa} onChange={e=>patchCampo(c,"activa",e.target.checked,"activa")}/>
                </td>
                <td>
                  <button onClick={()=>{
                    if(!window.confirm(`¿Eliminar "${c.nombre}"?`)) return;
                    setCondiciones(cs=>cs.filter(x=>x.id!==c.id));
                    if(condicionSel===c.id) setCondicionSel(null);
                    SB(`condiciones?id=eq.${encodeURIComponent(c.id)}`,{method:"DELETE"})
                      .then(r=>{ if(!r.ok) throw new Error(); })
                      .catch(()=>alert(`No se pudo eliminar "${c.nombre}". Probá de nuevo.`));
                  }} style={{background:"none",border:"none",color:"#b9c4bd",cursor:"pointer",fontSize:13}}>✕</button>
                </td>
              </tr>
              ));
            })()}</tbody>
          </table>
          <div style={{padding:"10px 14px",borderTop:"1px solid rgba(255,255,255,.15)",display:"flex",gap:8,flexWrap:"wrap"}}>
            <input placeholder="Nombre (ej: Contado)" value={nuCond.nombre} onChange={e=>setNuCond(v=>({...v,nombre:e.target.value}))}
              style={{flex:1,minWidth:140,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <input type="number" step="0.5" placeholder="Ajuste %" value={nuCond.ajuste_pct} onChange={e=>setNuCond(v=>({...v,ajuste_pct:e.target.value}))}
              style={{width:100,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <button onClick={()=>{
              const nombre=nuCond.nombre.trim(); if(!nombre) return;
              const ajuste_pct=parseFloat(nuCond.ajuste_pct)||0;
              // v4.34: antes esto no chequeaba r.ok — si el POST fallaba (por
              // ejemplo por RLS), igual tomaba el cuerpo del error como si
              // fuera la fila creada y la metía en la lista: aparecía una
              // línea vacía que desaparecía al refrescar (porque nunca se
              // guardó de verdad). Ahora se valida la respuesta y, si falla,
              // se avisa con el motivo real en vez de fallar en silencio.
              // v4.37: "id" es texto sin default en esta tabla — hay que
              // mandarlo nosotros (ver diagnostico_condiciones_id.sql).
              // v4.38: orden = siguiente al máximo actual (no length), para
              // que quede al final aunque ya se hayan reordenado con las
              // flechas y los valores de "orden" no sean 0..n-1 correlativos.
              const nuevoOrden = condiciones.length ? Math.max(...condiciones.map(c=>Number(c.orden)||0))+1 : 0;
              SB("condiciones",{method:"POST",headers:{"Prefer":"return=representation"},body:JSON.stringify({id:genId(),nombre,ajuste_pct,activa:true,orden:nuevoOrden})})
                .then(async r=>{ if(!r.ok) throw new Error(await r.text()); return r.json(); })
                .then(d=>{ const row=Array.isArray(d)?d[0]:d; if(row) setCondiciones(cs=>[...cs,row]); setNuCond({nombre:"",ajuste_pct:""}); })
                .catch(e=>{ console.error("No se pudo crear la condición:",e); alert("No se pudo agregar la condición de pago:\n\n"+e.message); });
            }} style={{background:"#116735",color:"#fff",border:"none",borderRadius:6,padding:"6px 14px",fontSize:12,fontWeight:600,cursor:"pointer"}}>+ Agregar</button>
          </div>
        </div>
      )}
      {aTab==="promos"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div className="ac">
            <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)"}}>
              <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{promos.length} promos</span>
            </div>
            <table className="atb">
              <thead><tr><th>Nombre</th><th>Si compra</th><th>Beneficia a</th><th style={{width:56}}>Cant.</th><th style={{width:70}}>Desc. %</th><th style={{width:70}}>Vitrina</th><th style={{width:60}}>Activa</th><th style={{width:36}}></th></tr></thead>
              <tbody>{promos.map(pr=>{
                const req = Array.isArray(pr.requisitos)&&pr.requisitos[0] ? pr.requisitos[0] : {cod:"",cant:1};
                return (
                <tr key={pr.id}>
                  <td style={{fontSize:12,fontWeight:600}}>{pr.nombre}</td>
                  <td style={{fontSize:11,color:"#c0c0c0"}}>{req.cant}x {req.cat?<>cat: <b>{req.cat}</b></>:req.cod}</td>
                  <td style={{fontSize:11,color:"#c0c0c0"}}>{pr.beneficio_cat?<>cat: <b>{pr.beneficio_cat}</b></>:pr.beneficio_cod}</td>
                  <td>
                    <input type="number" min="1" value={pr.beneficio_cant||1} onChange={e=>{
                      const beneficio_cant=parseInt(e.target.value)||1;
                      setPromos(ps=>ps.map(x=>x.id===pr.id?{...x,beneficio_cant}:x));
                      SB(`promos_catalogo?id=eq.${pr.id}`,{method:"PATCH",body:JSON.stringify({beneficio_cant})}).catch(()=>{});
                    }} style={{width:44,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 5px",fontSize:11,fontFamily:"var(--mf)"}}/>
                  </td>
                  <td style={{fontSize:12,fontWeight:700,color:"#6fcf97"}}>-{pr.beneficio_descuento_pct}%</td>
                  <td style={{textAlign:"center"}}>
                    <input type="checkbox" checked={!!pr.destacado} onChange={e=>{
                      const destacado=e.target.checked;
                      setPromos(ps=>ps.map(x=>x.id===pr.id?{...x,destacado}:x));
                      SB(`promos_catalogo?id=eq.${pr.id}`,{method:"PATCH",body:JSON.stringify({destacado})}).catch(()=>{});
                    }}/>
                  </td>
                  <td style={{textAlign:"center"}}>
                    <input type="checkbox" checked={pr.activa} onChange={e=>{
                      const activa=e.target.checked;
                      setPromos(ps=>ps.map(x=>x.id===pr.id?{...x,activa}:x));
                      SB(`promos_catalogo?id=eq.${pr.id}`,{method:"PATCH",body:JSON.stringify({activa})}).catch(()=>{});
                    }}/>
                  </td>
                  <td>
                    <button onClick={()=>{
                      if(!window.confirm(`¿Eliminar promo "${pr.nombre}"?`)) return;
                      setPromos(ps=>ps.filter(x=>x.id!==pr.id));
                      SB(`promos_catalogo?id=eq.${pr.id}`,{method:"DELETE"}).catch(()=>{});
                    }} style={{background:"none",border:"none",color:"#b9c4bd",cursor:"pointer",fontSize:13}}>✕</button>
                  </td>
                </tr>
                );
              })}</tbody>
            </table>
          </div>

          <div className="ac" style={{padding:14}}>
            <div style={{fontSize:11,fontWeight:700,color:"#6fcf97",textTransform:"uppercase",letterSpacing:.7,marginBottom:10}}>Nueva promo</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <input placeholder="Nombre de la promo" value={nuPromo.nombre} onChange={e=>setNuPromo(v=>({...v,nombre:e.target.value}))}
                style={{gridColumn:"1 / -1",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>

              <div>
                <div style={{fontSize:9,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>Si compra</div>
                {tipoToggle(nuPromo.req_tipo, t=>setNuPromo(v=>({...v,req_tipo:t})))}
                {nuPromo.req_tipo==="cat"
                  ? catPicker(nuPromo.req_cat, c=>setNuPromo(v=>({...v,req_cat:c})))
                  : codPicker("req", nuPromo.req_cod, "Buscar por código o nombre")}
                {nuPromo.req_tipo==="cat" && <div style={{fontSize:9.5,color:"#999",marginTop:2}}>Cuenta la suma de cualquier producto de esa categoría en el carrito.</div>}
              </div>
              <div>
                <div style={{fontSize:9,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>Cantidad mínima</div>
                <input type="number" min="1" value={nuPromo.req_cant} onChange={e=>setNuPromo(v=>({...v,req_cant:e.target.value}))}
                  style={{width:"100%",boxSizing:"border-box",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
              </div>

              <div>
                <div style={{fontSize:9,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>Se beneficia</div>
                {tipoToggle(nuPromo.benef_tipo, t=>setNuPromo(v=>({...v,benef_tipo:t})))}
                {nuPromo.benef_tipo==="cat"
                  ? catPicker(nuPromo.beneficio_cat, c=>setNuPromo(v=>({...v,beneficio_cat:c})))
                  : codPicker("benef", nuPromo.beneficio_cod, "Buscar por código o nombre")}
                {nuPromo.benef_tipo==="cat" && <div style={{fontSize:9.5,color:"#999",marginTop:2}}>El descuento se reparte entre los productos de esa categoría que haya en el carrito, hasta el tope de unidades de al lado.</div>}
              </div>
              <div>
                <div style={{fontSize:9,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>Descuento %</div>
                <input type="number" step="1" value={nuPromo.beneficio_descuento_pct} onChange={e=>setNuPromo(v=>({...v,beneficio_descuento_pct:e.target.value}))}
                  style={{width:"100%",boxSizing:"border-box",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
              </div>
              <div style={{gridColumn:"1 / -1"}}>
                <div style={{fontSize:9,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>
                  {nuPromo.benef_tipo==="cat" ? "Tope total de unidades bonificadas (para toda la categoría)" : "Cant. bonificada por vez"}
                </div>
                <input type="number" min="1" value={nuPromo.beneficio_cant} onChange={e=>setNuPromo(v=>({...v,beneficio_cant:e.target.value}))}
                  style={{width:160,boxSizing:"border-box",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
                <div style={{fontSize:9.5,color:"#999",marginTop:2}}>
                  {nuPromo.benef_tipo==="cat"
                    ? "Por cada vez que se cumple \"si compra\", se suma este tope de unidades bonificadas en total, repartidas entre los productos de la categoría beneficiada. El resto se cobra a precio normal."
                    : "Cuántas unidades del producto beneficiado se bonifican cada vez que se cumple \"si compra\". El resto se cobra a precio normal."}
                </div>
              </div>
            </div>
            <div style={{fontSize:10,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.5,marginBottom:5}}>Listas donde aplica (ninguna marcada = todas)</div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:8}}>
              {listasPrecio.map(l=>(
                <label key={l.key} style={{display:"flex",alignItems:"center",gap:5,fontSize:11.5,color:"#555",cursor:"pointer"}}>
                  <input type="checkbox" checked={nuPromo.listas.includes(l.key)} onChange={e=>{
                    setNuPromo(v=>({...v,listas: e.target.checked ? [...v.listas,l.key] : v.listas.filter(x=>x!==l.key)}));
                  }}/> {l.lbl}
                </label>
              ))}
            </div>
            <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11.5,color:"#555",cursor:"pointer",marginBottom:10}}>
              <input type="checkbox" checked={nuPromo.destacado} onChange={e=>setNuPromo(v=>({...v,destacado:e.target.checked}))}/>
              Mostrar en la vitrina de promociones
            </label>
            <button onClick={()=>{
              const nombre=nuPromo.nombre.trim();
              const reqVal = nuPromo.req_tipo==="cat" ? nuPromo.req_cat.trim() : nuPromo.req_cod.trim();
              const benefVal = nuPromo.benef_tipo==="cat" ? nuPromo.beneficio_cat.trim() : nuPromo.beneficio_cod.trim();
              const beneficio_descuento_pct=parseFloat(nuPromo.beneficio_descuento_pct)||0;
              if(!nombre||!reqVal||!benefVal||!beneficio_descuento_pct){ alert(`Completá nombre, ${nuPromo.req_tipo==="cat"?"categoría":"código"} disparador, ${nuPromo.benef_tipo==="cat"?"categoría":"código"} beneficiado y % de descuento.`); return; }
              const body = {
                nombre, beneficio_descuento_pct,
                beneficio_cod: nuPromo.benef_tipo==="cat" ? null : benefVal,
                beneficio_cat: nuPromo.benef_tipo==="cat" ? benefVal : null,
                beneficio_cant: parseInt(nuPromo.beneficio_cant)||1,
                requisitos: [nuPromo.req_tipo==="cat" ? {cat:reqVal, cant:parseInt(nuPromo.req_cant)||1} : {cod:reqVal, cant:parseInt(nuPromo.req_cant)||1}],
                listas: nuPromo.listas.length ? nuPromo.listas : null,
                destacado: nuPromo.destacado, activa: true,
              };
              SB("promos_catalogo",{method:"POST",headers:{"Prefer":"return=representation"},body:JSON.stringify(body)})
                .then(async r=>{ if(!r.ok) throw new Error(await r.text()); return r.json(); })
                .then(d=>{ const row=Array.isArray(d)?d[0]:d; if(row) setPromos(ps=>[...ps,row]); setNuPromo(NUEVA_PROMO); })
                .catch(e=>{ console.error("No se pudo crear la promo:",e); alert("No se pudo crear la promo:\n\n"+e.message); });
            }} style={{background:"#116735",color:"#fff",border:"none",borderRadius:6,padding:"8px 16px",fontSize:12.5,fontWeight:700,cursor:"pointer"}}>+ Crear promo</button>
          </div>
        </div>
      )}
      {aTab==="codigos"&&(()=>{
        if(!codigosAdmin.length) SB("rpc/listar_codigos_descuento",{method:"POST",body:"{}"}).then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setCodigosAdmin(d); }).catch(()=>{});
        return (
        <div className="ac">
          <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{codigosAdmin.length} códigos de descuento</span>
            <button onClick={()=>SB("rpc/listar_codigos_descuento",{method:"POST",body:"{}"}).then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setCodigosAdmin(d); })} style={{background:"rgba(111,207,151,.15)",border:"none",borderRadius:5,padding:"4px 10px",fontSize:11,fontWeight:600,color:"#6fcf97",cursor:"pointer"}}>↻ Actualizar</button>
          </div>
          <table className="atb">
            <thead><tr><th>Código</th><th>Origen</th><th style={{width:90}}>Desc. %</th><th style={{width:60}}>Activo</th><th style={{width:36}}></th></tr></thead>
            <tbody>{codigosAdmin.map(c=>(
              <tr key={c.id}>
                <td style={{fontSize:12,fontWeight:700,fontFamily:"monospace",color:"#6fcf97"}}>{c.codigo}</td>
                <td>
                  <input defaultValue={c.origen||""} placeholder="¿De quién viene?" onBlur={e=>{
                    const origen=e.target.value;
                    setCodigosAdmin(cs=>cs.map(x=>x.id===c.id?{...x,origen}:x));
                    SB("rpc/actualizar_codigo_descuento",{method:"POST",body:JSON.stringify({p_id:c.id,p_codigo:c.codigo,p_origen:origen,p_descuento_pct:c.descuento_pct,p_activo:c.activo})}).catch(()=>{});
                  }} style={{border:"none",background:"transparent",fontSize:12.5,width:"100%",outline:"none"}}/>
                </td>
                <td>
                  <input type="number" step="1" min="0" max="100" defaultValue={c.descuento_pct} onBlur={e=>{
                    const descuento_pct=parseFloat(e.target.value)||0;
                    setCodigosAdmin(cs=>cs.map(x=>x.id===c.id?{...x,descuento_pct}:x));
                    SB("rpc/actualizar_codigo_descuento",{method:"POST",body:JSON.stringify({p_id:c.id,p_codigo:c.codigo,p_origen:c.origen,p_descuento_pct:descuento_pct,p_activo:c.activo})}).catch(()=>{});
                  }} style={{border:"1px solid rgba(255,255,255,.1)",borderRadius:5,padding:"3px 6px",width:70,fontSize:12}}/>
                </td>
                <td style={{textAlign:"center"}}>
                  <input type="checkbox" checked={c.activo} onChange={e=>{
                    const activo=e.target.checked;
                    setCodigosAdmin(cs=>cs.map(x=>x.id===c.id?{...x,activo}:x));
                    SB("rpc/actualizar_codigo_descuento",{method:"POST",body:JSON.stringify({p_id:c.id,p_codigo:c.codigo,p_origen:c.origen,p_descuento_pct:c.descuento_pct,p_activo:activo})}).catch(()=>{});
                  }}/>
                </td>
                <td>
                  <button onClick={()=>{
                    if(!window.confirm(`¿Eliminar el código "${c.codigo}"?`)) return;
                    setCodigosAdmin(cs=>cs.filter(x=>x.id!==c.id));
                    SB("rpc/eliminar_codigo_descuento",{method:"POST",body:JSON.stringify({p_id:c.id})}).catch(()=>{});
                  }} style={{background:"none",border:"none",color:"#b9c4bd",cursor:"pointer",fontSize:13}}>✕</button>
                </td>
              </tr>
            ))}</tbody>
          </table>
          <div style={{padding:"10px 14px",borderTop:"1px solid rgba(255,255,255,.15)",display:"flex",gap:8,flexWrap:"wrap"}}>
            <input placeholder="Código (ej: MAXI10)" value={nuCodigoAdmin.codigo} onChange={e=>setNuCodigoAdmin(v=>({...v,codigo:e.target.value}))}
              style={{flex:1,minWidth:120,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <input placeholder="Origen (¿de quién viene?)" value={nuCodigoAdmin.origen} onChange={e=>setNuCodigoAdmin(v=>({...v,origen:e.target.value}))}
              style={{flex:1,minWidth:140,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <input type="number" step="1" min="0" max="100" placeholder="Desc. % (opcional)" value={nuCodigoAdmin.descuento_pct} onChange={e=>setNuCodigoAdmin(v=>({...v,descuento_pct:e.target.value}))}
              style={{width:140,border:"1.5px solid rgba(255,255,255,.15)",borderRadius:6,padding:"6px 10px",fontSize:12}}/>
            <button onClick={()=>{
              const codigo=nuCodigoAdmin.codigo.trim(); if(!codigo) return;
              const descuento_pct=parseFloat(nuCodigoAdmin.descuento_pct)||0;
              SB("rpc/crear_codigo_descuento",{method:"POST",body:JSON.stringify({p_codigo:codigo,p_origen:nuCodigoAdmin.origen||"",p_descuento_pct:descuento_pct})})
                .then(async r=>{ if(!r.ok) throw new Error(await r.text()); return r.json(); })
                .then(d=>{ const row=Array.isArray(d)?d[0]:d; if(row&&row.id) setCodigosAdmin(cs=>[row,...cs]); setNuCodigoAdmin({codigo:"",origen:"",descuento_pct:""}); })
                .catch(()=>alert("No se pudo crear el código (¿ya existe?)."));
            }} style={{background:"#116735",color:"#fff",border:"none",borderRadius:6,padding:"6px 14px",fontSize:12,fontWeight:600,cursor:"pointer"}}>+ Agregar</button>
          </div>
          <div style={{padding:"0 14px 12px",fontSize:10.5,color:"#999"}}>Un % en 0 sirve solo para trackear de dónde viene el pedido, sin aplicar descuento.</div>
        </div>
        );
      })()}
      {aTab==="pedidos"&&(()=>{
        if(!allPedidos.length) SB("pedidos_catalogo?select=*&order=created_at.desc&limit=100").then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setAllPedidos(d); }).catch(()=>{});
        return (
          <div className="ac">
            <div style={{padding:"8px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:12,fontWeight:600,color:"#6fcf97"}}>{allPedidos.length} pedidos confirmados</span>
              <button onClick={()=>SB("pedidos_catalogo?select=*&order=created_at.desc&limit=100").then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setAllPedidos(d); })} style={{background:"rgba(111,207,151,.15)",border:"none",borderRadius:5,padding:"4px 10px",fontSize:11,fontWeight:600,color:"#6fcf97",cursor:"pointer"}}>↻ Actualizar</button>
            </div>
            <div style={{maxHeight:520,overflowY:"auto"}}>
              {allPedidos.map((o,i)=>(
                <div key={i} style={{borderBottom:"1px solid rgba(111,207,151,.3)",padding:"12px 16px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                    <div>
                      <span style={{fontWeight:700,fontSize:13,color:"#f9fffc"}}>{o.nombre_cliente||o.usuario}</span>
                      <span style={{fontSize:11,color:"#999",marginLeft:8}}>{o.usuario}</span>
                      <span style={{fontSize:11,color:"#999",marginLeft:8}}>{new Date(o.created_at).toLocaleString("es-AR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</span>
                      {o.codigo_descuento && <span style={{fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:10,marginLeft:8,background:"rgba(111,207,151,.15)",color:"#6fcf97",fontFamily:"monospace"}}>{o.codigo_descuento}</span>}
                    </div>
                    <div style={{display:"flex",gap:6,alignItems:"center"}}>
                      <span style={{fontWeight:700,color:"#6fcf97",fontSize:13}}>{o.subtotal}</span>
                      <select value={o.estado||"pendiente"} onChange={e=>{
                        const nuevoEstado = e.target.value;
                        setAllPedidos(ps=>ps.map((p,j)=>j===i?{...p,estado:nuevoEstado}:p));
                        SB(`pedidos_catalogo?id=eq.${o.id}`,{method:"PATCH",headers:{"Prefer":"return=minimal"},body:JSON.stringify({estado:nuevoEstado})}).catch(()=>{});
                      }} style={{border:"1.5px solid "+estadoInfo(o.estado).bg,borderRadius:20,padding:"3px 10px",fontSize:11,fontWeight:700,fontFamily:"var(--mf)",outline:"none",background:estadoInfo(o.estado).bg,color:estadoInfo(o.estado).fg,cursor:"pointer"}}>
                        <option value="pendiente">Pendiente</option>
                        <option value="en_proceso">En proceso</option>
                        <option value="listo">Listo</option>
                        <option value="completado">Completado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    </div>
                  </div>
                  <div style={{fontSize:11,color:"#c0c0c0"}}>
                    {(Array.isArray(o.items)?o.items:[]).map((it,j)=>(
                      <span key={j} style={{marginRight:12}}>{it.qty}x {it.nom}{it.esExtra?" (cargo)":""} ({it.mon||"USD"} {Number(it.precioUnit||0).toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})})</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })()}
      {aTab==="actividad"&&(()=>{
        if(!activ.length) SB("actividad?select=*&order=created_at.desc&limit=200").then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setActiv(d); }).catch(()=>{});
        const tipoLabel = {login:"Login",vista_producto:"Vista producto",agregar_carrito:"Carrito",descarga_pdf:"PDF",descarga_excel:"Excel",envio_wa:"WhatsApp",envio_mail:"Email",copia_pedido:"Copia"};
        const thirtyDaysAgo = new Date(Date.now() - 30*24*60*60*1000).toISOString();
        const recentLogins = activ.filter(a=>a.tipo==="login" && a.created_at >= thirtyDaysAgo);
        const uniqueLogins = new Set(recentLogins.map(a=>a.usuario)).size;
        const vistas = activ.filter(a=>a.tipo==="vista_producto").length;
        const carritos = activ.filter(a=>a.tipo==="agregar_carrito").length;
        const descargas = activ.filter(a=>a.tipo==="descarga_pdf"||a.tipo==="descarga_excel").length;
        const prodCount = {};
        activ.filter(a=>a.tipo==="vista_producto").forEach(a=>{ const k=a.detalle?.nom||a.detalle?.cod||"?"; prodCount[k]=(prodCount[k]||0)+1; });
        const topProds = Object.entries(prodCount).sort((a,b)=>b[1]-a[1]).slice(0,5);
        const stats = [
          {lb:"Usuarios únicos\n(30 días)",val:uniqueLogins,tipos:["login"]},
          {lb:"Vistas",val:vistas,tipos:["vista_producto"]},
          {lb:"Al carrito",val:carritos,tipos:["agregar_carrito"]},
          {lb:"Descargas",val:descargas,tipos:["descarga_pdf","descarga_excel"]},
        ];
        const activFil = activFilter
          ? activ.filter(a=>stats.find(s=>s.lb===activFilter)?.tipos.includes(a.tipo))
          : activ;
        return (
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
              {stats.map(({lb,val,tipos})=>{
                const active = activFilter===lb;
                return (
                  <div key={lb} onClick={()=>setActivFilter(active?null:lb)}
                    style={{background:active?"#116735":"rgba(111,207,151,.15)",borderRadius:9,padding:"10px 12px",textAlign:"center",cursor:"pointer",transition:"all .15s",border:active?"2px solid #0d4f27":"2px solid transparent"}}>
                    <div style={{fontSize:22,fontWeight:800,fontFamily:"var(--bf)",color:active?"#fff":"#6fcf97"}}>{val}</div>
                    <div style={{fontSize:11,color:active?"rgba(255,255,255,.8)":"#c0c0c0",whiteSpace:"pre-line"}}>{lb}</div>
                  </div>
                );
              })}
            </div>
            {topProds.length>0&&<div style={{background:"#232323",border:"1px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 14px"}}>
              <div style={{fontSize:11,fontWeight:700,color:"#6fcf97",textTransform:"uppercase",letterSpacing:.7,marginBottom:8}}>Top productos más vistos</div>
              {topProds.map(([nom,cnt])=>(
                <div key={nom} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,.08)"}}>
                  <span style={{color:"#f9fffc"}}>{nom}</span>
                  <span style={{fontWeight:700,color:"#6fcf97"}}>{cnt} vistas</span>
                </div>
              ))}
            </div>}
            <div className="ac">
              <div style={{padding:"8px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:12,fontWeight:600,color:"#6fcf97"}}>
                  {activFilter ? <><span style={{cursor:"pointer",marginRight:6,color:"#6fcf97"}} onClick={()=>setActivFilter(null)}>← Todos</span>{activFilter}: {activFil.length} eventos</> : `Últimos ${activ.length} eventos`}
                </span>
                <button onClick={()=>SB("actividad?select=*&order=created_at.desc&limit=200").then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setActiv(d); })} style={{background:"rgba(111,207,151,.15)",border:"none",borderRadius:5,padding:"4px 10px",fontSize:11,fontWeight:600,color:"#6fcf97",cursor:"pointer"}}>↻ Actualizar</button>
              </div>
              <div style={{maxHeight:320,overflowY:"auto"}}>
                <table className="atb">
                  <thead><tr><th>Tipo</th><th>Usuario</th><th>Detalle</th><th>Fecha</th></tr></thead>
                  <tbody>{activFil.map((a,i)=>(
                    <tr key={i}>
                      <td style={{whiteSpace:"nowrap",fontSize:11}}>{tipoLabel[a.tipo]||a.tipo}</td>
                      <td style={{fontWeight:600,fontFamily:"monospace",fontSize:12,cursor:"pointer",color:"#6fcf97",textDecoration:"underline"}}
                        onClick={()=>{
                          const u = users.find(x=>x.u===a.usuario);
                          setActivUser(u ? {...u, usuario:a.usuario} : {usuario:a.usuario});
                        }}>{a.usuario}</td>
                      <td style={{fontSize:11,color:"#c0c0c0",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                        {a.tipo==="agregar_carrito"
                          ? `${a.detalle?.nom||a.detalle?.cod||"?"} — ${a.detalle?.precio||""} (${a.detalle?.lista||""})`
                          : a.detalle?.nom||a.detalle?.cod||JSON.stringify(a.detalle||{})}
                      </td>
                      <td style={{fontSize:11,color:"#999",whiteSpace:"nowrap"}}>{new Date(a.created_at).toLocaleString("es-AR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            </div>
          </div>
        );
      })()}
      {aTab==="banners"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* CATEGORY ORDER */}
          <div style={{background:"#232323",border:"1px solid rgba(255,255,255,.15)",borderRadius:9,padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#6fcf97",textTransform:"uppercase",letterSpacing:.7,marginBottom:4}}>Orden de categorías</div>
            <div style={{fontSize:11,color:"#999",marginBottom:10}}>Arrastrá las categorías para cambiar el orden</div>
            {(()=>{
              const allCats = [...new Set(prods.map(p=>p.cat).filter(Boolean))];
              const ordered = catOrder.length
                ? [...catOrder.filter(c=>allCats.includes(c)), ...allCats.filter(c=>!catOrder.includes(c))]
                : allCats;
              const saveCatOrder = arr => {
                setCatOrder(arr);
                SB("configuracion",{method:"POST",headers:{"Prefer":"resolution=merge-duplicates"},
                  body:JSON.stringify({clave:"cat_order",valor:arr})
                }).catch(()=>{});
              };
              let dragIdx = null;
              return ordered.map((cat,i)=>(
                <div key={cat}
                  draggable
                  onDragStart={()=>{ dragIdx=i; }}
                  onDragOver={e=>e.preventDefault()}
                  onDrop={()=>{
                    if(dragIdx===null||dragIdx===i) return;
                    const arr=[...ordered];
                    const [moved]=arr.splice(dragIdx,1);
                    arr.splice(i,0,moved);
                    saveCatOrder(arr);
                    dragIdx=null;
                  }}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"7px 10px",marginBottom:4,background:"#191919",border:"1px solid rgba(255,255,255,.15)",borderRadius:7,cursor:"grab",userSelect:"none"}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                  <span style={{fontSize:12,color:"#999",minWidth:18}}>{i+1}</span>
                  <span style={{flex:1,fontSize:13,color:"#f9fffc",fontWeight:500}}>{cat}</span>
                </div>
              ));
            })()}
          </div>
          <div style={{background:"#232323",border:"1px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#6fcf97",textTransform:"uppercase",letterSpacing:.7,marginBottom:8}}>URLs por categoría (para compartir)</div>
            {[...new Set(prods.map(p=>p.cat).filter(Boolean))].sort().map(cat=>{
              const slug = slugify(cat);
              const url = `${window.location.origin}/${slug}`;
              return (
                <div key={cat} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:"1px solid rgba(255,255,255,.08)",fontSize:12}}>
                  <span style={{color:"#f9fffc"}}>{cat}</span>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{color:"#999",fontSize:11}}>{url}</span>
                    <button onClick={()=>copyWithFeedback(url,`caturl_${cat}`)} style={{background:copiedKey===`caturl_${cat}`?"#116735":"rgba(111,207,151,.15)",border:"none",borderRadius:4,padding:"2px 8px",fontSize:10,color:copiedKey===`caturl_${cat}`?"#fff":"#6fcf97",cursor:"pointer",fontWeight:600,display:"inline-flex",alignItems:"center",gap:3}}>
                      {copiedKey===`caturl_${cat}` && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                      {copiedKey===`caturl_${cat}`?"Copiado":"Copiar"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{fontSize:12.5,color:"#c0c0c0",background:"rgba(111,207,151,.15)",borderRadius:8,padding:"10px 14px",lineHeight:1.7}}>
            <strong>Tamaño recomendado: 1440 × 480 px</strong> · Formato JPG o PNG · Máx 500KB · Subí las imágenes a Google Drive y pegá el link convertido (<code>uc?export=view&id=...</code>)
          </div>
          {banners.map((b,i)=>(
            <div key={i} style={{background:"#232323",border:"1px solid rgba(255,255,255,.15)",borderRadius:10,overflow:"hidden"}}>
              <div style={{background:"#191919",padding:"8px 14px",fontSize:12,fontWeight:700,color:"#6fcf97",borderBottom:"1px solid rgba(255,255,255,.15)"}}>Banner {i+1}</div>
              <div style={{padding:"12px 14px",display:"flex",flexDirection:"column",gap:8}}>
                {b.img && <img src={b.img} alt="" style={{width:"100%",height:80,objectFit:"cover",borderRadius:6,border:"1px solid rgba(255,255,255,.15)"}} onError={e=>e.target.style.display="none"}/>}
                <input className="ui" placeholder="URL de la imagen (Drive o directo)" value={b.img}
                  onChange={e=>setBanners(bs=>bs.map((x,j)=>j===i?{...x,img:e.target.value}:x))}/>
                <input className="ui" placeholder="Link al hacer clic (opcional)" value={b.link}
                  onChange={e=>setBanners(bs=>bs.map((x,j)=>j===i?{...x,link:e.target.value}:x))}/>
              </div>
            </div>
          ))}
        </div>
      )}
      {aTab==="up"&&(<>
        {upMsg&&<div className="sok">{upMsg}</div>}
        {!preview ? (<>
          <div className="ubox" onClick={()=>fRef.current.click()}>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#8fbf9e" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{margin:"0 auto 8px"}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            <h3>Subir Excel o CSV</h3>
            <p>Columnas: <code>cat</code> <code>cod</code> <code>nom</code> <code>desc</code> <code>marca</code> <code>iva</code> <code>pp</code> <code>p1</code> <code>pe</code> <code>p2</code> <code>mon</code> <code>img</code> <code>img2</code> <code>img3</code> <code>img4</code> <code>video</code></p>
          </div>
          <button onClick={downloadTemplate} style={{background:"rgba(111,207,151,.15)",color:"#6fcf97",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:7,padding:"8px 16px",fontFamily:"var(--mf)",fontSize:12,fontWeight:700,cursor:"pointer",marginTop:8}}>
            Descargar plantilla CSV
          </button>
          <input ref={fRef} type="file" accept=".csv,.xlsx,.xls" style={{display:"none"}} onChange={e=>handleF(e.target.files[0])}/>
          <div className="tip">
            <strong>Códigos únicos:</strong> si el código ya existe, actualiza; si es nuevo, agrega.<br/>
            <strong>Monedas:</strong> columna <code>mon</code> acepta <code>USD</code>, <code>ARS</code> o <code>EUR</code>. Precios en formato <code>1.234,56</code> o <code>1234.56</code>, ambos funcionan.
          </div>
        </>) : (()=>{
          const rows = preview.rows;
          const st   = preview.imgStatus;
          const pending = [...st.values()].filter(v=>v===null).length;
          const ok      = [...st.values()].filter(v=>v==="ok").length;
          const err     = [...st.values()].filter(v=>v==="err"||v==="timeout").length;
          const noPhoto = [...st.values()].filter(v=>v==="nophoto").length;
          const existCods = new Set(prods.map(p=>String(p.cod)));
          return (
            <div className="pw">
              <div className="pb">
                <span className="pt2">Vista previa — {rows.length} productos</span>
                <div className="ps">
                  {pending>0&&<span><span className="sp2">⟳</span> {pending} validando</span>}
                  {ok>0&&<span style={{color:"#6fcf97",fontWeight:700}}>✓ {ok} OK</span>}
                  {err>0&&<span style={{color:"#f87171",fontWeight:700}}>✗ {err} error</span>}
                  {noPhoto>0&&<span>{noPhoto} sin foto</span>}
                </div>
              </div>
              <div className="psc">
                <table className="ptb">
                  <thead><tr>
                    {preview.csvCols?.includes("img") && <th>Foto</th>}
                    <th>Estado</th>
                    <th>Código</th>
                    {preview.csvCols?.includes("nom") && <th>Nombre</th>}
                    {(preview.csvCols||[]).filter(c=>!["cod","img","nom","desc","id"].includes(c)).map(c=>(
                      <th key={c} style={{textTransform:"capitalize"}}>{c.replace(/_/g," ")}</th>
                    ))}
                    <th>Acción</th>
                  </tr></thead>
                  <tbody>{rows.map((p,i)=>{
                    const s = st.get(String(p.cod));
                    const isExist = existCods.has(String(p.cod));
                    return (
                      <tr key={i} style={{background:s==="err"||s==="timeout"?"#2a1616":""}}>
                        {preview.csvCols?.includes("img") && <td>{s==="ok"?<img src={p.img} className="ip" alt=""/>:<img src={NO_IMG} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>}</td>}
                        <td>
                          {s===null      && <span className="sp2" style={{color:"#999"}}>⟳</span>}
                          {s==="ok"      && <span style={{color:"#6fcf97",fontWeight:700}}>✓</span>}
                          {s==="err"     && <span style={{color:"#f87171",fontWeight:700}}>✗ <span style={{fontSize:10,fontWeight:400}}>inválido</span></span>}
                          {s==="timeout" && <span style={{color:"#f87171",fontWeight:700}}>! <span style={{fontSize:10,fontWeight:400}}>timeout</span></span>}
                          {s==="nophoto" && <span style={{color:"#888"}}>—</span>}
                        </td>
                        <td><span className="cbadge2">{p.cod}</span></td>
                        {preview.csvCols?.includes("nom") && <td style={{fontSize:12,fontWeight:600,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.nom||p.desc}</td>}
                        {(preview.csvCols||[]).filter(c=>!["cod","img","nom","desc","id"].includes(c)).map(c=>(
                          <td key={c} style={{fontSize:12,color:"#6fcf97",fontWeight:600}}>{p[c]||"—"}</td>
                        ))}
                        <td><span style={{fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:4,background:isExist?"rgba(59,130,246,.18)":"rgba(111,207,151,.18)",color:isExist?"#93c5fd":"#6fcf97"}}>{isExist?"Actualiza":"Nuevo"}</span></td>
                      </tr>
                    );
                  })}</tbody>
                </table>
              </div>
              {err>0&&<div style={{background:"#2a1616",padding:"9px 14px",fontSize:12,color:"#f87171",borderTop:"1px solid rgba(220,38,38,.3)"}}>
                {err} foto{err>1?"s":""} con error — se importan igual sin foto hasta que corrijas el link.
              </div>}
              {preview.unknownCols?.length>0&&(
                <div style={{background:"rgba(245,158,11,.12)",padding:"12px 14px",borderTop:"1px solid rgba(245,158,11,.3)"}}>
                  <div style={{fontSize:12,fontWeight:700,color:"#fbbf24",marginBottom:8}}>
                    Se detectaron columnas desconocidas. ¿Son listas de precios?
                  </div>
                  {preview.unknownCols.map(col=>(
                    <div key={col} style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
                      <span style={{fontSize:12,fontFamily:"monospace",background:"rgba(245,158,11,.18)",padding:"2px 8px",borderRadius:4,color:"#fbbf24"}}>{col}</span>
                      <span style={{fontSize:12,color:"#c0c0c0"}}>¿Es una lista de precios?</span>
                      <button onClick={()=>setPreview(pv=>({...pv,acceptedCols:[...(pv.acceptedCols||[]),col],unknownCols:pv.unknownCols.filter(c=>c!==col)}))}
                        style={{background:"#116735",color:"#fff",border:"none",borderRadius:5,padding:"3px 10px",fontSize:11,fontWeight:700,cursor:"pointer"}}>Sí, agregar</button>
                      <button onClick={()=>setPreview(pv=>({...pv,unknownCols:pv.unknownCols.filter(c=>c!==col)}))}
                        style={{background:"rgba(111,207,151,.15)",color:"#c0c0c0",border:"1px solid rgba(255,255,255,.15)",borderRadius:5,padding:"3px 10px",fontSize:11,cursor:"pointer"}}>No, ignorar</button>
                    </div>
                  ))}
                </div>
              )}
              <div className="pa">
                <button className="bc" onClick={confirmImport} disabled={pending>0||preview.unknownCols?.length>0} style={{opacity:(pending>0||preview.unknownCols?.length>0)?.6:1}}>
                  {pending>0?`⟳ Validando (${pending})…`:preview.unknownCols?.length>0?"Respondé las columnas desconocidas…":"Confirmar importación"}
                </button>
                <button className="bx" onClick={()=>setPreview(null)}>Cancelar</button>
              </div>
            </div>
          );
        })()}
      </>)}

      {/* EDIT PRODUCT MODAL - inside adminJSX */}
      {editProd&&<div className="emod" onClick={()=>setEditProd(null)}>
        <div className="emod-box" onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Editar producto</span>
            <button className="emod-close" onClick={()=>setEditProd(null)}>✕</button>
          </div>
          <div className="emod-body">
            <div className="emod-section">Identificación</div>
            <div className="emod-grid">
              <div><div className="emod-label">Código / SKU</div><input className="emod-input" value={editProd.cod||""} onChange={e=>setEditProd(p=>({...p,cod:e.target.value}))}/></div>
              <div><div className="emod-label">Categoría</div><input className="emod-input" value={editProd.cat||""} onChange={e=>setEditProd(p=>({...p,cat:e.target.value}))}/></div>
              <div className="emod-full"><div className="emod-label">Nombre</div><input className="emod-input" value={editProd.nom||""} onChange={e=>setEditProd(p=>({...p,nom:e.target.value}))}/></div>
              <div className="emod-full"><div className="emod-label">Descripción</div><textarea className="emod-textarea" value={editProd.desc||""} onChange={e=>setEditProd(p=>({...p,desc:e.target.value}))}/></div>
              <div><div className="emod-label">Marca</div><input className="emod-input" value={editProd.marca||""} onChange={e=>setEditProd(p=>({...p,marca:e.target.value}))}/></div>
              <div><div className="emod-label">IVA</div><input className="emod-input" placeholder="21%" value={editProd.iva||""} onChange={e=>setEditProd(p=>({...p,iva:e.target.value}))}/></div>
              <div><div className="emod-label">Moneda</div>
                <select className="emod-input" value={editProd.mon||"USD"} onChange={e=>setEditProd(p=>({...p,mon:e.target.value}))}>
                  <option value="USD">USD</option><option value="ARS">ARS</option><option value="EUR">EUR</option>
                </select>
              </div>
            </div>
            <div className="emod-section">Precios</div>
            <div className="emod-grid">
              {listasPrecio.map(l=>(
                <div key={l.key}>
                  <div className="emod-label">{l.lbl}</div>
                  <input className="emod-input" placeholder="Sin precio propio (usa fallback)" value={editProd._precios?.[l.key]||""}
                    onChange={e=>setEditProd(p=>({...p,_precios:{...p._precios,[l.key]:e.target.value}}))}/>
                </div>
              ))}
            </div>
            <div className="emod-section">Fotos y Video</div>
            <div className="emod-grid">
              {[["img","Foto principal"],["img2","Foto 2"],["img3","Foto 3"],["img4","Foto 4"]].map(([field,label])=>(
                <div key={field}>
                  <div className="emod-label">{label}</div>
                  {editProd[field]&&<img src={editProd[field]} className="emod-img-prev" alt="" onError={e=>e.target.style.display="none"}/>}
                  <input className="emod-input" placeholder="URL de imagen" value={editProd[field]||""} onChange={e=>setEditProd(p=>({...p,[field]:e.target.value}))}/>
                  <label style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:6,fontSize:11.5,fontWeight:700,color:"var(--mint)",cursor:uploadingImg===field?"default":"pointer",opacity:uploadingImg===field?.6:1}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    {uploadingImg===field?"Subiendo…":"Subir foto desde el celular/PC"}
                    <input type="file" accept="image/*" style={{display:"none"}} disabled={uploadingImg===field}
                      onChange={e=>{ const f=e.target.files?.[0]; e.target.value=""; if(f) uploadProductImage(f,field); }}/>
                  </label>
                </div>
              ))}
              <div className="emod-full">
                <div className="emod-label">Video YouTube</div>
                <input className="emod-input" placeholder="https://youtube.com/watch?v=..." value={editProd.video||""} onChange={e=>setEditProd(p=>({...p,video:e.target.value}))}/>
              </div>
            </div>
          </div>
          <div className="emod-footer">
            <button className="emod-cancel" onClick={()=>setEditProd(null)}>Cancelar</button>
            <button className="emod-save" onClick={()=>{
              const origCod = editProd._origCod || editProd.cod;
              if(!origCod){ console.error("PATCH abortado: cod vacío"); return; }
              setProds(ps=>ps.map(p=>p.cod===origCod?{...p,...editProd,desc:editProd.desc}:p));
              setPreciosMap(m=>({...m,[editProd.cod]:{...(editProd._precios||{})}}));
              SB("rpc/upsert_producto",{
                method:"POST",
                body:JSON.stringify({p_data:{
                  cod:editProd.cod,
                  nom:editProd.nom||"",descripcion:editProd.desc||"",cat:editProd.cat||"",
                  marca:editProd.marca||"",iva:editProd.iva||"",mon:editProd.mon||"USD",
                  img:editProd.img||"",img2:editProd.img2||"",
                  img3:editProd.img3||"",img4:editProd.img4||"",
                  video:editProd.video||""
                }})
              }).then(async r=>{ if(!r.ok){ const t=await r.text(); console.error("PATCH error:",r.status,t); } else { console.log("✅ Producto actualizado en Supabase"); } })
              .catch(e=>console.error("PATCH fetch error:",e));
              listasPrecio.forEach(l=>{
                const val = editProd._precios?.[l.key];
                if(val){
                  SB("rpc/upsert_precio_producto",{method:"POST",body:JSON.stringify({p_cod:editProd.cod,p_lista_key:l.key,p_precio:String(val)})}).catch(()=>{});
                } else {
                  SB(`precios_producto?producto_cod=eq.${encodeURIComponent(editProd.cod)}&lista_key=eq.${encodeURIComponent(l.key)}`,{method:"DELETE"}).catch(()=>{});
                }
              });
              setEditProd(null);
            }}>Guardar cambios</button>
          </div>
        </div>
      </div>}
    </div>
  );

  // v4: Tablero. Mismo screen para vendedor/admin y cliente, cambia el
  // encabezado y qué pedidos entran en la cuenta (todos vs. solo los propios).
  const tableroJSX = screen==="tablero" && sess && (()=>{
    const isStaff = sess.rol==="admin"||sess.rol==="vendedor";
    if(tableroPedidos===null){
      return <div className="aw"><div style={{padding:40,textAlign:"center",color:"#6b7280"}}>Cargando…</div></div>;
    }
    const now = new Date();
    const inicioMes = new Date(now.getFullYear(), now.getMonth(), 1);
    const delMes = tableroPedidos.filter(o=>o.tipo==="pedido" && o.estado!=="cancelado" && new Date(o.created_at) >= inicioMes);
    const montoMes = delMes.reduce((s,o)=>s+(Number(o.neto)||0),0);
    const prodCount = {};
    delMes.forEach(o=>(Array.isArray(o.items)?o.items:[]).forEach(it=>{
      const key = it.nom||it.cod||"?";
      prodCount[key] = (prodCount[key]||0) + (Number(it.qty)||0);
    }));
    const topProds = Object.entries(prodCount).sort((a,b)=>b[1]-a[1]).slice(0,5);
    const nombreMes = now.toLocaleDateString("es-AR",{month:"long",year:"numeric"});
    return (
      <div className="aw">
        <div className="att">Tablero</div>
        <div style={{fontSize:12.5,color:"#6b7280",marginBottom:16,textTransform:"capitalize"}}>{nombreMes} · valores sin impuestos</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12,marginBottom:18}}>
          <div style={{background:"#116735",borderRadius:11,padding:"16px 18px",color:"#fff"}}>
            <div style={{fontSize:11,opacity:.75,textTransform:"uppercase",letterSpacing:.6,marginBottom:6}}>{isStaff?"Monto de pedidos del mes":"Tus compras del mes"}</div>
            <div style={{fontFamily:"var(--bf)",fontSize:26,fontWeight:800}}>$ {montoMes.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
          </div>
          <div style={{background:"#232323",border:"1px solid rgba(255,255,255,.15)",borderRadius:11,padding:"16px 18px"}}>
            <div style={{fontSize:11,color:"#999",textTransform:"uppercase",letterSpacing:.6,marginBottom:6}}>Pedidos del mes</div>
            <div style={{fontFamily:"var(--bf)",fontSize:26,fontWeight:800,color:"#6fcf97"}}>{delMes.length}</div>
          </div>
        </div>
        <div className="ac">
          <div style={{padding:"10px 14px",background:"#191919",borderBottom:"1px solid rgba(255,255,255,.15)"}}>
            <span style={{fontSize:12.5,fontWeight:600,color:"#6fcf97"}}>{isStaff?"Producto más vendido este mes":"Producto que más compraste este mes"}</span>
          </div>
          {topProds.length===0
            ? <div style={{padding:28,textAlign:"center",color:"#999",fontSize:12.5}}>Todavía no hay pedidos este mes.</div>
            : <div style={{padding:"6px 14px"}}>
                {topProds.map(([nom,cant],i)=>(
                  <div key={nom} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:i<topProds.length-1?"1px solid rgba(255,255,255,.08)":"none"}}>
                    <span style={{fontFamily:"var(--bf)",fontSize:15,fontWeight:800,color:"#6fcf97",width:20}}>{i+1}</span>
                    <span style={{flex:1,fontSize:12.5,color:"#f9fffc"}}>{nom}</span>
                    <span style={{fontSize:12.5,fontWeight:700,color:"#6fcf97"}}>{cant} un.</span>
                  </div>
                ))}
              </div>
          }
        </div>
      </div>
    );
  })();

  // Clientes: listado de solo lectura para vendedor/admin — a diferencia de
  // la pestaña Usuarios de Configuraciones (admin-only, con edición), acá
  // solo se puede mirar. Tocar una fila abre el mismo popup "Info del
  // usuario" que ya existe (CUIT, teléfono, localidad, etc.), sin botones de
  // editar ni eliminar.
  const clientesJSX = screen==="clientes" && (sess?.rol==="admin"||sess?.rol==="vendedor") && (()=>{
    const clientes = users.filter(u=>u.rol!=="admin"&&u.rol!=="vendedor");
    return (
      <div className="aw">
        <div className="att">Clientes</div>
        <div style={{fontSize:12.5,color:"#6b7280",marginBottom:16}}>{clientes.length} cliente{clientes.length===1?"":"s"} · tocá una fila para ver los datos completos</div>
        <div className="ac">
          <table className="atb">
            <thead><tr><th>Usuario</th><th>Nombre</th><th>Lista</th><th>Localidad</th></tr></thead>
            <tbody>{clientes.length===0
              ? <tr><td colSpan={4} style={{textAlign:"center",padding:24,color:"#999",fontSize:12.5}}>Todavía no hay clientes registrados.</td></tr>
              : clientes.map((u,i)=>(
                <tr key={i} onClick={()=>setActivUser(u)} style={{cursor:"pointer"}}>
                  <td style={{fontWeight:700,fontFamily:"monospace",fontSize:12}}>{u.u}</td>
                  <td style={{fontSize:12}}>{u.nom}</td>
                  <td><span className={`tl ${u.lista||u.rol}`}>{listasPrecio.find(l=>l.key===u.lista)?.lbl||u.lista}</span></td>
                  <td style={{fontSize:12,color:"#c0c0c0"}}>{u.localidad||"—"}{u.provincia?`, ${u.provincia}`:""}</td>
                </tr>
              ))}</tbody>
          </table>
        </div>
      </div>
    );
  })();

  if(loading) return (
    <>
      <style>{S}</style>
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#1a1a1a",flexDirection:"column",gap:16}}>
        <TmcLogo h={40}/>
        <div style={{fontSize:13,color:"#c0c0c0",fontFamily:"var(--mf)"}}>Cargando catálogo…</div>
      </div>
    </>
  );

  if(screen==="register") return (
    <>
      <style>{S}</style>
      <div style={{minHeight:"100dvh",background:"#141414",display:"flex",alignItems:"center",justifyContent:"center",padding:"28px 16px"}}>
        <div className="lc" style={{maxWidth:480,maxHeight:"92vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"center",marginBottom:22}}><TmcLogo h={30}/></div>
          <div className="lt">Crear cuenta</div>
          <div className="lsub">Registrate para ver precios y hacer pedidos en el catálogo.</div>
            {regMsg&&<div className="lerr">{regMsg}</div>}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {[["Email * (será tu usuario)","email","email"],["Contraseña *","p","password"],["Nombre / Empresa *","nom","text"],["Teléfono","tel","tel"]].map(([label,key,type])=>(
                <div key={key} style={{gridColumn:["nom","email"].includes(key)?"1/-1":"auto"}}>
                  <label style={{fontSize:10.5,fontWeight:700,color:"var(--mint)",textTransform:"uppercase",letterSpacing:.8,display:"block",marginBottom:5}}>{label}</label>
                  <input type={type} value={regForm[key]} onChange={e=>setRegForm(f=>({...f,[key]:e.target.value}))}
                    style={{width:"100%",background:"var(--bgd)",color:"var(--wht)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:10,padding:"11px 12px",fontFamily:"var(--mf)",fontSize:13,boxSizing:"border-box",outline:"none"}}/>
                </div>
              ))}
              <div>
                <label style={{fontSize:10.5,fontWeight:700,color:"var(--mint)",textTransform:"uppercase",letterSpacing:.8,display:"block",marginBottom:5}}>Tipo de documento *</label>
                <select value={regForm.docTipo} onChange={e=>setRegForm(f=>({...f,docTipo:e.target.value}))}
                  style={{width:"100%",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:10,padding:"11px 12px",fontFamily:"var(--mf)",fontSize:13,boxSizing:"border-box",outline:"none",background:"#232323",color:"var(--wht)"}}>
                  <option value="cuit">CUIT</option>
                  <option value="dni">DNI</option>
                </select>
              </div>
              <div>
                <label style={{fontSize:10.5,fontWeight:700,color:"var(--mint)",textTransform:"uppercase",letterSpacing:.8,display:"block",marginBottom:5}}>{regForm.docTipo==="dni"?"DNI *":"CUIT *"}</label>
                <input type="text" inputMode="numeric" placeholder={regForm.docTipo==="dni"?"12345678":"20123456783"} value={regForm.cuit}
                  onChange={e=>setRegForm(f=>({...f,cuit:e.target.value}))}
                  style={{width:"100%",background:"var(--bgd)",color:"var(--wht)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:10,padding:"11px 12px",fontFamily:"var(--mf)",fontSize:13,boxSizing:"border-box",outline:"none"}}/>
              </div>
              {[["Localidad","loc","text"],["Código postal","cp","text"]].map(([label,key,type])=>(
                <div key={key}>
                  <label style={{fontSize:10.5,fontWeight:700,color:"var(--mint)",textTransform:"uppercase",letterSpacing:.8,display:"block",marginBottom:5}}>{label}</label>
                  <input type={type} value={regForm[key]} onChange={e=>setRegForm(f=>({...f,[key]:e.target.value}))}
                    style={{width:"100%",background:"var(--bgd)",color:"var(--wht)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:10,padding:"11px 12px",fontFamily:"var(--mf)",fontSize:13,boxSizing:"border-box",outline:"none"}}/>
                </div>
              ))}
              <div style={{gridColumn:"1/-1"}}>
                <label style={{fontSize:10.5,fontWeight:700,color:"var(--mint)",textTransform:"uppercase",letterSpacing:.8,display:"block",marginBottom:5}}>Provincia *</label>
                <select value={regForm.prov} onChange={e=>setRegForm(f=>({...f,prov:e.target.value}))}
                  style={{width:"100%",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:10,padding:"11px 12px",fontFamily:"var(--mf)",fontSize:13,boxSizing:"border-box",outline:"none",background:"#232323",color:"var(--wht)"}}>
                  <option value="">Seleccioná una provincia…</option>
                  {["Buenos Aires","Catamarca","Chaco","Chubut","Ciudad Autónoma de Buenos Aires","Córdoba","Corrientes","Entre Ríos","Formosa","Jujuy","La Pampa","La Rioja","Mendoza","Misiones","Neuquén","Río Negro","Salta","San Juan","San Luis","Santa Cruz","Santa Fe","Santiago del Estero","Tierra del Fuego","Tucumán"].map(p=>(
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>
            </div>
            <button className="lbtn" style={{marginTop:18}} onClick={doRegister}>Crear cuenta</button>
            <div className="lterms">Al crear tu cuenta aceptás nuestras <span onClick={()=>setSc("terminos")}>condiciones de uso</span>.</div>
            <div className="lpub"><span onClick={()=>setSc("login")}>← Ya tengo cuenta</span></div>
        </div>
      </div>
    </>
  );

  if(screen==="terminos") return (
    <>
      <style>{S}</style>
      <div style={{minHeight:"100dvh",background:"#141414"}}>
        <div className="hdr">
          <div style={{cursor:"pointer"}} onClick={()=>setSc("cat")}><TmcLogo h={26}/></div>
          <span onClick={()=>window.history.length>1?window.history.back():setSc("login")} style={{color:"#fff",fontSize:12.5,fontWeight:600,cursor:"pointer"}}>← Volver</span>
        </div>
        <div className="tos">
          <h1>Condiciones de uso</h1>
          <div className="tos-upd">Catálogo Digital TMC.agro · Última actualización: {new Date().toLocaleDateString("es-AR",{day:"2-digit",month:"long",year:"numeric"})}</div>

          <h2>1. Objeto y aceptación</h2>
          <p>Estas condiciones regulan el acceso y uso del Catálogo Digital de TMC.agro (catalogo.tmcagro.com), disponible para clientes, distribuidores y demás usuarios registrados. Al crear una cuenta o utilizar el catálogo, aceptás estas condiciones en su totalidad.</p>

          <h2>2. Cuenta de usuario</h2>
          <p>El acceso a precios y a la posibilidad de generar pedidos requiere una cuenta de usuario. Sos responsable de mantener la confidencialidad de tu usuario y contraseña, y de toda actividad realizada desde tu cuenta. La misma cuenta puede utilizarse en otras aplicaciones de TMC.agro.</p>

          <h2>3. Precios y disponibilidad</h2>
          <p>Los precios publicados están sujetos a modificación sin previo aviso y corresponden a la lista asignada a tu cuenta. La disponibilidad de stock no está garantizada al momento de la consulta; se confirma al procesar el pedido.</p>

          <h2>4. Pedidos y presupuestos</h2>
          <p>Un "presupuesto" generado en el catálogo no constituye una orden de compra confirmada ni compromete stock ni precio. Un "pedido" queda sujeto a confirmación por parte del equipo de Ventas de TMC.agro, que podrá contactarte para validar condiciones, forma de pago y disponibilidad antes de despachar la mercadería.</p>

          <h2>5. Condiciones comerciales y pagos</h2>
          <p>Las condiciones de pago, descuentos y ajustes que se muestran en el catálogo son informativos y pueden variar según lo acordado comercialmente con cada cliente. Ante cualquier discrepancia, prevalece lo confirmado por Ventas.</p>

          <h2>6. Envíos</h2>
          <p>Los plazos y costos de envío se informan al confirmar el pedido y pueden variar según el destino y la disponibilidad de transporte.</p>

          <h2>7. Datos personales</h2>
          <p>Los datos que completás al registrarte (nombre, email, teléfono, CUIT/DNI, domicilio) se utilizan exclusivamente para gestionar tu cuenta y tus pedidos, y no se comparten con terceros ajenos a la operación comercial. Podés solicitar la actualización o eliminación de tus datos escribiendo a <a href="mailto:ventas@tmcagro.com">ventas@tmcagro.com</a>.</p>

          <h2>8. Propiedad intelectual</h2>
          <p>El contenido del catálogo (marca, logo, textos, fichas e imágenes de producto) es propiedad de TMC.agro o de sus proveedores y no puede reproducirse sin autorización.</p>

          <h2>9. Modificaciones</h2>
          <p>TMC.agro puede actualizar estas condiciones en cualquier momento. La versión vigente es siempre la publicada en esta página.</p>

          <h2>10. Contacto</h2>
          <p>Para consultas sobre estas condiciones, escribinos a <a href="mailto:ventas@tmcagro.com">ventas@tmcagro.com</a> o por <a href={`https://wa.me/${WA}`} target="_blank" rel="noreferrer">WhatsApp</a>.</p>
        </div>
      </div>
    </>
  );

  if(screen==="login") return (
    <>
      <style>{S}</style>
      <div style={{minHeight:"100dvh",background:"#141414",display:"flex",alignItems:"center",justifyContent:"center",padding:"28px 16px"}}>
        <div className="lc">
          <div style={{display:"flex",justifyContent:"center",marginBottom:26}}><TmcLogo h={30}/></div>
          <div className="lt">Iniciar sesión</div>
          <div className="lsub">Usá tu cuenta de TMC para ver precios y hacer pedidos. Además usás las otras aplicaciones de TMC.</div>
            {lerr&&<div className="lerr" style={lerr.startsWith("OK:")?{background:"rgba(111,207,151,.15)",color:"#6fcf97",borderColor:"rgba(255,255,255,.15)"}:{}}>{lerr.replace(/^OK:/,"")}{lerr.startsWith("OK:")&&<><br/><span onClick={()=>setSc("cat")} style={{cursor:"pointer",textDecoration:"underline",fontWeight:700,marginTop:4,display:"inline-block"}}>Ver catálogo</span></>}</div>}
            <div className="lf"><label>Usuario</label><input value={uIn} onChange={e=>setUIn(e.target.value)} onKeyDown={e=>e.key==="Enter"&&doLogin()} placeholder="tu email"/>
              <div style={{fontSize:10.5,color:"#999",marginTop:5}}>Tu usuario es el email con el que accedés al catálogo.</div>
            </div>
            <div className="lf">
              <label>Contraseña</label>
              <input type="password" value={pIn} onChange={e=>setPIn(e.target.value)} onKeyDown={e=>e.key==="Enter"&&doLogin()} placeholder="••••••••"/>
              <div style={{textAlign:"right",marginTop:6}}>
                <span onClick={()=>window.open(`mailto:ventas@tmcagro.com?subject=${encodeURIComponent("Recupero de contraseña — Catálogo Digital TMC.agro")}&body=${encodeURIComponent(`Hola TMC.agro,\n\nOlvidé mi contraseña del Catálogo Digital.\nUsuario: ${uIn||"(completar)"}\n\nPor favor ayúdenme a recuperarla.\n\nSaludos.`)}`)} style={{fontSize:11,color:"#999",cursor:"pointer",textDecoration:"underline"}}>Olvidé mi contraseña</span>
              </div>
            </div>
            <button className="lbtn" onClick={doLogin}>Ingresar</button>
            <button className="lbtn2" onClick={()=>setSc("register")}>¿No tenés cuenta? Registrate</button>
            <div className="lterms">Al ingresar aceptás nuestras <span onClick={()=>setSc("terminos")}>condiciones de uso</span>. Tus datos están protegidos y no se comparten con terceros.</div>
            <div style={{marginTop:8,textAlign:"center"}}>
              <span onClick={()=>setSc("cat")} style={{fontSize:12,color:"#888",cursor:"pointer"}}>← Volver al catálogo</span>
            </div>
            <div style={{marginTop:14,textAlign:"center"}}>
              <a href={`https://wa.me/${WA}?text=${encodeURIComponent("Hola TMC.agro, necesito ayuda.")}`} target="_blank" rel="noreferrer"
                style={{display:"inline-flex",alignItems:"center",gap:6,color:"#888",fontSize:11.5,textDecoration:"none"}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                ¿Necesitás ayuda? Escribinos por WhatsApp
              </a>
            </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <style>{S}</style>
      <div className="hdr">
        <div style={{cursor:"pointer"}} onClick={()=>setSc("cat")}><TmcLogo h={28}/></div>
        <div className="hr">
          {(sess?.rol==="admin"||sess?.rol==="vendedor")
            ? <select value={adminLista} onChange={e=>setAdminLista(e.target.value)}
                style={{background:"rgba(255,255,255,.15)",color:"#fff",border:"none",borderRadius:6,padding:"5px 9px",fontFamily:"var(--mf)",fontSize:11,fontWeight:600,cursor:"pointer",outline:"none"}}>
                {listasPrecio.map(l=><option key={l.key} value={l.key} style={{color:"#f9fffc",background:"#232323"}}>{l.lbl}</option>)}
              </select>
            : sess
            ? <span className="lpill">{liInfo.lbl}</span>
            : <button onClick={()=>setSc("register")} style={{background:"#6FCF97",color:"#0d4f27",border:"none",borderRadius:50,padding:"5px 12px",fontFamily:"var(--mf)",fontSize:11,fontWeight:700,cursor:"pointer"}}>Ver precios</button>
          }
          <button className="hb no-print" onClick={()=>setCartOp(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            <span>Mi carrito</span> {cnt>0&&<span className="cbadge">{cnt}</span>}
          </button>
          {sess &&
            <button className="hb no-print" onClick={()=>setShowMenu(s=>!s)} aria-label="Menú" style={{position:"relative"}}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg>
              {queue.length>0&&<span className="cbadge" style={{background:"#e67e22"}}>{queue.length}</span>}
            </button>
          }
          {!sess && <button className="hb no-print" onClick={()=>setSc("login")}>Ingresar</button>}
          {showMenu && <>
            <div className="mnov" onClick={()=>setShowMenu(false)}/>
            <div className="mnu">
              <div className="mnu-hdr">
                {sess?.nom}{sess?.rol==="admin"?" · Admin":sess?.rol==="vendedor"?" · Vendedor":""}
              </div>
              <button className="mnu-item" onClick={()=>{ setSc(s=>s==="tablero"?"cat":"tablero"); setShowMenu(false); }}>
                <span className="mnu-lb">
                  {screen==="tablero"
                    ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                    : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>}
                  {screen==="tablero"?"Volver al catálogo":"Tablero"}
                </span>
              </button>
              {(sess?.rol==="admin"||sess?.rol==="vendedor") &&
                <button className="mnu-item" onClick={()=>{ setSc(s=>s==="clientes"?"cat":"clientes"); setShowMenu(false); }}>
                  <span className="mnu-lb">
                    {screen==="clientes"
                      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>}
                    {screen==="clientes"?"Volver al catálogo":"Clientes"}
                  </span>
                </button>
              }
              {myOrders.length>0 &&
                <button className="mnu-item" onClick={()=>{ setShowMyOrders(true); setShowMenu(false); }}>
                  <span className="mnu-lb">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                    Mis pedidos
                  </span>
                  <span className="mnu-badge">{myOrders.length}</span>
                </button>
              }
              {queue.length>0 &&
                <button className="mnu-item" onClick={()=>{ setShowPendientes(true); setShowMenu(false); }}>
                  <span className="mnu-lb">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                    {!online?"Sin conexión":"Pendientes"}
                  </span>
                  <span className="mnu-badge warn">{queue.length}</span>
                </button>
              }
              {sess?.rol==="admin" &&
                <button className="mnu-item" onClick={()=>{ setSc(s=>s==="admin"?"cat":"admin"); setShowMenu(false); }}>
                  <span className="mnu-lb">
                    {screen==="admin"
                      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>}
                    {screen==="admin"?"Volver al catálogo":"Configuraciones"}
                  </span>
                </button>
              }
              <button className="mnu-item danger" onClick={()=>{ doOut(); setShowMenu(false); }}>
                <span className="mnu-lb">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Salir
                </span>
              </button>
            </div>
          </>}
        </div>
      </div>

      {sess && ((puedeVerVitrina&&promosVitrina.length>0) || condicionesActivas.length>0) && (
        <div className="topact no-print">
          {puedeVerVitrina && promosVitrina.length>0 &&
            <button className="topact-btn" onClick={()=>setShowPromos(true)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l8 8a1 1 0 0 1 0 1.41z"/><line x1="7" y1="7.5" x2="7.01" y2="7.5"/></svg>
              Promociones <span className="mnu-badge">{promosVitrina.length}</span>
            </button>
          }
          {condicionesActivas.length>0 &&
            <button className="topact-btn" onClick={()=>setShowCondiciones(true)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
              Condiciones de pago
            </button>
          }
        </div>
      )}

      <button className="cartFab no-print" onClick={()=>setCartOp(true)} aria-label="Mi carrito">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        {cnt>0 && <span className="cbadge">{cnt}</span>}
      </button>

      {showBackToTop && (
        <button className="topFab no-print" onClick={()=>window.scrollTo({top:0,behavior:"smooth"})} aria-label="Volver arriba">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
        </button>
      )}

      {/* Franja flotante compacta mientras se scrollea (pedido de Marcos
          19/08): accesos rápidos a WhatsApp y al sitio principal sin tener
          que llegar hasta el footer completo del final. */}
      {showBackToTop && !nearBottom && !(adminJSX||tableroJSX||clientesJSX) && (
        <nav className="quickbar no-print" aria-label="Accesos rápidos">
          <a className="quickbar-btn wa" href={`https://wa.me/${WA}`} target="_blank" rel="noreferrer" aria-label="WhatsApp">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.45 9.9-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.03c-.24.68-1.4 1.3-1.93 1.38-.5.08-1.12.11-1.8-.11-.42-.13-.96-.31-1.65-.6-2.9-1.25-4.79-4.17-4.94-4.36-.14-.2-1.18-1.57-1.18-3 0-1.42.75-2.12 1.02-2.41.26-.29.58-.36.77-.36.19 0 .39 0 .55.01.18.01.42-.07.65.5.24.58.82 2 .89 2.15.07.14.11.31.02.5-.09.19-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.57.16.28.71 1.17 1.52 1.9 1.05.94 1.93 1.23 2.21 1.37.28.14.44.12.6-.07.16-.2.68-.79.87-1.06.18-.27.36-.22.61-.13.24.09 1.55.73 1.82.86.26.14.44.2.5.32.06.11.06.65-.18 1.33z"/></svg>
            <span>WhatsApp</span>
          </a>
          <div className="quickbar-div"/>
          <a className="quickbar-btn" href="https://tmcagro.com" target="_blank" rel="noreferrer" aria-label="Ir al sitio">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            <span>Ir al sitio</span>
          </a>
        </nav>
      )}

      {showInstallBar && (
        <div className="no-print" style={{background:"#0d4f27",color:"#fff",padding:"9px 16px",display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",fontSize:12.5}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" style={{flexShrink:0}}><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
          <span style={{flex:1,minWidth:180}}>
            {isIOSInstall
              ? <>Descargá e instalá el catálogo TMC.agro en tu dispositivo: tocá <b>Compartir</b> y después <b>Agregar a inicio</b>.</>
              : <>Descargá e instalá el catálogo TMC.agro en tu dispositivo y accedé más rápido, sin buscar el link cada vez.</>}
          </span>
          {!isIOSInstall && installEvt && (
            <button onClick={async ()=>{
              installEvt.prompt();
              try{ await installEvt.userChoice; }catch{}
              setInstallEvt(null); setShowInstallBar(false);
            }} style={{background:"#6FCF97",color:"#0d4f27",border:"none",borderRadius:50,padding:"6px 14px",fontFamily:"var(--mf)",fontSize:12,fontWeight:700,cursor:"pointer"}}>Instalar</button>
          )}
          <button onClick={dismissInstall} style={{background:"none",border:"none",color:"rgba(255,255,255,.7)",cursor:"pointer",fontSize:16,lineHeight:1,padding:"0 4px"}}>✕</button>
        </div>
      )}

      {adminJSX||tableroJSX||clientesJSX||(<div className="cat-wrap" data-stamp={new Date().toLocaleString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})} data-lista={liInfo.lbl}>
        {/* CAROUSEL */}
        {banners.some(b=>b.img) && (
          <div className="car">
            <div className="car-track" style={{transform:`translateX(-${carIdx*100}%)`}}>
              {banners.map((b,i)=>(
                <div className="car-slide" key={i} onClick={()=>b.link&&window.open(b.link,"_blank")} style={{cursor:b.link?"pointer":"default"}}>
                  {b.img ? <img src={b.img} alt={`Banner ${i+1}`}/> : <div className="car-slide-ph"><TmcLogo h={48}/></div>}
                </div>
              ))}
            </div>
            <button className="car-arr l" onClick={()=>setCarIdx(i=>(i-1+banners.length)%banners.length)}>‹</button>
            <button className="car-arr r" onClick={()=>setCarIdx(i=>(i+1)%banners.length)}>›</button>
            <div className="car-dots">{banners.map((_,i)=><div key={i} className={`car-dot ${i===carIdx?"on":""}`} onClick={()=>setCarIdx(i)}/>)}</div>
          </div>
        )}
        <div className="mw">
          {!sess &&
            <div className="li">Registrate o ingresá para ver precios · <span style={{cursor:"pointer",color:"#6fcf97",textDecoration:"underline",fontWeight:600}} onClick={()=>setSc("register")}>Crear cuenta</span> · <span style={{cursor:"pointer",color:"#6fcf97",textDecoration:"underline"}} onClick={()=>setSc("login")}>Ingresar</span></div>
          }
          <div className="sb">
            <span style={{color:"#116735",display:"inline-flex"}}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></span>
            <input className="si" placeholder="Buscar producto..." value={q} onChange={e=>setQ(e.target.value)}/>
            <span style={{fontSize:11,color:"#6b7280",whiteSpace:"nowrap"}}>{fil.length} prods.</span>
            <button onClick={downloadPDF} className="no-print" style={{background:"#333",color:"#fff",border:"none",borderRadius:5,padding:"5px 11px",fontSize:11,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:4}}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              PDF
            </button>
            <button onClick={downloadExcel} className="no-print" style={{background:"#1d6f42",color:"#fff",border:"none",borderRadius:5,padding:"5px 11px",fontSize:11,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:4}}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Excel
            </button>
          </div>
          <div className="cp" id="cat-filtros">
            <button className={`pk ${cats2.size===0?"on":""}`} onClick={()=>setCats2(new Set())}>Todas</button>
            {(catOrder.length
              ? [...catOrder.filter(c=>cats.includes(c)), ...cats.filter(c=>!catOrder.includes(c))]
              : cats
            ).map(c=>(
              <button key={c} className={`pk ${cats2.has(c)?"on":""}`} onClick={()=>setCats2(prev=>{
                const s=new Set(prev);
                s.has(c)?s.delete(c):s.add(c);
                return s;
              })}>
                {c}{cats2.has(c)&&<span style={{marginLeft:4,opacity:.7}}>×</span>}
              </button>
            ))}
          </div>
          {orderedGroups.map(([catN,items],catIdx)=>{
            const expanded = expandedCats.has(catN);
            const visible = expanded ? items : items.slice(0,CAT_PAGE_SIZE);
            const resto = items.length - visible.length;
            const goTo = id => document.getElementById(id)?.scrollIntoView({behavior:"smooth",block:"start"});
            return (
            <div className="cs" id={`cat-${slugify(catN)}`} key={catN}>
              <div className="ct"><span className="cn">{catN}</span><span className="cc">{items.length}</span><div className="cl"/></div>
              <div className="pl">
                {visible.map((p,i)=>(
                  <div className="pr" key={i} onClick={()=>{ setModal(p); track("vista_producto",{cod:p.cod,nom:p.nom}); }}>
                    <div className="pimg">
                      {(() => {
                        const b = promoBadgeFor(p);
                        if(!b) return null;
                        return b.type==="benef"
                          ? <span style={{position:"absolute",top:4,left:4,background:b.pct>=100?"#e67e22":"#116735",color:"#fff",fontSize:9.5,fontWeight:800,padding:"3px 7px",borderRadius:5,letterSpacing:.3,zIndex:1,boxShadow:"0 2px 6px rgba(0,0,0,.25)",whiteSpace:"nowrap"}}>{b.pct>=100?"GRATIS":`-${b.pct}%`}</span>
                          : <span style={{position:"absolute",top:4,left:4,background:"#232323",color:"#6fcf97",border:"1.5px solid #116735",fontSize:9,fontWeight:800,padding:"2px 6px",borderRadius:5,letterSpacing:.3,zIndex:1,whiteSpace:"nowrap"}}>PROMO</span>;
                      })()}
                      {p.img
                      ? <img src={p.img} alt="" style={{objectFit:"cover"}} onError={e=>{e.target.src=NO_IMG;e.target.style.objectFit="contain";}}/>
                      : <img src={NO_IMG} alt="" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
                    }</div>
                    <div className="pi">
                      <div className="pt"><span className="pc">{p.cod||"—"}</span>{p.marca&&<span className="pm">{p.marca}</span>}</div>
                      <div className="pn">{p.nom||p.desc}</div>
                      {p.desc&&<div className="pd">{p.desc}</div>}
                    </div>
                    <div className="pp" onClick={e=>e.stopPropagation()}>
                      {!sess ? (
                        <button onClick={()=>setSc("login")} style={{background:"#116735",color:"#fff",border:"none",borderRadius:50,padding:"8px 12px",fontFamily:"var(--mf)",fontSize:11,fontWeight:700,cursor:"pointer",width:"100%",letterSpacing:.3,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                          VER PRECIOS
                        </button>
                      ) : (
                        // v4: sin precio público tachado / "descuento" — un único precio,
                        // el de la lista seleccionada (selector arriba para vendedor/admin).
                        <>
                          <div className="prow2">
                            <span className="pcu">{p.mon||"USD"}</span>
                            <span className="pv">{gp(p)}</span>
                          </div>
                          {li==="publico" && <span style={{fontSize:9,color:"#888"}}>Precio público</span>}
                          {p.iva&&p.iva.includes("%")&&<span className="piv">+ IVA {p.iva}</span>}
                        </>
                      )}
                      {sess&&<button className={`ab ${inC(p)?"in":""}`} onClick={()=>add(p)}>{inC(p)?"✓ En pedido":"+ Agregar"}</button>}
                    </div>
                  </div>
                ))}
              </div>
              {resto>0 && (
                <button className="catmore" onClick={()=>setExpandedCats(prev=>new Set(prev).add(catN))}>
                  Ver {resto} más de {catN}
                </button>
              )}
              {resto===0 && (
                <div className="catnav" style={{justifyContent:"flex-end"}}>
                  <button onClick={()=>goTo("cat-filtros")}>↑ Volver a categorías</button>
                </div>
              )}
            </div>
          );})}
        </div>
        {/* FOOTER */}
        <footer className="ft no-print">
          <div className="ft-inner">
            <div className="ft-top">
              <div><TmcLogo h={28}/><div className="ft-tag">Innovación y calidad para tu producción</div></div>
              <div className="ft-links">
                <a className="ft-link wa" href={`https://wa.me/${WA}`} target="_blank" rel="noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor" style={{width:15,height:15}}><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.45 9.9-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.03c-.24.68-1.4 1.3-1.93 1.38-.5.08-1.12.11-1.8-.11-.42-.13-.96-.31-1.65-.6-2.9-1.25-4.79-4.17-4.94-4.36-.14-.2-1.18-1.57-1.18-3 0-1.42.75-2.12 1.02-2.41.26-.29.58-.36.77-.36.19 0 .39 0 .55.01.18.01.42-.07.65.5.24.58.82 2 .89 2.15.07.14.11.31.02.5-.09.19-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.57.16.28.71 1.17 1.52 1.9 1.05.94 1.93 1.23 2.21 1.37.28.14.44.12.6-.07.16-.2.68-.79.87-1.06.18-.27.36-.22.61-.13.24.09 1.55.73 1.82.86.26.14.44.2.5.32.06.11.06.65-.18 1.33z"/></svg>
                  WhatsApp
                </a>
                <a className="ft-link" href={IG} target="_blank" rel="noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor" style={{width:15,height:15}}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                  Instagram
                </a>
                <a className="ft-link" href={YT} target="_blank" rel="noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor" style={{width:15,height:15}}><path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>
                  YouTube
                </a>
              </div>
            </div>
            <div className="ft-divider"/>
            <div className="ft-bot">
              <span className="ft-copy">© {new Date().getFullYear()} TMC.agro · Todos los derechos reservados · <span style={{opacity:.5}}>{APP_VERSION}</span></span>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:3}}>
                <span className="ft-prices">Despachamos a todo el país</span>
                <span className="ft-prices">Los precios no incluyen impuestos</span>
              </div>
            </div>
          </div>
        </footer>
        </div>
      )}

      {/* USER INFO POPUP — global (antes vivía adentro de adminJSX, así que
          solo se veía si screen==="admin"; con eso, tocar un cliente desde
          la pantalla "Clientes" o desde el ⓘ de Actividad no abría nada
          porque ese árbol de JSX ni se estaba renderizando). Ahora es un
          hermano al mismo nivel que los otros modales globales, así se ve
          sin importar en qué pantalla se disparó. */}
      {activUser&&<div className="emod" onClick={()=>setActivUser(null)}>
        <div className="emod-box" style={{maxWidth:380}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Info del usuario</span>
            <button className="emod-close" onClick={()=>setActivUser(null)}>✕</button>
          </div>
          <div className="emod-body">
            {[
              ["Usuario",activUser.u||activUser.usuario],
              ["Nombre",activUser.nom||activUser.nombre],
              ["Email",activUser.email],
              ["Teléfono",activUser.telefono],
              ["Documento (CUIT/DNI)",activUser.cuit],
              ["Localidad",activUser.localidad],
              ["Provincia",activUser.provincia],
              ["Lista asignada",listasPrecio.find(l=>l.key===activUser.lista)?.lbl||activUser.lista],
              ["Rol",activUser.rol],
            ].map(([label,val])=>val?(
              <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,.08)",fontSize:13}}>
                <span style={{color:"#c0c0c0",fontSize:12}}>{label}</span>
                <span style={{fontWeight:600,color:"#f9fffc"}}>{val}</span>
              </div>
            ):null)}
          </div>
        </div>
      </div>}

      {/* MIS PEDIDOS MODAL */}
      {showMyOrders&&<div className="emod" onClick={()=>setShowMyOrders(false)}>
        <div className="emod-box" style={{maxWidth:640}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Mis pedidos</span>
            <button className="emod-close" onClick={()=>setShowMyOrders(false)}>✕</button>
          </div>
          <div style={{maxHeight:"70vh",overflowY:"auto"}}>
            {myOrders.length===0
              ? <div style={{padding:32,textAlign:"center",color:"#999"}}>No tenés pedidos confirmados aún.</div>
              : myOrders.map((o,i)=>{
                const p = armarPedidoObj(o);
                return (
                <div key={i} style={{borderBottom:"1px solid rgba(111,207,151,.3)",padding:"14px 18px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div>
                      <span style={{fontSize:11,fontWeight:800,padding:"2px 8px",borderRadius:10,marginRight:6,background:p.tipo==="presupuesto"?"rgba(245,158,11,.18)":"rgba(111,207,151,.18)",color:p.tipo==="presupuesto"?"#fbbf24":"#6fcf97"}}>{p.tipo==="presupuesto"?"PRESUPUESTO":"PEDIDO"}</span>
                      <span style={{fontSize:12,fontWeight:700,color:"#6fcf97",fontFamily:"monospace"}}>{o.codigo||"—"}</span>
                      {p.revisiones>0 && <span style={{fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:10,marginLeft:6,background:"rgba(99,102,241,.15)",color:"#a5b4fc"}}>Rev. {p.revisiones}</span>}
                      <div style={{fontSize:11,color:"#999",marginTop:2}}>{o.lista||"—"} · {new Date(o.created_at||Date.now()).toLocaleString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})}</div>
                    </div>
                    {(sess?.rol==="admin"||sess?.rol==="vendedor") && o.id!=null ? (
                      <select value={o.estado||"pendiente"} onChange={e=>{
                        const nuevoEstado = e.target.value;
                        setMyOrders(ps=>ps.map(x=>x.id===o.id?{...x,estado:nuevoEstado}:x));
                        SB(`pedidos_catalogo?id=eq.${o.id}`,{method:"PATCH",headers:{"Prefer":"return=minimal"},body:JSON.stringify({estado:nuevoEstado})}).catch(()=>{});
                      }} style={{border:"1.5px solid "+estadoInfo(o.estado).bg,borderRadius:20,padding:"3px 10px",fontSize:11,fontFamily:"var(--mf)",outline:"none",background:estadoInfo(o.estado).bg,color:estadoInfo(o.estado).fg,fontWeight:700,cursor:"pointer"}}>
                        <option value="pendiente">Pendiente</option>
                        <option value="en_proceso">En proceso</option>
                        <option value="listo">Listo</option>
                        <option value="completado">Completado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    ) : (
                      <span style={{fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:12,background:estadoInfo(o.estado).bg,color:estadoInfo(o.estado).fg}}>{estadoInfo(o.estado).lbl}</span>
                    )}
                  </div>
                  <div style={{fontSize:12,color:"#555",marginBottom:8}}>
                    {(Array.isArray(o.items)?o.items:[]).map((it,j)=>(
                      <div key={j} style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}>
                        <span>{it.qty}x {it.nom}{it.esExtra?<span style={{color:"#999"}}> (cargo)</span>:null}</span>
                        <span style={{fontWeight:600}}>{it.mon||"USD"} {Number(it.precioUnit||0).toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                      </div>
                    ))}
                  </div>
                  {pesoRefTxt(p.total,p.moneda) && (
                    <div style={{fontSize:10.5,color:"#999",marginBottom:6,textAlign:"right"}}>{pesoRefTxt(p.total,p.moneda)}</div>
                  )}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
                    <span style={{fontWeight:700,color:"#6fcf97",fontSize:14}}>Subtotal: {o.subtotal}</span>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      {o.estado!=="cancelado" && o.id!=null && (
                        <button onClick={()=>startEditOrder(o)}
                          style={{background:"rgba(245,158,11,.18)",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,color:"#fbbf24",cursor:"pointer",fontWeight:600}}>Editar</button>
                      )}
                      {(sess?.rol==="admin"||sess?.rol==="vendedor") && p.tipo==="presupuesto" && o.id!=null && (
                        <button onClick={()=>convertirEnPedido(o)}
                          style={{background:"rgba(111,207,151,.18)",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,color:"#6fcf97",cursor:"pointer",fontWeight:600}}>Convertir en pedido</button>
                      )}
                      <button onClick={()=>copyWithFeedback(resumenTexto(p),`mp_${o.id??i}`)}
                        style={{background:copiedKey===`mp_${o.id??i}`?"#116735":"rgba(111,207,151,.15)",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,color:copiedKey===`mp_${o.id??i}`?"#fff":"#6fcf97",cursor:"pointer",fontWeight:600,display:"inline-flex",alignItems:"center",gap:4}}>
                        {copiedKey===`mp_${o.id??i}` && <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                        {copiedKey===`mp_${o.id??i}`?"Copiado":"Copiar"}
                      </button>
                      <button onClick={()=>window.open(`https://wa.me/${WA}?text=${encodeURIComponent(resumenTexto(p))}`,"_blank")}
                        style={{background:"#25D366",border:"none",borderRadius:50,padding:"5px 10px",fontSize:11,color:"#fff",cursor:"pointer",fontWeight:600}}>WhatsApp</button>
                      <button onClick={()=>{ const w=window.open("","_blank","width=800,height=600"); w.document.write(pedidoHTML(p)); w.document.close(); w.onload=()=>w.print(); }}
                        style={{background:"#333",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,color:"#fff",cursor:"pointer",fontWeight:600}}>PDF</button>
                    </div>
                  </div>
                </div>
              );})
            }
          </div>
        </div>
      </div>}

      {/* PENDIENTES DE SINCRONIZAR (cola offline) */}
      {showPendientes&&<div className="emod" onClick={()=>setShowPendientes(false)}>
        <div className="emod-box" style={{maxWidth:560}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Pendientes de sincronizar</span>
            <button className="emod-close" onClick={()=>setShowPendientes(false)}>✕</button>
          </div>
          <div style={{padding:"10px 18px",fontSize:11.5,color:online?"#c0c0c0":"#fbbf24",background:online?"#191919":"rgba(245,158,11,.12)"}}>
            {online
              ? `${queue.length} pedido${queue.length===1?"":"s"} guardado${queue.length===1?"":"s"} en este celular, esperando para subirse — se suben solos.`
              : "Sin conexión. Estos pedidos quedan guardados en el celular y se suben apenas vuelva la señal."}
          </div>
          <div style={{maxHeight:"60vh",overflowY:"auto"}}>
            {queue.length===0
              ? <div style={{padding:32,textAlign:"center",color:"#999"}}>Todo sincronizado.</div>
              : queue.map(item=>{
                const p = armarPedidoObj({...item.p_data, created_at:new Date(item.ts).toISOString()});
                return (
                <div key={item.id} style={{borderBottom:"1px solid rgba(111,207,151,.3)",padding:"14px 18px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                    <span style={{fontSize:11,fontWeight:800,padding:"2px 8px",borderRadius:10,background:p.tipo==="presupuesto"?"rgba(245,158,11,.18)":"rgba(111,207,151,.18)",color:p.tipo==="presupuesto"?"#fbbf24":"#6fcf97"}}>{p.tipo==="presupuesto"?"PRESUPUESTO":"PEDIDO"}</span>
                    <span style={{fontSize:11,color:"#999"}}>{p.fecha.toLocaleString("es-AR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</span>
                  </div>
                  <div style={{fontSize:12,color:"#555",marginBottom:8}}>
                    {p.items.map((it,j)=>(<div key={j} style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}><span>{it.qty}x {it.nom}</span></div>))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontWeight:700,color:"#6fcf97",fontSize:14}}>{p.moneda} {p.total.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                    <div style={{display:"flex",gap:6}}>
                      <button onClick={()=>window.open(`https://wa.me/${WA}?text=${encodeURIComponent(`Hola TMC.agro! Les mando este pedido porque no se pudo subir solo desde la app:\n\n${resumenTexto(p)}`)}`,"_blank")}
                        style={{background:"#25D366",border:"none",borderRadius:50,padding:"5px 10px",fontSize:11,color:"#fff",cursor:"pointer",fontWeight:600}}>Enviar por WhatsApp</button>
                      <button onClick={()=>{
                        if(!window.confirm("¿Descartar este pedido pendiente? No se va a subir al servidor.")) return;
                        setQueue(q=>q.filter(x=>x.id!==item.id));
                      }} style={{background:"rgba(255,255,255,.06)",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,color:"#888",cursor:"pointer",fontWeight:600}}>Descartar</button>
                    </div>
                  </div>
                </div>
              );})
            }
          </div>
          {queue.length>0 && <div style={{padding:"10px 18px",borderTop:"1px solid rgba(111,207,151,.3)"}}>
            <button onClick={flushQueue} disabled={!online} style={{width:"100%",background:online?"#116735":"rgba(255,255,255,.1)",color:"#fff",border:"none",borderRadius:7,padding:"9px",fontSize:12.5,fontWeight:700,cursor:online?"pointer":"default"}}>
              {online?"Reintentar ahora":"Sin conexión"}
            </button>
          </div>}
        </div>
      </div>}

      {/* AVISO POST-CONFIRMACIÓN — el mail es un mailto: (el cliente tiene que
          apretar enviar en su propio mail), así que acá insistimos con
          WhatsApp como la forma confiable de que Ventas lo vea sí o sí. */}
      {confirmResult&&<div className="emod" onClick={()=>setConfirmResult(null)}>
        <div className="emod-box" style={{maxWidth:400}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">
              {confirmResult.queued ? "Pedido guardado" : confirmResult.p.tipo==="presupuesto" ? "Presupuesto guardado" : "Pedido confirmado"}
            </span>
            <button className="emod-close" onClick={()=>setConfirmResult(null)}>✕</button>
          </div>
          <div style={{padding:"18px 20px"}}>
            {confirmResult.p.codigo && <div style={{fontFamily:"monospace",fontWeight:700,color:"#6fcf97",fontSize:15,marginBottom:12}}>{confirmResult.p.codigo}</div>}
            {confirmResult.queued ? (
              <div style={{background:"rgba(245,158,11,.18)",color:"#fbbf24",borderRadius:7,padding:"10px 12px",fontSize:12.5,marginBottom:14,lineHeight:1.5}}>
                No hay conexión en este momento. Para que no se pierda, mandalo ahora por WhatsApp — de todas formas se va a subir solo apenas vuelva la señal.
              </div>
            ) : confirmResult.p.tipo==="pedido" ? (
              <div style={{fontSize:12.5,color:"#c0c0c0",marginBottom:14,lineHeight:1.5}}>
                Se abrió tu mail para avisarle a Ventas, pero tenés que apretar enviar ahí para que salga. Si no tenés mail configurado en el celular, mandalo por WhatsApp para asegurarte de que lo vean:
              </div>
            ) : (
              <div style={{fontSize:12.5,color:"#c0c0c0",marginBottom:14,lineHeight:1.5}}>
                Quedó guardado como presupuesto — todavía no se le avisó a Ventas. Podés enviárselo por WhatsApp o mail cuando quieras.
              </div>
            )}
            <button onClick={()=>window.open(`https://wa.me/${WA}?text=${encodeURIComponent(resumenTexto(confirmResult.p))}`,"_blank")}
              style={{width:"100%",background:"#25D366",color:"#fff",border:"none",borderRadius:50,padding:"12px",fontFamily:"var(--mf)",fontSize:13.5,fontWeight:700,cursor:"pointer",marginBottom:8,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
              Enviar por WhatsApp
            </button>
            {confirmResult.p.tipo==="pedido" && (
              <button onClick={()=>enviarMailVentas(confirmResult.p)}
                style={{width:"100%",background:"rgba(255,255,255,.06)",color:"#555",border:"none",borderRadius:8,padding:"10px",fontFamily:"var(--mf)",fontSize:12.5,fontWeight:600,cursor:"pointer",marginBottom:8}}>
                Reenviar por mail
              </button>
            )}
            <span onClick={()=>{ setConfirmResult(null); setShowMyOrders(true); }}
              style={{display:"block",textAlign:"center",fontSize:12,fontWeight:600,color:"#6fcf97",cursor:"pointer",textDecoration:"underline",marginTop:4}}>
              Ver en "Mis pedidos"
            </span>
          </div>
        </div>
      </div>}

      {/* VITRINA DE PROMOS */}
      {showPromos&&<div className="emod" onClick={()=>setShowPromos(false)}>
        <div className="emod-box" style={{maxWidth:560}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Promociones</span>
            <button className="emod-close" onClick={()=>setShowPromos(false)}>✕</button>
          </div>
          <div style={{maxHeight:"70vh",overflowY:"auto",padding:"12px 10px"}}>
            {promosVitrina.length===0
              ? <div style={{padding:32,textAlign:"center",color:"#999"}}>No hay promociones activas.</div>
              : promosVitrina.map(pr=>{
                const req = Array.isArray(pr.requisitos)&&pr.requisitos[0] ? pr.requisitos[0] : null;
                const reqProd = req && !req.cat && prods.find(p=>p.cod===req.cod);
                const benefProd = !pr.beneficio_cat && prods.find(p=>p.cod===pr.beneficio_cod);
                const esGratis = Number(pr.beneficio_descuento_pct)>=100;
                const catThumb = <div style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(255,255,255,.15)",flexShrink:0,background:"#232323",display:"flex",alignItems:"center",justifyContent:"center",color:"#8fbf9e"}}>
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
                </div>;
                return (
                  <div key={pr.id} style={{position:"relative",overflow:"hidden",borderRadius:12,background:"linear-gradient(135deg,rgba(111,207,151,.12),#1a2620)",border:"1.5px solid rgba(255,255,255,.15)",padding:"14px 16px",marginBottom:10}}>
                    <div style={{position:"absolute",top:0,right:0,background:esGratis?"#e67e22":"#116735",color:"#fff",fontFamily:"var(--bf)",fontWeight:800,fontSize:esGratis?13:16,padding:"5px 14px",borderBottomLeftRadius:10,letterSpacing:.3}}>
                      {esGratis?"GRATIS":`-${pr.beneficio_descuento_pct}%`}
                    </div>
                    <div style={{fontSize:13.5,fontWeight:800,color:"#6fcf97",marginBottom:2,paddingRight:80,lineHeight:1.25}}>{pr.nombre}</div>
                    <div style={{fontSize:10,fontWeight:700,color:"#8fbf9e",marginBottom:10}}>{pr.beneficio_descuento_pct}% de descuento{esGratis?" (gratis)":""}</div>
                    <div style={{display:"flex",alignItems:"flex-start",gap:8}}>
                      <div style={{display:"flex",alignItems:"flex-start",gap:7,flex:1,minWidth:0}}>
                        {req?.cat ? catThumb : (reqProd?.img
                          ? <img src={reqProd.img} alt="" style={{width:38,height:38,borderRadius:8,objectFit:"cover",border:"1px solid rgba(255,255,255,.15)",flexShrink:0,background:"#232323"}}/>
                          : <div style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(255,255,255,.15)",flexShrink:0,background:"#232323"}}/>)}
                        <div style={{minWidth:0}}>
                          <div style={{fontSize:9,fontWeight:800,color:"#8fbf9e",textTransform:"uppercase",letterSpacing:.5}}>Comprás</div>
                          <div style={{fontSize:11.5,fontWeight:700,color:"#f9fffc",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{req?`${req.cant}x `:""}{req?.cat?`cat. ${req.cat}`:(reqProd?.nom||req?.cod||"—")}</div>
                        </div>
                      </div>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6FCF97" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:10}}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                      <div style={{display:"flex",alignItems:"flex-start",gap:7,flex:1,minWidth:0}}>
                        {pr.beneficio_cat ? catThumb : (benefProd?.img
                          ? <img src={benefProd.img} alt="" style={{width:38,height:38,borderRadius:8,objectFit:"cover",border:"1px solid rgba(255,255,255,.15)",flexShrink:0,background:"#232323"}}/>
                          : <div style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(255,255,255,.15)",flexShrink:0,background:"#232323"}}/>)}
                        <div style={{minWidth:0}}>
                          <div style={{fontSize:9,fontWeight:800,color:"#8fbf9e",textTransform:"uppercase",letterSpacing:.5}}>Te bonifican</div>
                          <div style={{fontSize:11.5,fontWeight:700,color:"#6fcf97",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{pr.beneficio_cant||1}x {pr.beneficio_cat?`cat. ${pr.beneficio_cat}`:(benefProd?.nom||pr.beneficio_cod)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>}

      {/* CONDICIONES DE PAGO */}
      {showCondiciones&&<div className="emod" onClick={()=>setShowCondiciones(false)}>
        <div className="emod-box" style={{maxWidth:460}} onClick={e=>e.stopPropagation()}>
          <div className="emod-hdr">
            <span className="emod-ttl">Condiciones de pago</span>
            <button className="emod-close" onClick={()=>setShowCondiciones(false)}>✕</button>
          </div>
          <div style={{maxHeight:"70vh",overflowY:"auto"}}>
            {condicionesActivas.length===0
              ? <div style={{padding:32,textAlign:"center",color:"#999"}}>No hay condiciones de pago cargadas.</div>
              : condicionesActivas.map(c=>(
                <div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid rgba(255,255,255,.08)",padding:"12px 18px"}}>
                  <span style={{fontSize:13,fontWeight:600,color:"#f9fffc"}}>{c.nombre}</span>
                  <span style={{fontSize:12.5,fontWeight:700,color:c.ajuste_pct<0?"#6fcf97":c.ajuste_pct>0?"#fbbf24":"#888"}}>
                    {c.ajuste_pct===0?"Sin ajuste":`${c.ajuste_pct>0?"+":""}${c.ajuste_pct}%`}
                  </span>
                </div>
              ))
            }
          </div>
          <div style={{padding:"10px 18px",fontSize:10.5,color:"#999",borderTop:"1px solid rgba(255,255,255,.08)"}}>
            El ajuste se aplica sobre el subtotal según lista. Elegí la condición en el detalle del pedido para ver el total exacto.
          </div>
        </div>
      </div>}

      <div className={`co ${cartOp?"op":""}`} onClick={()=>setCartOp(false)}/>
      <div className={`cp2 ${cartOp?"op":""}`}>
        <div className="ch"><div className="chttl">{editingOrder?`Editando ${editingOrder.codigo||"pedido"}`:`Mi pedido${cart.length>0?` (${cnt})`:""}`}</div><button className="chcls" onClick={()=>editingOrder?cancelEditOrder():setCartOp(false)} aria-label="Cerrar">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button></div>
        {editingOrder && (
          <div style={{background:"rgba(245,158,11,.18)",color:"#fbbf24",fontSize:11.5,padding:"7px 15px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
            <span>Modificando un pedido ya confirmado — al guardar queda como revisión.</span>
            <span onClick={cancelEditOrder} style={{cursor:"pointer",textDecoration:"underline",fontWeight:700,flexShrink:0,marginLeft:8}}>Cancelar</span>
          </div>
        )}
        <div className="cbdy">
          {cart.length===0
            ? <div className="cemp">
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" style={{color:"#c7d9cd"}}><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                <p style={{fontWeight:600,marginTop:10,color:"#888"}}>Tu pedido está vacío</p>
              </div>
            : cart.map((item,i)=>(
            <div className="ci" key={i}>
              {item.product.img?<img src={item.product.img} className="cimg" alt=""/>:<div className="cph2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8fbf9e" strokeWidth="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
              </div>}
              <div className="cin">
                <div className="cnm">{item.product.nom||item.product.desc}</div>
                <div className="cco">Cód: {item.product.cod}</div>
                <div className="cpr">{item.product.mon||"USD"} {gp(item.product)}</div>
                <div className="qr">
                  <button className="qb" onClick={()=>upd(item.product.cod,item.qty-1)} aria-label="Restar">−</button>
                  <input
                    type="number" min="1"
                    value={item.qty}
                    onChange={e=>{ const v=parseInt(e.target.value)||""; if(v===""||v>0) upd(item.product.cod,v||1); }}
                    onFocus={e=>e.target.select()}
                    style={{width:52,textAlign:"center",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:5,padding:"2px 4px",fontFamily:"var(--mf)",fontSize:13,fontWeight:700,outline:"none"}}
                  />
                  <button className="qb" onClick={()=>upd(item.product.cod,item.qty+1)} aria-label="Sumar">+</button>
                </div>
              </div>
              <button className="cdl" onClick={()=>rm(item.product.cod)} aria-label="Quitar">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
              </button>
            </div>
          ))}
        </div>
        {cart.length>0&&(()=>{
          const pedidoActual = armarPedidoObj();
          return (
          <div className="cft">
            <div className="cno" style={{marginBottom:8}}>{liInfo.lbl} · {cnt} artículo{cnt===1?"":"s"}</div>

            {condiciones.length>0 && (
              <div style={{marginBottom:8}}>
                {/* v4.37: condiciones.id es texto (UUID/lo que sea), no numérico
                    — antes esto forzaba Number(...) y la comparación estricta
                    con c.id (string) siempre daba false, así que "elegir" una
                    condición no hacía nada. */}
                <select value={condicionSel||""} onChange={e=>setCondicionSel(e.target.value||null)}
                  style={{width:"100%",border:"1.5px solid rgba(255,255,255,.1)",borderRadius:7,padding:"7px 8px",fontFamily:"var(--mf)",fontSize:12,color:"#f9fffc",background:"#232323",outline:"none"}}>
                  <option value="">Sin condición</option>
                  {condiciones.filter(c=>c.activa).map(c=>(
                    <option key={c.id} value={c.id}>{c.nombre}{c.ajuste_pct?` (${c.ajuste_pct>0?"+":""}${c.ajuste_pct}%)`:""}</option>
                  ))}
                </select>
                <button onClick={()=>setShowComparar(s=>!s)} style={{background:"none",border:"none",padding:"5px 0 0",fontSize:10.5,color:"#6fcf97",fontWeight:600,cursor:"pointer",textDecoration:"underline"}}>
                  {showComparar?"Ocultar comparación":"Comparar condiciones"}
                </button>
                {showComparar && (
                  <div style={{border:"1px solid rgba(255,255,255,.1)",borderRadius:7,marginTop:5,overflow:"hidden"}}>
                    {condiciones.filter(c=>c.activa).map(c=>{
                      const calc = calcularPedido(cart.map(i=>({product:i.product,qty:i.qty})), c, li);
                      const activa = condicionSel===c.id;
                      return (
                        <div key={c.id} onClick={()=>setCondicionSel(c.id)}
                          style={{display:"flex",justifyContent:"space-between",padding:"7px 9px",fontSize:11.5,cursor:"pointer",
                            background:activa?"rgba(111,207,151,.15)":"#232323",borderBottom:"1px solid rgba(255,255,255,.08)",fontWeight:activa?700:500,color:activa?"#6fcf97":"#999"}}>
                          <span>{c.nombre}</span>
                          <span>{calc.moneda} {calc.total.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            <div style={{marginBottom:8}}>
              {codigoAplicado ? (
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"rgba(111,207,151,.08)",border:"1.5px solid #6FCF97",borderRadius:7,padding:"7px 10px",fontSize:12}}>
                  <span style={{color:"#6fcf97",fontWeight:700}}>
                    Código {codigoAplicado.codigo}{codigoAplicado.descuento_pct>0?` · -${codigoAplicado.descuento_pct}%`:" · aplicado (sin descuento)"}
                  </span>
                  <button onClick={quitarCodigoDescuento} style={{background:"none",border:"none",color:"#6fcf97",cursor:"pointer",fontSize:11,fontWeight:600,textDecoration:"underline"}}>Quitar</button>
                </div>
              ) : (
                <div>
                  <div style={{display:"flex",gap:6}}>
                    <input placeholder="Código de descuento (opcional)" value={codigoInput}
                      onChange={e=>setCodigoInput(e.target.value)}
                      onKeyDown={e=>{ if(e.key==="Enter"){ e.preventDefault(); aplicarCodigoDescuento(); } }}
                      style={{flex:1,minWidth:0,border:"1.5px solid rgba(255,255,255,.1)",borderRadius:7,padding:"7px 8px",fontFamily:"var(--mf)",fontSize:12,outline:"none"}} />
                    <button onClick={aplicarCodigoDescuento} disabled={codigoValidando}
                      style={{background:"#116735",color:"#fff",border:"none",borderRadius:7,padding:"0 14px",fontSize:12,fontWeight:700,cursor:codigoValidando?"default":"pointer",opacity:codigoValidando?.7:1,flexShrink:0}}>
                      {codigoValidando?"…":"Aplicar"}
                    </button>
                  </div>
                  {codigoError && <div style={{fontSize:10.5,color:"#fbbf24",marginTop:4}}>{codigoError}</div>}
                </div>
              )}
            </div>

            {pedidoActual.promosAplicadas.length>0 && (
              <div style={{background:"rgba(111,207,151,.08)",border:"1.5px solid #6FCF97",borderRadius:7,padding:"7px 10px",marginBottom:8,fontSize:11.5,color:"#6fcf97",fontWeight:600}}>
                {pedidoActual.promosAplicadas.map((pr,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:5}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#116735" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l8 8a1 1 0 0 1 0 1.41z"/><line x1="7" y1="7.5" x2="7.01" y2="7.5"/></svg>
                  {pr.nombre}: -{pr.descuento_pct}% en {pr.cant} u.
                </div>)}
              </div>
            )}

            {puedeCargosExtra && (
              <div style={{border:"1.5px dashed rgba(255,255,255,.15)",borderRadius:7,padding:"8px 10px",marginBottom:10}}>
                <div style={{fontSize:10,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.6,marginBottom:6}}>Cargos adicionales</div>
                {extraCargos.map((ec,i)=>(
                  <div key={ec.key} style={{marginBottom:i<extraCargos.length-1?8:0}}>
                    <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#999",fontWeight:600,cursor:"pointer"}}>
                      <input type="checkbox" checked={ec.enabled} onChange={e=>{
                        const en = e.target.checked;
                        setExtraCargos(prev=>prev.map((x,j)=>j===i?{...x,enabled:en}:x));
                      }} />
                      {ec.desc || "Cargo adicional"}
                    </label>
                    {ec.enabled && (
                      <div style={{display:"flex",gap:6,marginTop:5}}>
                        <input type="text" value={ec.desc} placeholder="Descripción" onChange={e=>{
                          const v = e.target.value;
                          setExtraCargos(prev=>prev.map((x,j)=>j===i?{...x,desc:v}:x));
                        }} style={{flex:2,border:"1.5px solid rgba(255,255,255,.1)",borderRadius:6,padding:"6px 8px",fontFamily:"var(--mf)",fontSize:11.5,outline:"none"}} />
                        <div style={{flex:1,display:"flex",alignItems:"center",gap:4,minWidth:0}}>
                          <span style={{fontSize:11,color:"#999",flexShrink:0}}>{pedidoActual.moneda}</span>
                          <input type="number" inputMode="decimal" min="0" step="0.01" value={ec.monto} placeholder="Monto" onChange={e=>{
                            const v = e.target.value;
                            setExtraCargos(prev=>prev.map((x,j)=>j===i?{...x,monto:v}:x));
                          }} style={{flex:1,minWidth:0,border:"1.5px solid rgba(255,255,255,.1)",borderRadius:6,padding:"6px 8px",fontFamily:"var(--mf)",fontSize:11.5,outline:"none"}} />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                <div style={{fontSize:10,color:"#999",marginTop:6}}>Se suman al pedido con IVA 21%, en la misma moneda del total.</div>
              </div>
            )}

            <div style={{borderTop:"1px solid rgba(255,255,255,.08)",paddingTop:8,marginBottom:10,fontSize:11.5,color:"#c0c0c0"}}>
              {pedidoActual.descCodigoPct>0 && (
                <div style={{display:"flex",justifyContent:"space-between",padding:"1px 0",color:"#6fcf97",fontWeight:600}}><span>Código {pedidoActual.codigoDescuento} (-{pedidoActual.descCodigoPct}%)</span><span>{pedidoActual.moneda} {pedidoActual.montoDescCodigo.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span></div>
              )}
              <div style={{display:"flex",justifyContent:"space-between",padding:"1px 0"}}><span>Neto gravado</span><span>{pedidoActual.moneda} {pedidoActual.neto.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",padding:"1px 0"}}><span>IVA</span><span>{pedidoActual.moneda} {pedidoActual.ivaTotal.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",padding:"4px 0 0",fontSize:15,fontWeight:800,color:"#6fcf97"}}><span>Total</span><span>{pedidoActual.moneda} {pedidoActual.total.toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}</span></div>
            </div>
            {pesoRefTxt(pedidoActual.total,pedidoActual.moneda) && (
              <div style={{fontSize:10.5,color:"#999",marginTop:-6,marginBottom:10,textAlign:"right"}}>
                {pesoRefTxt(pedidoActual.total,pedidoActual.moneda)}
              </div>
            )}

            {!editingOrder && puedePresupuesto && (
              <div style={{display:"flex",gap:6,marginBottom:10}}>
                {["pedido","presupuesto"].map(t=>(
                  <button key={t} onClick={()=>setTipo(t)}
                    style={{flex:1,padding:"7px",borderRadius:7,fontSize:12,fontWeight:700,textTransform:"capitalize",cursor:"pointer",
                      border:tipo===t?"1.5px solid #116735":"1.5px solid rgba(255,255,255,.15)",
                      background:tipo===t?"rgba(111,207,151,.15)":"#232323",color:tipo===t?"#6fcf97":"#777"}}>
                    {t}
                  </button>
                ))}
              </div>
            )}
            <button onClick={editingOrder?guardarEdicionPedido:confirmarPedido} disabled={confirmando} style={{width:"100%",background:"#116735",color:"#fff",border:"none",borderRadius:8,padding:"12px",fontFamily:"var(--mf)",fontSize:13.5,fontWeight:700,cursor:confirmando?"default":"pointer",letterSpacing:.2,opacity:confirmando?.7:1}}>
              {confirmando ? "Guardando…" : editingOrder ? "Guardar cambios" : tipo==="presupuesto" ? "Guardar presupuesto" : "Confirmar pedido"}
            </button>
            <div style={{fontSize:10.5,color:"#999",textAlign:"center",margin:"5px 0 12px"}}>
              {editingOrder ? "Se guarda como una revisión del pedido y se avisa a ventas por mail" : tipo==="presupuesto" ? "Queda guardado en \"Mis pedidos\" — no se avisa a ventas todavía" : "Queda guardado en \"Mis pedidos\" y se avisa a ventas por mail"}
            </div>
          <div style={{fontSize:10,fontWeight:700,color:"#999",textTransform:"uppercase",letterSpacing:.6,marginBottom:6}}>Compartir</div>
          <div className="shareRow">
            <button className="shareBtn wa" onClick={sendWA}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
              WhatsApp
            </button>
            <button className="shareBtn" onClick={sendMail}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3 7 12 13 21 7"/></svg>
              Email
            </button>
            <button className="shareBtn" onClick={copyOrder}>
              {copied
                ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
                : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>}
              {copied?"Copiado":"Copiar"}
            </button>
            <button className="shareBtn no-print" onClick={printCart}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
              PDF
            </button>
          </div>
          </div>
          );
        })()}
      </div>

      {modal&&<div className="ov" onClick={()=>setModal(null)}>
        <div className="mb" onClick={e=>e.stopPropagation()} style={{maxWidth:560}}>
          {/* Gallery */}
          <div className="gal-main">
            {galPhoto
              ? <img src={galPhoto} alt="" onError={e=>{e.target.src=NO_IMG;}}/>
              : <img src={NO_IMG} alt="" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
            }
          </div>
          {/* Thumbnails */}
          {[modal.img,modal.img2,modal.img3,modal.img4].filter(Boolean).length > 1 && (
            <div className="gal-thumbs" style={{padding:"8px 14px"}}>
              {[modal.img,modal.img2,modal.img3,modal.img4].filter(Boolean).map((url,i)=>(
                <div key={i} className={`gal-thumb ${galPhoto===url?"on":""}`} onClick={()=>setGalPhoto(url)}>
                  <img src={url} alt="" onError={e=>e.target.style.display="none"}/>
                </div>
              ))}
            </div>
          )}
          <div className="mbdy">
            <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:"1.1px",color:"#0d4f27",marginBottom:4}}>{modal.cat}</div>
            <div style={{fontFamily:"var(--bf)",fontSize:24,fontWeight:800,color:"#1a1a1a",lineHeight:1.1,marginBottom:2}}>{modal.nom||modal.desc}</div>
            <div style={{fontSize:11,color:"#6b7280",marginBottom:8}}>Código: {modal.cod}{modal.marca&&` · Marca: ${modal.marca}`}</div>
            {(() => {
              const b = promoBadgeFor(modal);
              if(!b) return null;
              if(b.type==="benef"){
                const pr = promosVitrina.find(p=>promoAplicaALista(p) && (p.beneficio_cod===modal.cod || (p.beneficio_cat && p.beneficio_cat===modal.cat)));
                const req = pr && Array.isArray(pr.requisitos) && pr.requisitos[0];
                const reqProd = req && !req.cat && prods.find(p=>p.cod===req.cod);
                const reqTxt = req ? (req.cat ? `${req.cant}x productos de "${req.cat}"` : `${req.cant}x ${reqProd?.nom||req.cod}`) : "el producto de la promo";
                return (
                  <div style={{background:"rgba(17,103,53,.08)",border:"1.5px solid #6FCF97",borderRadius:8,padding:"9px 12px",marginBottom:12,fontSize:12,color:"#0d4f27"}}>
                    <b>{b.pct>=100?"¡Gratis!":`${b.pct}% off`}</b> comprando {reqTxt} — {pr?.nombre}.
                  </div>
                );
              }
              const pr = promosVitrina.find(p=>promoAplicaALista(p) && Array.isArray(p.requisitos) && p.requisitos.some(r=>r.cod===modal.cod || (r.cat && r.cat===modal.cat)));
              const benefProd = pr && !pr.beneficio_cat && prods.find(p=>p.cod===pr.beneficio_cod);
              const benefTxt = pr?.beneficio_cat ? `productos de "${pr.beneficio_cat}"` : (benefProd?.nom||pr?.beneficio_cod);
              return (
                <div style={{background:"rgba(245,158,11,.12)",border:"1.5px solid rgba(245,158,11,.35)",borderRadius:8,padding:"9px 12px",marginBottom:12,fontSize:12,color:"#92400e"}}>
                  Comprando este producto te bonifican <b>{benefTxt}</b> — {pr?.nombre}.
                </div>
              );
            })()}
            {modal.desc&&<div style={{fontSize:13,color:"#374151",lineHeight:1.6,marginBottom:14}}>{modal.desc}</div>}
            {sess ? (<>
              <div style={{display:"flex",alignItems:"baseline",gap:9,marginBottom:14}}>
                <div style={{fontFamily:"var(--bf)",fontSize:34,fontWeight:800,color:"#1a1a1a"}}>
                  <span style={{fontSize:13,fontWeight:700,color:"#6b7280"}}>{modal.mon||"USD"} </span>{gp(modal)}
                </div>
                {modal.iva&&modal.iva.includes("%")&&<span style={{fontSize:11,color:"#0d4f27",background:"rgba(17,103,53,.12)",padding:"3px 8px",borderRadius:4,fontWeight:600}}>+ IVA {modal.iva}</span>}
              </div>
              {ytId(modal.video)&&(
                <div className="yt-wrap">
                  <iframe src={`https://www.youtube.com/embed/${ytId(modal.video)}`} allowFullScreen title="video"/>
                </div>
              )}
              <div style={{display:"flex",gap:8,marginTop:16}}>
                <button style={{flex:1,background:"#116735",color:"#fff",border:"none",borderRadius:8,padding:11,fontFamily:"var(--mf)",fontSize:13,fontWeight:700,cursor:"pointer"}} onClick={()=>{add(modal);setModal(null);setCartOp(true);}}>+ Agregar a mi pedido</button>
                <button style={{background:"rgba(17,103,53,.12)",color:"#0d4f27",border:"none",borderRadius:8,padding:"11px 14px",fontFamily:"var(--mf)",fontSize:12.5,fontWeight:600,cursor:"pointer"}} onClick={()=>setModal(null)}>Cerrar</button>
              </div>
            </>) : (<>
              {ytId(modal.video)&&(
                <div className="yt-wrap">
                  <iframe src={`https://www.youtube.com/embed/${ytId(modal.video)}`} allowFullScreen title="video"/>
                </div>
              )}
              <button onClick={()=>{setModal(null);setSc("login");}} style={{width:"100%",background:"#116735",color:"#fff",border:"none",borderRadius:8,padding:12,fontFamily:"var(--mf)",fontSize:13,fontWeight:700,cursor:"pointer",marginTop:16}}>
                Registrate para ver el precio y agregar al pedido
              </button>
            </>)}
          </div>
        </div>
      </div>}
    </>
  );
}
